//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class WebPortalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAccessRequests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAccessRequest> {
        let url_ = this.baseUrl + "/api/v3/accessrequests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessRequests(_response);
        });
    }

    protected processGetAccessRequests(response: Response): Promise<QueryOfAccessRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAccessRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAccessRequest>(null as any);
    }

    postAccessRequest(body: AccessRequestCreation): Promise<AccessRequest> {
        let url_ = this.baseUrl + "/api/v3/accessrequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAccessRequest(_response);
        });
    }

    protected processPostAccessRequest(response: Response): Promise<AccessRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRequest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRequest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getAccessRequest(key: string, select?: string | undefined, expand?: string | undefined): Promise<AccessRequest> {
        let url_ = this.baseUrl + "/api/v3/accessrequests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessRequest(_response);
        });
    }

    protected processGetAccessRequest(response: Response): Promise<AccessRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRequest>(null as any);
    }

    deleteAccessRequest(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/accessrequests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAccessRequest(_response);
        });
    }

    protected processDeleteAccessRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAlertNotifications(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlertNotifications(_response);
        });
    }

    protected processGetAlertNotifications(response: Response): Promise<QueryOfAlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAlertNotification;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAlertNotification>(null as any);
    }

    postAlertNotification(body: AlertNotificationCreation): Promise<AlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAlertNotification(_response);
        });
    }

    protected processPostAlertNotification(response: Response): Promise<AlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertNotification;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertNotification>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getAlertNotification(key: string, select?: string | undefined, expand?: string | undefined): Promise<AlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlertNotification(_response);
        });
    }

    protected processGetAlertNotification(response: Response): Promise<AlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertNotification;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertNotification>(null as any);
    }

    patchAlertNotification(body: AlertNotificationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<AlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchAlertNotification(_response);
        });
    }

    protected processPatchAlertNotification(response: Response): Promise<AlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertNotification;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertNotification>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAlerts(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAlert> {
        let url_ = this.baseUrl + "/api/v3/alerts?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlerts(_response);
        });
    }

    protected processGetAlerts(response: Response): Promise<QueryOfAlert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAlert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAlert>(null as any);
    }

    postAlert(body: AlertCreation): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/alerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAlert(_response);
        });
    }

    protected processPostAlert(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getAlert(key: string, select?: string | undefined, expand?: string | undefined): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/alerts/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlert(_response);
        });
    }

    protected processGetAlert(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    patchAlert(body: AlertMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/alerts/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchAlert(_response);
        });
    }

    protected processPatchAlert(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/analysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalysisSetTypes(_response);
        });
    }

    protected processGetAnalysisSetTypes(response: Response): Promise<QueryOfAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAnalysisSetType>(null as any);
    }

    annotatedEcg(body: AnnotatedEcgRequest): Promise<AnnotatedEcgWrapper> {
        let url_ = this.baseUrl + "/api/v3/annotatedecg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnnotatedEcg(_response);
        });
    }

    protected processAnnotatedEcg(response: Response): Promise<AnnotatedEcgWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnotatedEcgWrapper;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnotatedEcgWrapper>(null as any);
    }

    postAuditTrailEvent(body: AuditTrailEvent): Promise<AuditTrailEvent> {
        let url_ = this.baseUrl + "/api/v3/audittrailevent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAuditTrailEvent(_response);
        });
    }

    protected processPostAuditTrailEvent(response: Response): Promise<AuditTrailEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditTrailEvent;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditTrailEvent>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseSampleMethods(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseSampleMethod> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesamplemethods?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSampleMethods(_response);
        });
    }

    protected processGetBloodGlucoseSampleMethods(response: Response): Promise<QueryOfBloodGlucoseSampleMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseSampleMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseSampleMethod>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSessions(_response);
        });
    }

    protected processGetBloodGlucoseSessions(response: Response): Promise<QueryOfBloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseSession>(null as any);
    }

    postBloodGlucoseSession(body: BloodGlucoseSessionCreation): Promise<BloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodGlucoseSession(_response);
        });
    }

    protected processPostBloodGlucoseSession(response: Response): Promise<BloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodGlucoseSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSession(_response);
        });
    }

    protected processGetBloodGlucoseSession(response: Response): Promise<BloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseSession>(null as any);
    }

    patchBloodGlucoseSession(body: BloodGlucoseSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodGlucoseSession(_response);
        });
    }

    protected processPatchBloodGlucoseSession(response: Response): Promise<BloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseTests(_response);
        });
    }

    protected processGetBloodGlucoseTests(response: Response): Promise<QueryOfBloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseTest>(null as any);
    }

    postBloodGlucoseTest(body: BloodGlucoseTestCreation): Promise<BloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodGlucoseTest(_response);
        });
    }

    protected processPostBloodGlucoseTest(response: Response): Promise<BloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodGlucoseTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseTest(_response);
        });
    }

    protected processGetBloodGlucoseTest(response: Response): Promise<BloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTest>(null as any);
    }

    patchBloodGlucoseTest(body: BloodGlucoseTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodGlucoseTest(_response);
        });
    }

    protected processPatchBloodGlucoseTest(response: Response): Promise<BloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodPressureSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureSessions(_response);
        });
    }

    protected processGetBloodPressureSessions(response: Response): Promise<QueryOfBloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodPressureSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodPressureSession>(null as any);
    }

    postBloodPressureSession(body: BloodPressureSessionCreation): Promise<BloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodPressureSession(_response);
        });
    }

    protected processPostBloodPressureSession(response: Response): Promise<BloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodPressureSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureSession(_response);
        });
    }

    protected processGetBloodPressureSession(response: Response): Promise<BloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureSession>(null as any);
    }

    patchBloodPressureSession(body: BloodPressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodPressureSession(_response);
        });
    }

    protected processPatchBloodPressureSession(response: Response): Promise<BloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodPressureTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureTests(_response);
        });
    }

    protected processGetBloodPressureTests(response: Response): Promise<QueryOfBloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodPressureTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodPressureTest>(null as any);
    }

    postBloodPressureTest(body: BloodPressureTestCreation): Promise<BloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodPressureTest(_response);
        });
    }

    protected processPostBloodPressureTest(response: Response): Promise<BloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodPressureTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureTest(_response);
        });
    }

    protected processGetBloodPressureTest(response: Response): Promise<BloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureTest>(null as any);
    }

    patchBloodPressureTest(body: BloodPressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodPressureTest(_response);
        });
    }

    protected processPatchBloodPressureTest(response: Response): Promise<BloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBorgScales(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBorgScales(_response);
        });
    }

    protected processGetBorgScales(response: Response): Promise<QueryOfBorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBorgScale;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBorgScale>(null as any);
    }

    postBorgScale(body: BorgScaleCreation): Promise<BorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBorgScale(_response);
        });
    }

    protected processPostBorgScale(response: Response): Promise<BorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BorgScale;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BorgScale>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBorgScale(key: string, select?: string | undefined, expand?: string | undefined): Promise<BorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBorgScale(_response);
        });
    }

    protected processGetBorgScale(response: Response): Promise<BorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BorgScale;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BorgScale>(null as any);
    }

    patchBorgScale(body: BorgScaleMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBorgScale(_response);
        });
    }

    protected processPatchBorgScale(response: Response): Promise<BorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BorgScale;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BorgScale>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCalibrations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalibrations(_response);
        });
    }

    protected processGetCalibrations(response: Response): Promise<QueryOfCalibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalibration>(null as any);
    }

    postCalibration(body: CalibrationCreation): Promise<Calibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCalibration(_response);
        });
    }

    protected processPostCalibration(response: Response): Promise<Calibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Calibration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Calibration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCalibration(key: string, select?: string | undefined, expand?: string | undefined): Promise<Calibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalibration(_response);
        });
    }

    protected processGetCalibration(response: Response): Promise<Calibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Calibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Calibration>(null as any);
    }

    patchCalibration(body: CalibrationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Calibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCalibration(_response);
        });
    }

    protected processPatchCalibration(response: Response): Promise<Calibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Calibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Calibration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getChallengeSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChallengeSessions(_response);
        });
    }

    protected processGetChallengeSessions(response: Response): Promise<QueryOfChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfChallengeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfChallengeSession>(null as any);
    }

    postChallengeSession(body: ChallengeSessionCreation): Promise<ChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostChallengeSession(_response);
        });
    }

    protected processPostChallengeSession(response: Response): Promise<ChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChallengeSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getChallengeSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<ChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChallengeSession(_response);
        });
    }

    protected processGetChallengeSession(response: Response): Promise<ChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChallengeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeSession>(null as any);
    }

    patchChallengeSession(body: ChallengeSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<ChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchChallengeSession(_response);
        });
    }

    protected processPatchChallengeSession(response: Response): Promise<ChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChallengeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getConfigurableDataItems(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfConfigurableDataItem> {
        let url_ = this.baseUrl + "/api/v3/configurabledataitems?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfigurableDataItems(_response);
        });
    }

    protected processGetConfigurableDataItems(response: Response): Promise<QueryOfConfigurableDataItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfConfigurableDataItem;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfConfigurableDataItem>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSetComments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSetComment> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetComments(_response);
        });
    }

    protected processGetCoughAnalysisSetComments(response: Response): Promise<QueryOfCoughAnalysisSetComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSetComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSetComment>(null as any);
    }

    postCoughAnalysisSetComment(body: CoughAnalysisSetCommentCreation): Promise<CoughAnalysisSetComment> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughAnalysisSetComment(_response);
        });
    }

    protected processPostCoughAnalysisSetComment(response: Response): Promise<CoughAnalysisSetComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetComment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetComment>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughAnalysisSetComment(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSetComment> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetComment(_response);
        });
    }

    protected processGetCoughAnalysisSetComment(response: Response): Promise<CoughAnalysisSetComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetComment>(null as any);
    }

    deleteCoughAnalysisSetComment(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCoughAnalysisSetComment(_response);
        });
    }

    protected processDeleteCoughAnalysisSetComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSetEvents(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetEvents(_response);
        });
    }

    protected processGetCoughAnalysisSetEvents(response: Response): Promise<QueryOfCoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSetEvent;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSetEvent>(null as any);
    }

    postCoughAnalysisSetEvent(body: CoughAnalysisSetEventCreation): Promise<CoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughAnalysisSetEvent(_response);
        });
    }

    protected processPostCoughAnalysisSetEvent(response: Response): Promise<CoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetEvent;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetEvent>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughAnalysisSetEvent(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetEvent(_response);
        });
    }

    protected processGetCoughAnalysisSetEvent(response: Response): Promise<CoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetEvent;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetEvent>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSets(_response);
        });
    }

    protected processGetCoughAnalysisSets(response: Response): Promise<QueryOfCoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSet>(null as any);
    }

    postCoughAnalysisSet(body: CoughAnalysisSet): Promise<CoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughAnalysisSet(_response);
        });
    }

    protected processPostCoughAnalysisSet(response: Response): Promise<CoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSet(_response);
        });
    }

    protected processGetCoughAnalysisSet(response: Response): Promise<CoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughEventTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/cougheventtypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughEventTypes(_response);
        });
    }

    protected processGetCoughEventTypes(response: Response): Promise<QueryOfCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughEventType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughSessions(_response);
        });
    }

    protected processGetCoughSessions(response: Response): Promise<QueryOfCoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughSession>(null as any);
    }

    postCoughSession(body: CoughSessionCreation): Promise<CoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughSession(_response);
        });
    }

    protected processPostCoughSession(response: Response): Promise<CoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughSession(_response);
        });
    }

    protected processGetCoughSession(response: Response): Promise<CoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughSession>(null as any);
    }

    patchCoughSession(body: CoughSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<CoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCoughSession(_response);
        });
    }

    protected processPatchCoughSession(response: Response): Promise<CoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughSessionStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughSessionStatus> {
        let url_ = this.baseUrl + "/api/v3/coughsessionstatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughSessionStatuses(_response);
        });
    }

    protected processGetCoughSessionStatuses(response: Response): Promise<QueryOfCoughSessionStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughSessionStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughSessionStatus>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughWaveformTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughWaveformType> {
        let url_ = this.baseUrl + "/api/v3/coughwaveformtypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughWaveformTypes(_response);
        });
    }

    protected processGetCoughWaveformTypes(response: Response): Promise<QueryOfCoughWaveformType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughWaveformType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughWaveformType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCountries(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCountry> {
        let url_ = this.baseUrl + "/api/v3/countries?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<QueryOfCountry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCountry;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCountry>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCustomCalculations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomCalculations(_response);
        });
    }

    protected processGetCustomCalculations(response: Response): Promise<QueryOfCustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCustomCalculation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCustomCalculation>(null as any);
    }

    postCustomCalculation(body: CustomCalculationCreation): Promise<CustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCustomCalculation(_response);
        });
    }

    protected processPostCustomCalculation(response: Response): Promise<CustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomCalculation;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomCalculation>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCustomCalculation(key: string, select?: string | undefined, expand?: string | undefined): Promise<CustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomCalculation(_response);
        });
    }

    protected processGetCustomCalculation(response: Response): Promise<CustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomCalculation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomCalculation>(null as any);
    }

    patchCustomCalculation(body: CustomCalculationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<CustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCustomCalculation(_response);
        });
    }

    protected processPatchCustomCalculation(response: Response): Promise<CustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomCalculation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomCalculation>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDataItemConfigurations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDataItemConfigurations(_response);
        });
    }

    protected processGetDataItemConfigurations(response: Response): Promise<QueryOfDataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDataItemConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDataItemConfiguration>(null as any);
    }

    postDataItemConfiguration(body: DataItemConfigurationCreation): Promise<DataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDataItemConfiguration(_response);
        });
    }

    protected processPostDataItemConfiguration(response: Response): Promise<DataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataItemConfiguration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataItemConfiguration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDataItemConfiguration(key: string, select?: string | undefined, expand?: string | undefined): Promise<DataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDataItemConfiguration(_response);
        });
    }

    protected processGetDataItemConfiguration(response: Response): Promise<DataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataItemConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataItemConfiguration>(null as any);
    }

    patchDataItemConfiguration(body: DataItemConfigurationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDataItemConfiguration(_response);
        });
    }

    protected processPatchDataItemConfiguration(response: Response): Promise<DataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataItemConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataItemConfiguration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDcfCorrectionTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDcfCorrectionType> {
        let url_ = this.baseUrl + "/api/v3/dcfcorrectiontypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfCorrectionTypes(_response);
        });
    }

    protected processGetDcfCorrectionTypes(response: Response): Promise<QueryOfDcfCorrectionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDcfCorrectionType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDcfCorrectionType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDcfRequests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfRequests(_response);
        });
    }

    protected processGetDcfRequests(response: Response): Promise<QueryOfDcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDcfRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDcfRequest>(null as any);
    }

    postDcfRequest(body: DcfRequestCreation): Promise<DcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDcfRequest(_response);
        });
    }

    protected processPostDcfRequest(response: Response): Promise<DcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DcfRequest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DcfRequest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDcfRequest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfRequest(_response);
        });
    }

    protected processGetDcfRequest(response: Response): Promise<DcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DcfRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DcfRequest>(null as any);
    }

    patchDcfRequest(body: DcfRequestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDcfRequest(_response);
        });
    }

    protected processPatchDcfRequest(response: Response): Promise<DcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DcfRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DcfRequest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDcfRequestStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDcfRequestStatus> {
        let url_ = this.baseUrl + "/api/v3/dcfrequeststatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfRequestStatuses(_response);
        });
    }

    protected processGetDcfRequestStatuses(response: Response): Promise<QueryOfDcfRequestStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDcfRequestStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDcfRequestStatus>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDefinedReports(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefinedReports(_response);
        });
    }

    protected processGetDefinedReports(response: Response): Promise<QueryOfDefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDefinedReport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDefinedReport>(null as any);
    }

    postDefinedReport(body: DefinedReportCreation): Promise<DefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDefinedReport(_response);
        });
    }

    protected processPostDefinedReport(response: Response): Promise<DefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinedReport;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefinedReport>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDefinedReport(key: string, select?: string | undefined, expand?: string | undefined): Promise<DefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefinedReport(_response);
        });
    }

    protected processGetDefinedReport(response: Response): Promise<DefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinedReport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefinedReport>(null as any);
    }

    patchDefinedReport(body: DefinedReportMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDefinedReport(_response);
        });
    }

    protected processPatchDefinedReport(response: Response): Promise<DefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinedReport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefinedReport>(null as any);
    }

    deleteDefinedReport(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/definedreports/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDefinedReport(_response);
        });
    }

    protected processDeleteDefinedReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDeviceAuditTrails(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDeviceAuditTrail> {
        let url_ = this.baseUrl + "/api/v3/deviceaudittrail?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeviceAuditTrails(_response);
        });
    }

    protected processGetDeviceAuditTrails(response: Response): Promise<QueryOfDeviceAuditTrail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDeviceAuditTrail;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDeviceAuditTrail>(null as any);
    }

    postDeviceAuditTrail(body: DeviceAuditTrailCreation): Promise<DeviceAuditTrail> {
        let url_ = this.baseUrl + "/api/v3/deviceaudittrail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDeviceAuditTrail(_response);
        });
    }

    protected processPostDeviceAuditTrail(response: Response): Promise<DeviceAuditTrail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceAuditTrail;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceAuditTrail>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDeviceAuditTrail(key: string, select?: string | undefined, expand?: string | undefined): Promise<DeviceAuditTrail> {
        let url_ = this.baseUrl + "/api/v3/deviceaudittrail/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeviceAuditTrail(_response);
        });
    }

    protected processGetDeviceAuditTrail(response: Response): Promise<DeviceAuditTrail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceAuditTrail;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceAuditTrail>(null as any);
    }

    deviceConfiguration(body: ConfigurationRequest): Promise<DeviceConfiguration> {
        let url_ = this.baseUrl + "/api/v3/deviceconfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeviceConfiguration(_response);
        });
    }

    protected processDeviceConfiguration(response: Response): Promise<DeviceConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceConfiguration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDevices(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDevice> {
        let url_ = this.baseUrl + "/api/v3/devices?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: Response): Promise<QueryOfDevice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDevice;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDevice>(null as any);
    }

    postDevice(body: DeviceCreation): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDevice(_response);
        });
    }

    protected processPostDevice(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDevice(key: string, select?: string | undefined, expand?: string | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/devices/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    patchDevice(body: DeviceMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/devices/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDevice(_response);
        });
    }

    protected processPatchDevice(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    deleteDevice(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/devices/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevice(_response);
        });
    }

    protected processDeleteDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDeviceTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDeviceType> {
        let url_ = this.baseUrl + "/api/v3/devicetypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeviceTypes(_response);
        });
    }

    protected processGetDeviceTypes(response: Response): Promise<QueryOfDeviceType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDeviceType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDeviceType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryCompliances(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryCompliances(_response);
        });
    }

    protected processGetDiaryCompliances(response: Response): Promise<QueryOfDiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryCompliance;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryCompliance>(null as any);
    }

    postDiaryCompliance(body: DiaryComplianceCreation): Promise<DiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryCompliance(_response);
        });
    }

    protected processPostDiaryCompliance(response: Response): Promise<DiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryCompliance;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryCompliance>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiaryCompliance(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryCompliance(_response);
        });
    }

    protected processGetDiaryCompliance(response: Response): Promise<DiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryCompliance;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryCompliance>(null as any);
    }

    patchDiaryCompliance(body: DiaryComplianceMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiaryCompliance(_response);
        });
    }

    protected processPatchDiaryCompliance(response: Response): Promise<DiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryCompliance;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryCompliance>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryConfigurationFiles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryConfigurationFile> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurationfiles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryConfigurationFiles(_response);
        });
    }

    protected processGetDiaryConfigurationFiles(response: Response): Promise<QueryOfDiaryConfigurationFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryConfigurationFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryConfigurationFile>(null as any);
    }

    postDiaryConfigurationFile(body: DiaryConfigurationFile): Promise<DiaryConfigurationFile> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurationfiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryConfigurationFile(_response);
        });
    }

    protected processPostDiaryConfigurationFile(response: Response): Promise<DiaryConfigurationFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryConfigurationFile;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryConfigurationFile>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryConfigurations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryConfiguration> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryConfigurations(_response);
        });
    }

    protected processGetDiaryConfigurations(response: Response): Promise<QueryOfDiaryConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryConfiguration>(null as any);
    }

    postDiaryConfiguration(body: DiaryConfigurationCreation): Promise<DiaryConfiguration> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryConfiguration(_response);
        });
    }

    protected processPostDiaryConfiguration(response: Response): Promise<DiaryConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryConfiguration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryConfiguration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryPackageDeployments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryPackageDeployment> {
        let url_ = this.baseUrl + "/api/v3/diarypackagedeployments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryPackageDeployments(_response);
        });
    }

    protected processGetDiaryPackageDeployments(response: Response): Promise<QueryOfDiaryPackageDeployment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryPackageDeployment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryPackageDeployment>(null as any);
    }

    postDiaryPackageDeployment(body: DiaryPackageDeploymentCreation): Promise<DiaryPackageDeployment> {
        let url_ = this.baseUrl + "/api/v3/diarypackagedeployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryPackageDeployment(_response);
        });
    }

    protected processPostDiaryPackageDeployment(response: Response): Promise<DiaryPackageDeployment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryPackageDeployment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryPackageDeployment>(null as any);
    }

    deleteDiaryPackageDeployment(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/diarypackagedeployments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDiaryPackageDeployment(_response);
        });
    }

    protected processDeleteDiaryPackageDeployment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryResourceStrings(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryResourceString> {
        let url_ = this.baseUrl + "/api/v3/diaryresourcestrings?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryResourceStrings(_response);
        });
    }

    protected processGetDiaryResourceStrings(response: Response): Promise<QueryOfDiaryResourceString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryResourceString;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryResourceString>(null as any);
    }

    postDiaryResourceString(body: DiaryResourceString): Promise<DiaryResourceString> {
        let url_ = this.baseUrl + "/api/v3/diaryresourcestrings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryResourceString(_response);
        });
    }

    protected processPostDiaryResourceString(response: Response): Promise<DiaryResourceString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryResourceString;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryResourceString>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiaryResourceString(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiaryResourceString> {
        let url_ = this.baseUrl + "/api/v3/diaryresourcestrings/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryResourceString(_response);
        });
    }

    protected processGetDiaryResourceString(response: Response): Promise<DiaryResourceString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryResourceString;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryResourceString>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiarySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiarySessions(_response);
        });
    }

    protected processGetDiarySessions(response: Response): Promise<QueryOfDiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiarySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiarySession>(null as any);
    }

    postDiarySession(body: DiarySessionCreation): Promise<DiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiarySession(_response);
        });
    }

    protected processPostDiarySession(response: Response): Promise<DiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiarySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiarySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiarySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiarySession(_response);
        });
    }

    protected processGetDiarySession(response: Response): Promise<DiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiarySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiarySession>(null as any);
    }

    patchDiarySession(body: DiarySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiarySession(_response);
        });
    }

    protected processPatchDiarySession(response: Response): Promise<DiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiarySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiarySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryTests(_response);
        });
    }

    protected processGetDiaryTests(response: Response): Promise<QueryOfDiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryTest>(null as any);
    }

    postDiaryTest(body: DiaryTestCreation): Promise<DiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryTest(_response);
        });
    }

    protected processPostDiaryTest(response: Response): Promise<DiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiaryTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryTest(_response);
        });
    }

    protected processGetDiaryTest(response: Response): Promise<DiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryTest>(null as any);
    }

    patchDiaryTest(body: DiaryTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiaryTest(_response);
        });
    }

    protected processPatchDiaryTest(response: Response): Promise<DiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDirectoryFiles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFileViewModel> {
        let url_ = this.baseUrl + "/api/v3/directoryfiles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDirectoryFiles(_response);
        });
    }

    protected processGetDirectoryFiles(response: Response): Promise<QueryOfFileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFileViewModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFileViewModel>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoAnalysisSets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSets(_response);
        });
    }

    protected processGetDlcoAnalysisSets(response: Response): Promise<QueryOfDlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoAnalysisSets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSet(_response);
        });
    }

    protected processGetDlcoAnalysisSet(response: Response): Promise<DlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSet>(null as any);
    }

    postDlcoAnalysisSet(body: DlcoAnalysisSetCreation): Promise<DlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoAnalysisSet(_response);
        });
    }

    protected processPostDlcoAnalysisSet(response: Response): Promise<DlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSet>(null as any);
    }

    patchDlcoAnalysisSet(body: DlcoAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoAnalysisSet(_response);
        });
    }

    protected processPatchDlcoAnalysisSet(response: Response): Promise<DlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSetTests(_response);
        });
    }

    protected processGetDlcoAnalysisSetTests(response: Response): Promise<QueryOfDlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoAnalysisSetTest>(null as any);
    }

    postDlcoAnalysisSetTest(body: DlcoAnalysisSetTest): Promise<DlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoAnalysisSetTest(_response);
        });
    }

    protected processPostDlcoAnalysisSetTest(response: Response): Promise<DlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSetTest(_response);
        });
    }

    protected processGetDlcoAnalysisSetTest(response: Response): Promise<DlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSetTest>(null as any);
    }

    patchDlcoAnalysisSetTest(body: DlcoAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoAnalysisSetTest(_response);
        });
    }

    protected processPatchDlcoAnalysisSetTest(response: Response): Promise<DlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    dlcoCalculationMethod(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalculationMethod> {
        let url_ = this.baseUrl + "/api/v3/dlcocalculationmethod?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDlcoCalculationMethod(_response);
        });
    }

    protected processDlcoCalculationMethod(response: Response): Promise<QueryOfCalculationMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalculationMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalculationMethod>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    kcoCalculationMethod(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalculationMethod> {
        let url_ = this.baseUrl + "/api/v3/kcocalculationmethod?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKcoCalculationMethod(_response);
        });
    }

    protected processKcoCalculationMethod(response: Response): Promise<QueryOfCalculationMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalculationMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalculationMethod>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    vaCalculationMethod(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalculationMethod> {
        let url_ = this.baseUrl + "/api/v3/vacalculationmethod?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVaCalculationMethod(_response);
        });
    }

    protected processVaCalculationMethod(response: Response): Promise<QueryOfCalculationMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalculationMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalculationMethod>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoSessions(_response);
        });
    }

    protected processGetDlcoSessions(response: Response): Promise<QueryOfDlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoSession>(null as any);
    }

    postDlcoSession(body: DlcoSessionCreation): Promise<DlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoSession(_response);
        });
    }

    protected processPostDlcoSession(response: Response): Promise<DlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoSession(_response);
        });
    }

    protected processGetDlcoSession(response: Response): Promise<DlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoSession>(null as any);
    }

    patchDlcoSession(body: DlcoSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoSession(_response);
        });
    }

    protected processPatchDlcoSession(response: Response): Promise<DlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoTests(_response);
        });
    }

    protected processGetDlcoTests(response: Response): Promise<QueryOfDlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoTest>(null as any);
    }

    postDlcoTests(body: DlcoTestCreation): Promise<DlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoTests(_response);
        });
    }

    protected processPostDlcoTests(response: Response): Promise<DlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoTest(_response);
        });
    }

    protected processGetDlcoTest(response: Response): Promise<DlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoTest>(null as any);
    }

    patchDlcoTests(body: DlcoTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoTests(_response);
        });
    }

    protected processPatchDlcoTests(response: Response): Promise<DlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSets(_response);
        });
    }

    protected processGetEcgAnalysisSets(response: Response): Promise<QueryOfEcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgAnalysisSet>(null as any);
    }

    postEcgAnalysisSet(body: EcgAnalysisSetCreation): Promise<EcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgAnalysisSet(_response);
        });
    }

    protected processPostEcgAnalysisSet(response: Response): Promise<EcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSet(_response);
        });
    }

    protected processGetEcgAnalysisSet(response: Response): Promise<EcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSet>(null as any);
    }

    patchEcgAnalysisSet(body: EcgAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgAnalysisSet(_response);
        });
    }

    protected processPatchEcgAnalysisSet(response: Response): Promise<EcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSetTests(_response);
        });
    }

    protected processGetEcgAnalysisSetTests(response: Response): Promise<QueryOfEcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgAnalysisSetTest>(null as any);
    }

    postEcgAnalysisSetTest(body: EcgAnalysisSetTest): Promise<EcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgAnalysisSetTest(_response);
        });
    }

    protected processPostEcgAnalysisSetTest(response: Response): Promise<EcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSetTest(_response);
        });
    }

    protected processGetEcgAnalysisSetTest(response: Response): Promise<EcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSetTest>(null as any);
    }

    patchEcgAnalysisSetTest(body: EcgAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgAnalysisSetTest(_response);
        });
    }

    protected processPatchEcgAnalysisSetTest(response: Response): Promise<EcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSetTypes(_response);
        });
    }

    protected processGetEcgAnalysisSetTypes(response: Response): Promise<QueryOfEcgAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgAnalysisSetType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgSessions(_response);
        });
    }

    protected processGetEcgSessions(response: Response): Promise<QueryOfEcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgSession>(null as any);
    }

    postEcgSession(body: EcgSessionCreation): Promise<EcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgSession(_response);
        });
    }

    protected processPostEcgSession(response: Response): Promise<EcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgSession(_response);
        });
    }

    protected processGetEcgSession(response: Response): Promise<EcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgSession>(null as any);
    }

    patchEcgSession(body: EcgSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgSession(_response);
        });
    }

    protected processPatchEcgSession(response: Response): Promise<EcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgTests(_response);
        });
    }

    protected processGetEcgTests(response: Response): Promise<QueryOfEcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgTest>(null as any);
    }

    postEcgTest(body: EcgTestCreation): Promise<EcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgTest(_response);
        });
    }

    protected processPostEcgTest(response: Response): Promise<EcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgTest(_response);
        });
    }

    protected processGetEcgTest(response: Response): Promise<EcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgTest>(null as any);
    }

    patchEcgTest(body: EcgTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgTest(_response);
        });
    }

    protected processPatchEcgTest(response: Response): Promise<EcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFenoQCs(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoQCs(_response);
        });
    }

    protected processGetFenoQCs(response: Response): Promise<QueryOfFenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFenoQC;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFenoQC>(null as any);
    }

    postFenoQC(body: FenoQCCreation): Promise<FenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFenoQC(_response);
        });
    }

    protected processPostFenoQC(response: Response): Promise<FenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoQC;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoQC>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFenoQC(key: string, select?: string | undefined, expand?: string | undefined): Promise<FenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoQC(_response);
        });
    }

    protected processGetFenoQC(response: Response): Promise<FenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoQC;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoQC>(null as any);
    }

    patchFenoQC(body: FenoQCMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFenoQC(_response);
        });
    }

    protected processPatchFenoQC(response: Response): Promise<FenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoQC;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoQC>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFenoSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoSessions(_response);
        });
    }

    protected processGetFenoSessions(response: Response): Promise<QueryOfFenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFenoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFenoSession>(null as any);
    }

    postFenoSession(body: FenoSessionCreation): Promise<FenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFenoSession(_response);
        });
    }

    protected processPostFenoSession(response: Response): Promise<FenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFenoSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<FenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoSession(_response);
        });
    }

    protected processGetFenoSession(response: Response): Promise<FenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoSession>(null as any);
    }

    patchFenoSession(body: FenoSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFenoSession(_response);
        });
    }

    protected processPatchFenoSession(response: Response): Promise<FenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoSession;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFenoTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoTests(_response);
        });
    }

    protected processGetFenoTests(response: Response): Promise<QueryOfFenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFenoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFenoTest>(null as any);
    }

    postFenoTest(body: FenoTestCreation): Promise<FenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFenoTest(_response);
        });
    }

    protected processPostFenoTest(response: Response): Promise<FenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFenoTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<FenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoTest(_response);
        });
    }

    protected processGetFenoTest(response: Response): Promise<FenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoTest>(null as any);
    }

    patchFenoTest(body: FenoTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFenoTest(_response);
        });
    }

    protected processPatchFenoTest(response: Response): Promise<FenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoTest;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFileAttachments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFileAttachment> {
        let url_ = this.baseUrl + "/api/v3/fileattachments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileAttachments(_response);
        });
    }

    protected processGetFileAttachments(response: Response): Promise<QueryOfFileAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFileAttachment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFileAttachment>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFiles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFile> {
        let url_ = this.baseUrl + "/api/v3/files?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFiles(_response);
        });
    }

    protected processGetFiles(response: Response): Promise<QueryOfFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFile>(null as any);
    }

    postFile(body: FileCreation): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFile(_response);
        });
    }

    protected processPostFile(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFile(key: string, select?: string | undefined, expand?: string | undefined): Promise<File> {
        let url_ = this.baseUrl + "/api/v3/files/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<File> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as File;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<File>(null as any);
    }

    deleteFile(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/files/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fileUpload(body: FileUpload): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v3/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFileUpload(_response);
        });
    }

    protected processFileUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFileUpload(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/FileUpload/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFileUpload(_response);
        });
    }

    protected processDeleteFileUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedComments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedComments(_response);
        });
    }

    protected processGetFixedComments(response: Response): Promise<QueryOfFixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedComment>(null as any);
    }

    postFixedComment(body: FixedCommentCreation): Promise<FixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFixedComment(_response);
        });
    }

    protected processPostFixedComment(response: Response): Promise<FixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedComment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedComment>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFixedComment(key: string, select?: string | undefined, expand?: string | undefined): Promise<FixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedComment(_response);
        });
    }

    protected processGetFixedComment(response: Response): Promise<FixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedComment>(null as any);
    }

    patchFixedComment(body: FixedCommentCreation, key: string, auditAnnotation?: string | null | undefined): Promise<FixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFixedComment(_response);
        });
    }

    protected processPatchFixedComment(response: Response): Promise<FixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedComment>(null as any);
    }

    deleteFixedComment(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFixedComment(_response);
        });
    }

    protected processDeleteFixedComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedCommentSetEntityTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedCommentSetEntityType> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsetentitytypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSetEntityTypes(_response);
        });
    }

    protected processGetFixedCommentSetEntityTypes(response: Response): Promise<QueryOfFixedCommentSetEntityType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedCommentSetEntityType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedCommentSetEntityType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedCommentSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSets(_response);
        });
    }

    protected processGetFixedCommentSets(response: Response): Promise<QueryOfFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedCommentSet>(null as any);
    }

    postFixedCommentSet(body: FixedCommentSet): Promise<FixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFixedCommentSet(_response);
        });
    }

    protected processPostFixedCommentSet(response: Response): Promise<FixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedCommentSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedCommentSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFixedCommentSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<FixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSet(_response);
        });
    }

    protected processGetFixedCommentSet(response: Response): Promise<FixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedCommentSet>(null as any);
    }

    patchFixedCommentSet(body: FixedCommentSet, key: string, auditAnnotation?: string | null | undefined): Promise<FixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFixedCommentSet(_response);
        });
    }

    protected processPatchFixedCommentSet(response: Response): Promise<FixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedCommentSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedCommentSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedCommentSetType> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSetTypes(_response);
        });
    }

    protected processGetFixedCommentSetTypes(response: Response): Promise<QueryOfFixedCommentSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedCommentSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedCommentSetType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFvcSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcSessions(_response);
        });
    }

    protected processGetFvcSessions(response: Response): Promise<QueryOfFvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcSession>(null as any);
    }

    postFvcSession(body: FvcSessionCreation): Promise<FvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFvcSession(_response);
        });
    }

    protected processPostFvcSession(response: Response): Promise<FvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFvcSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcSession(_response);
        });
    }

    protected processGetFvcSession(response: Response): Promise<FvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcSession>(null as any);
    }

    patchFvcSession(body: FvcSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFvcSession(_response);
        });
    }

    protected processPatchFvcSession(response: Response): Promise<FvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFvcTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcTests(_response);
        });
    }

    protected processGetFvcTests(response: Response): Promise<QueryOfFvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcTest>(null as any);
    }

    postFvcTest(body: FvcTestCreation): Promise<FvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFvcTest(_response);
        });
    }

    protected processPostFvcTest(response: Response): Promise<FvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFvcTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcTest(_response);
        });
    }

    protected processGetFvcTest(response: Response): Promise<FvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcTest>(null as any);
    }

    patchFvcTest(body: FvcTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFvcTest(_response);
        });
    }

    protected processPatchFvcTest(response: Response): Promise<FvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLanguages(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLanguage> {
        let url_ = this.baseUrl + "/api/v3/languages?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<QueryOfLanguage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLanguage;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLanguage>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSets(_response);
        });
    }

    protected processGetLungVolumeAnalysisSets(response: Response): Promise<QueryOfLungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeAnalysisSet>(null as any);
    }

    postLungVolumeAnalysisSet(body: LungVolumeAnalysisSetCreation): Promise<LungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeAnalysisSet(_response);
        });
    }

    protected processPostLungVolumeAnalysisSet(response: Response): Promise<LungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSet(_response);
        });
    }

    protected processGetLungVolumeAnalysisSet(response: Response): Promise<LungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSet>(null as any);
    }

    patchLungVolumeAnalysisSet(body: LungVolumeAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeAnalysisSet(_response);
        });
    }

    protected processPatchLungVolumeAnalysisSet(response: Response): Promise<LungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSetTests(_response);
        });
    }

    protected processGetLungVolumeAnalysisSetTests(response: Response): Promise<QueryOfLungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeAnalysisSetTest>(null as any);
    }

    postLungVolumeAnalysisSetTest(body: LungVolumeAnalysisSetTest): Promise<LungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeAnalysisSetTest(_response);
        });
    }

    protected processPostLungVolumeAnalysisSetTest(response: Response): Promise<LungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSetTest(_response);
        });
    }

    protected processGetLungVolumeAnalysisSetTest(response: Response): Promise<LungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSetTest>(null as any);
    }

    patchLungVolumeAnalysisSetTest(body: LungVolumeAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeAnalysisSetTest(_response);
        });
    }

    protected processPatchLungVolumeAnalysisSetTest(response: Response): Promise<LungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeSessions(_response);
        });
    }

    protected processGetLungVolumeSessions(response: Response): Promise<QueryOfLungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeSession>(null as any);
    }

    postLungVolumeSession(body: LungVolumeSessionCreation): Promise<LungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeSession(_response);
        });
    }

    protected processPostLungVolumeSession(response: Response): Promise<LungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeSession(_response);
        });
    }

    protected processGetLungVolumeSession(response: Response): Promise<LungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeSession>(null as any);
    }

    patchLungVolumeSession(body: LungVolumeSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeSession(_response);
        });
    }

    protected processPatchLungVolumeSession(response: Response): Promise<LungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeSession;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeTests(_response);
        });
    }

    protected processGetLungVolumeTests(response: Response): Promise<QueryOfLungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeTest>(null as any);
    }

    postLungVolumeTest(body: LungVolumeTestCreation): Promise<LungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeTest(_response);
        });
    }

    protected processPostLungVolumeTest(response: Response): Promise<LungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeTest(_response);
        });
    }

    protected processGetLungVolumeTest(response: Response): Promise<LungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeTest>(null as any);
    }

    patchLungVolumeTest(body: LungVolumeTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeTest(_response);
        });
    }

    protected processPatchLungVolumeTest(response: Response): Promise<LungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeTest;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMappedServerDirectories(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMappedServerDirectory> {
        let url_ = this.baseUrl + "/api/v3/mappedserverdirectories?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMappedServerDirectories(_response);
        });
    }

    protected processGetMappedServerDirectories(response: Response): Promise<QueryOfMappedServerDirectory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMappedServerDirectory;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMappedServerDirectory>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMappedServerDirectories2(key: string, select?: string | undefined, expand?: string | undefined): Promise<MappedServerDirectory> {
        let url_ = this.baseUrl + "/api/v3/mappedserverdirectories/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMappedServerDirectories2(_response);
        });
    }

    protected processGetMappedServerDirectories2(response: Response): Promise<MappedServerDirectory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MappedServerDirectory;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MappedServerDirectory>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMedicationRecords(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationRecords(_response);
        });
    }

    protected processGetMedicationRecords(response: Response): Promise<QueryOfMedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMedicationRecord;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMedicationRecord>(null as any);
    }

    postMedicationRecord(body: MedicationRecordCreation): Promise<MedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMedicationRecord(_response);
        });
    }

    protected processPostMedicationRecord(response: Response): Promise<MedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedicationRecord;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationRecord>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMedicationRecord(key: string, select?: string | undefined, expand?: string | undefined): Promise<MedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationRecord(_response);
        });
    }

    protected processGetMedicationRecord(response: Response): Promise<MedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedicationRecord;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationRecord>(null as any);
    }

    patchMedicationRecord(body: MedicationRecordMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMedicationRecord(_response);
        });
    }

    protected processPatchMedicationRecord(response: Response): Promise<MedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedicationRecord;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationRecord>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSets(_response);
        });
    }

    protected processGetMepAnalysisSets(response: Response): Promise<QueryOfMepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepAnalysisSet>(null as any);
    }

    postMepAnalysisSet(body: MepAnalysisSetCreation): Promise<MepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepAnalysisSet(_response);
        });
    }

    protected processPostMepAnalysisSet(response: Response): Promise<MepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSet(_response);
        });
    }

    protected processGetMepAnalysisSet(response: Response): Promise<MepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSet>(null as any);
    }

    patchMepAnalysisSet(body: MepAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepAnalysisSet(_response);
        });
    }

    protected processPatchMepAnalysisSet(response: Response): Promise<MepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSetTests(_response);
        });
    }

    protected processGetMepAnalysisSetTests(response: Response): Promise<QueryOfMepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepAnalysisSetTest>(null as any);
    }

    postMepAnalysisSetTest(body: MepAnalysisSetTestCreation): Promise<MepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepAnalysisSetTest(_response);
        });
    }

    protected processPostMepAnalysisSetTest(response: Response): Promise<MepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSetTest(_response);
        });
    }

    protected processGetMepAnalysisSetTest(response: Response): Promise<MepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSetTest>(null as any);
    }

    patchMepAnalysisSetTest(body: PressureAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepAnalysisSetTest(_response);
        });
    }

    protected processPatchMepAnalysisSetTest(response: Response): Promise<MepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepSessions(_response);
        });
    }

    protected processGetMepSessions(response: Response): Promise<QueryOfMepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepSession>(null as any);
    }

    postMepSession(body: MepSessionCreation): Promise<MepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepSession(_response);
        });
    }

    protected processPostMepSession(response: Response): Promise<MepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepSession(_response);
        });
    }

    protected processGetMepSession(response: Response): Promise<MepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepSession>(null as any);
    }

    patchMepSession(body: PressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepSession(_response);
        });
    }

    protected processPatchMepSession(response: Response): Promise<MepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepTests(_response);
        });
    }

    protected processGetMepTests(response: Response): Promise<QueryOfMepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepTest>(null as any);
    }

    postMepTest(body: MepTestCreation): Promise<MepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepTest(_response);
        });
    }

    protected processPostMepTest(response: Response): Promise<MepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepTest(_response);
        });
    }

    protected processGetMepTest(response: Response): Promise<MepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepTest>(null as any);
    }

    patchMepTest(body: PressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepTest(_response);
        });
    }

    protected processPatchMepTest(response: Response): Promise<MepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSets(_response);
        });
    }

    protected processGetMipAnalysisSets(response: Response): Promise<QueryOfMipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipAnalysisSet>(null as any);
    }

    postMipAnalysisSet(body: MipAnalysisSetCreation): Promise<MipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipAnalysisSet(_response);
        });
    }

    protected processPostMipAnalysisSet(response: Response): Promise<MipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSet(_response);
        });
    }

    protected processGetMipAnalysisSet(response: Response): Promise<MipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSet>(null as any);
    }

    patchMipAnalysisSet(body: MipAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipAnalysisSet(_response);
        });
    }

    protected processPatchMipAnalysisSet(response: Response): Promise<MipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSetTests(_response);
        });
    }

    protected processGetMipAnalysisSetTests(response: Response): Promise<QueryOfMipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipAnalysisSetTest>(null as any);
    }

    postMipAnalysisSetTest(body: MipAnalysisSetTestCreation): Promise<MipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipAnalysisSetTest(_response);
        });
    }

    protected processPostMipAnalysisSetTest(response: Response): Promise<MipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSetTest(_response);
        });
    }

    protected processGetMipAnalysisSetTest(response: Response): Promise<MipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSetTest>(null as any);
    }

    patchMipAnalysisSetTest(body: PressureAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipAnalysisSetTest(_response);
        });
    }

    protected processPatchMipAnalysisSetTest(response: Response): Promise<MipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipSessions(_response);
        });
    }

    protected processGetMipSessions(response: Response): Promise<QueryOfMipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipSession>(null as any);
    }

    postMipSession(body: MipSessionCreation): Promise<MipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipSession(_response);
        });
    }

    protected processPostMipSession(response: Response): Promise<MipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipSession(_response);
        });
    }

    protected processGetMipSession(response: Response): Promise<MipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipSession>(null as any);
    }

    patchMipSession(body: PressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipSession(_response);
        });
    }

    protected processPatchMipSession(response: Response): Promise<MipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipTests(_response);
        });
    }

    protected processGetMipTests(response: Response): Promise<QueryOfMipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipTest>(null as any);
    }

    postMipTest(body: MipTestCreation): Promise<MipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipTest(_response);
        });
    }

    protected processPostMipTest(response: Response): Promise<MipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipTest(_response);
        });
    }

    protected processGetMipTest(response: Response): Promise<MipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipTest>(null as any);
    }

    patchMipTest(body: PressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipTest(_response);
        });
    }

    protected processPatchMipTest(response: Response): Promise<MipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMiscellaneousFields(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMiscellaneousFields(_response);
        });
    }

    protected processGetMiscellaneousFields(response: Response): Promise<QueryOfMiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMiscField;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMiscField>(null as any);
    }

    postMiscellaneousField(body: MiscFieldCreation): Promise<MiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMiscellaneousField(_response);
        });
    }

    protected processPostMiscellaneousField(response: Response): Promise<MiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MiscField;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscField>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMiscellaneousField(key: string, select?: string | undefined, expand?: string | undefined): Promise<MiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMiscellaneousField(_response);
        });
    }

    protected processGetMiscellaneousField(response: Response): Promise<MiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MiscField;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscField>(null as any);
    }

    patchMiscellaneousField(body: MiscFieldMuation, key: string, auditAnnotation?: string | null | undefined): Promise<MiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMiscellaneousField(_response);
        });
    }

    protected processPatchMiscellaneousField(response: Response): Promise<MiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MiscField;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscField>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getNotificationSubscriptions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfNotificationSubscription> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationSubscriptions(_response);
        });
    }

    protected processGetNotificationSubscriptions(response: Response): Promise<QueryOfNotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfNotificationSubscription;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfNotificationSubscription>(null as any);
    }

    postNotificationSubscription(body: NotificationSubscriptionCreation): Promise<NotificationSubscription> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostNotificationSubscription(_response);
        });
    }

    protected processPostNotificationSubscription(response: Response): Promise<NotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationSubscription;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getNotificationSubscription(key: string, select?: string | undefined, expand?: string | undefined): Promise<NotificationSubscription> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationSubscription(_response);
        });
    }

    protected processGetNotificationSubscription(response: Response): Promise<NotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationSubscription;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription>(null as any);
    }

    patchNotificationSubscription(body: NotificationSubscriptionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchNotificationSubscription(_response);
        });
    }

    protected processPatchNotificationSubscription(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    deleteNotificationSubscription(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNotificationSubscription(_response);
        });
    }

    protected processDeleteNotificationSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometryAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSets(_response);
        });
    }

    protected processGetOscillometryAnalysisSets(response: Response): Promise<QueryOfOscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometryAnalysisSet>(null as any);
    }

    postOscillometryAnalysisSet(body: OscillometryAnalysisSetCreation): Promise<OscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometryAnalysisSet(_response);
        });
    }

    protected processPostOscillometryAnalysisSet(response: Response): Promise<OscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometryAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/Oscillometryanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSet(_response);
        });
    }

    protected processGetOscillometryAnalysisSet(response: Response): Promise<OscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSet>(null as any);
    }

    patchOscillometryAnalysisSet(body: OscillometryAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometryAnalysisSet(_response);
        });
    }

    protected processPatchOscillometryAnalysisSet(response: Response): Promise<OscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometryAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSetTests(_response);
        });
    }

    protected processGetOscillometryAnalysisSetTests(response: Response): Promise<QueryOfOscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometryAnalysisSetTest>(null as any);
    }

    postOscillometryAnalysisSetTest(body: OscillometryAnalysisSetTestCreation): Promise<OscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometryAnalysisSetTest(_response);
        });
    }

    protected processPostOscillometryAnalysisSetTest(response: Response): Promise<OscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometryAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSetTest(_response);
        });
    }

    protected processGetOscillometryAnalysisSetTest(response: Response): Promise<OscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSetTest>(null as any);
    }

    patchOscillometryAnalysisSetTest(body: OscillometryAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometryAnalysisSetTest(_response);
        });
    }

    protected processPatchOscillometryAnalysisSetTest(response: Response): Promise<OscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometrySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometrySessions(_response);
        });
    }

    protected processGetOscillometrySessions(response: Response): Promise<QueryOfOscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometrySession>(null as any);
    }

    postOscillometrySession(body: OscillometrySessionCreation): Promise<OscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometrySession(_response);
        });
    }

    protected processPostOscillometrySession(response: Response): Promise<OscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometrySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometrySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometrySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometrySession(_response);
        });
    }

    protected processGetOscillometrySession(response: Response): Promise<OscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometrySession>(null as any);
    }

    patchOscillometrySession(body: OscillometrySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometrySession(_response);
        });
    }

    protected processPatchOscillometrySession(response: Response): Promise<OscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometrySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometryTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryTests(_response);
        });
    }

    protected processGetOscillometryTests(response: Response): Promise<QueryOfOscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometryTest>(null as any);
    }

    postOscillometryTest(body: OscillometryTestCreation): Promise<OscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometryTest(_response);
        });
    }

    protected processPostOscillometryTest(response: Response): Promise<OscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometryTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryTest(_response);
        });
    }

    protected processGetOscillometryTest(response: Response): Promise<OscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryTest>(null as any);
    }

    patchOscillometryTest(body: OscillometryTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometryTest(_response);
        });
    }

    protected processPatchOscillometryTest(response: Response): Promise<OscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOverreadChallengeStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOverreadChallengeStatus> {
        let url_ = this.baseUrl + "/api/v3/overreadchallengestatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOverreadChallengeStatuses(_response);
        });
    }

    protected processGetOverreadChallengeStatuses(response: Response): Promise<QueryOfOverreadChallengeStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOverreadChallengeStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOverreadChallengeStatus>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOverreadStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOverreadStatus> {
        let url_ = this.baseUrl + "/api/v3/overreadstatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOverreadStatuses(_response);
        });
    }

    protected processGetOverreadStatuses(response: Response): Promise<QueryOfOverreadStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOverreadStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOverreadStatus>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getParameters(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfParameter> {
        let url_ = this.baseUrl + "/api/v3/parameters?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParameters(_response);
        });
    }

    protected processGetParameters(response: Response): Promise<QueryOfParameter> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfParameter;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfParameter>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSets(_response);
        });
    }

    protected processGetPcfAnalysisSets(response: Response): Promise<QueryOfPcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfAnalysisSet>(null as any);
    }

    postPcfAnalysisSet(body: PcfAnalysisSetCreation): Promise<PcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfAnalysisSet(_response);
        });
    }

    protected processPostPcfAnalysisSet(response: Response): Promise<PcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSet(_response);
        });
    }

    protected processGetPcfAnalysisSet(response: Response): Promise<PcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSet>(null as any);
    }

    patchPcfAnalysisSet(body: PcfAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfAnalysisSet(_response);
        });
    }

    protected processPatchPcfAnalysisSet(response: Response): Promise<PcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSetTests(_response);
        });
    }

    protected processGetPcfAnalysisSetTests(response: Response): Promise<QueryOfPcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfAnalysisSetTest>(null as any);
    }

    postPcfAnalysisSetTest(body: PcfAnalysisSetTestCreation): Promise<PcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfAnalysisSetTest(_response);
        });
    }

    protected processPostPcfAnalysisSetTest(response: Response): Promise<PcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSetTest(_response);
        });
    }

    protected processGetPcfAnalysisSetTest(response: Response): Promise<PcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSetTest>(null as any);
    }

    patchPcfAnalysisSetTest(body: PcfAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfAnalysisSetTest(_response);
        });
    }

    protected processPatchPcfAnalysisSetTest(response: Response): Promise<PcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfSessions(_response);
        });
    }

    protected processGetPcfSessions(response: Response): Promise<QueryOfPcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfSession>(null as any);
    }

    postPcfSession(body: PcfSessionCreation): Promise<PcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfSession(_response);
        });
    }

    protected processPostPcfSession(response: Response): Promise<PcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfSession(_response);
        });
    }

    protected processGetPcfSession(response: Response): Promise<PcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfSession>(null as any);
    }

    patchPcfSession(body: PcfSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfSession(_response);
        });
    }

    protected processPatchPcfSession(response: Response): Promise<PcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfTests(_response);
        });
    }

    protected processGetPcfTests(response: Response): Promise<QueryOfPcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfTest>(null as any);
    }

    postPcfTest(body: PcfTestCreation): Promise<PcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfTest(_response);
        });
    }

    protected processPostPcfTest(response: Response): Promise<PcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfTest(_response);
        });
    }

    protected processGetPcfTest(response: Response): Promise<PcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfTest>(null as any);
    }

    patchPcfTest(body: PcfTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfTest(_response);
        });
    }

    protected processPatchPcfTest(response: Response): Promise<PcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSets(_response);
        });
    }

    protected processGetPefAnalysisSets(response: Response): Promise<QueryOfPefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSet(_response);
        });
    }

    protected processGetPefAnalysisSet(response: Response): Promise<PefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSet>(null as any);
    }

    patchPefAnalysisSet(body: PefAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefAnalysisSet(_response);
        });
    }

    protected processPatchPefAnalysisSet(response: Response): Promise<PefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSet>(null as any);
    }

    postPefAnalysisSet(body: PefAnalysisSetCreation): Promise<PefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefAnalysisSet(_response);
        });
    }

    protected processPostPefAnalysisSet(response: Response): Promise<PefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSetTests(_response);
        });
    }

    protected processGetPefAnalysisSetTests(response: Response): Promise<QueryOfPefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefAnalysisSetTest>(null as any);
    }

    postPefAnalysisSetTest(body: PefAnalysisSetTestCreation): Promise<PefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefAnalysisSetTest(_response);
        });
    }

    protected processPostPefAnalysisSetTest(response: Response): Promise<PefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSetTest(_response);
        });
    }

    protected processGetPefAnalysisSetTest(response: Response): Promise<PefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSetTest>(null as any);
    }

    patchPefAnalysisSetTest(body: PefAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefAnalysisSetTest(_response);
        });
    }

    protected processPatchPefAnalysisSetTest(response: Response): Promise<PefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefSession> {
        let url_ = this.baseUrl + "/api/v3/pefsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefSessions(_response);
        });
    }

    protected processGetPefSessions(response: Response): Promise<QueryOfPefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefSession> {
        let url_ = this.baseUrl + "/api/v3/pefsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefSession(_response);
        });
    }

    protected processGetPefSession(response: Response): Promise<PefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefSession>(null as any);
    }

    postPefSession(body: PefSessionCreation): Promise<PefSession> {
        let url_ = this.baseUrl + "/api/v3/PefSessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefSession(_response);
        });
    }

    protected processPostPefSession(response: Response): Promise<PefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefSession>(null as any);
    }

    patchPefSession(body: PefSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefSession> {
        let url_ = this.baseUrl + "/api/v3/PefSessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefSession(_response);
        });
    }

    protected processPatchPefSession(response: Response): Promise<PefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefTest> {
        let url_ = this.baseUrl + "/api/v3/peftests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefTests(_response);
        });
    }

    protected processGetPefTests(response: Response): Promise<QueryOfPefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefTest> {
        let url_ = this.baseUrl + "/api/v3/PefTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefTest(_response);
        });
    }

    protected processGetPefTest(response: Response): Promise<PefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefTest>(null as any);
    }

    patchPefTest(body: PefTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefTest> {
        let url_ = this.baseUrl + "/api/v3/PefTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefTest(_response);
        });
    }

    protected processPatchPefTest(response: Response): Promise<PefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefTest>(null as any);
    }

    postPefTest(body: PefTestCreation): Promise<PefTest> {
        let url_ = this.baseUrl + "/api/v3/PefTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefTest(_response);
        });
    }

    protected processPostPefTest(response: Response): Promise<PefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPermissionCategories(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPermissionCategory> {
        let url_ = this.baseUrl + "/api/v3/permissioncategories?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissionCategories(_response);
        });
    }

    protected processGetPermissionCategories(response: Response): Promise<QueryOfPermissionCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPermissionCategory;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPermissionCategory>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPermissions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPermission> {
        let url_ = this.baseUrl + "/api/v3/permissions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<QueryOfPermission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPermission;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPermission>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPhases(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPhase> {
        let url_ = this.baseUrl + "/api/v3/phases?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPhases(_response);
        });
    }

    protected processGetPhases(response: Response): Promise<QueryOfPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPhase>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPopulationGroups(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPopulationGroups(_response);
        });
    }

    protected processGetPopulationGroups(response: Response): Promise<QueryOfPopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPopulationGroup;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPopulationGroup>(null as any);
    }

    postPopulationGroup(body: PopulationGroup): Promise<PopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPopulationGroup(_response);
        });
    }

    protected processPostPopulationGroup(response: Response): Promise<PopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGroup;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGroup>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPopulationGroup(key: string, select?: string | undefined, expand?: string | undefined): Promise<PopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPopulationGroup(_response);
        });
    }

    protected processGetPopulationGroup(response: Response): Promise<PopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGroup;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGroup>(null as any);
    }

    patchPopulationGroup(body: PopulationGroup, key: string, auditAnnotation?: string | null | undefined): Promise<PopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPopulationGroup(_response);
        });
    }

    protected processPatchPopulationGroup(response: Response): Promise<PopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGroup;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGroup>(null as any);
    }

    deletePopulationGroup(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/populationgroups/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePopulationGroup(_response);
        });
    }

    protected processDeletePopulationGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPredictedSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPredictedSet> {
        let url_ = this.baseUrl + "/api/v3/predictedsets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPredictedSets(_response);
        });
    }

    protected processGetPredictedSets(response: Response): Promise<QueryOfPredictedSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPredictedSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPredictedSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetryAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSets(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSets(response: Response): Promise<QueryOfPulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetryAnalysisSet>(null as any);
    }

    postPulseOximetryAnalysisSet(body: PulseOximetryAnalysisSet): Promise<PulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetryAnalysisSet(_response);
        });
    }

    protected processPostPulseOximetryAnalysisSet(response: Response): Promise<PulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetryAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSet(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSet(response: Response): Promise<PulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSet>(null as any);
    }

    patchPulseOximetryAnalysisSet(body: PulseOximetryAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetryAnalysisSet(_response);
        });
    }

    protected processPatchPulseOximetryAnalysisSet(response: Response): Promise<PulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetryAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSetTests(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSetTests(response: Response): Promise<QueryOfPulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetryAnalysisSetTest>(null as any);
    }

    postPulseOximetryAnalysisSetTest(body: PulseOximetryAnalysisSetTest): Promise<PulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetryAnalysisSetTest(_response);
        });
    }

    protected processPostPulseOximetryAnalysisSetTest(response: Response): Promise<PulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetryAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSetTest(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSetTest(response: Response): Promise<PulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSetTest>(null as any);
    }

    patchPulseOximetryAnalysisSetTest(body: PulseOximetryAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetryAnalysisSetTest(_response);
        });
    }

    protected processPatchPulseOximetryAnalysisSetTest(response: Response): Promise<PulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetrySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetrySessions(_response);
        });
    }

    protected processGetPulseOximetrySessions(response: Response): Promise<QueryOfPulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetrySession>(null as any);
    }

    postPulseOximetrySession(body: PulseOximetrySession): Promise<PulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetrySession(_response);
        });
    }

    protected processPostPulseOximetrySession(response: Response): Promise<PulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetrySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetrySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetrySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetrySession(_response);
        });
    }

    protected processGetPulseOximetrySession(response: Response): Promise<PulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetrySession>(null as any);
    }

    patchPulseOximetrySession(body: PulseOximetrySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetrySession(_response);
        });
    }

    protected processPatchPulseOximetrySession(response: Response): Promise<PulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetrySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetryTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryTests(_response);
        });
    }

    protected processGetPulseOximetryTests(response: Response): Promise<QueryOfPulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetryTest>(null as any);
    }

    postPulseOximetryTest(body: PulseOximetryTest): Promise<PulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetryTest(_response);
        });
    }

    protected processPostPulseOximetryTest(response: Response): Promise<PulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetryTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryTest(_response);
        });
    }

    protected processGetPulseOximetryTest(response: Response): Promise<PulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryTest>(null as any);
    }

    patchPulseOximetryTest(body: PulseOximetryTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetryTest(_response);
        });
    }

    protected processPatchPulseOximetryTest(response: Response): Promise<PulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getQuestionnaireTestAnswers(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfQuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTestAnswers(_response);
        });
    }

    protected processGetQuestionnaireTestAnswers(response: Response): Promise<QueryOfQuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfQuestionnaireTestAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfQuestionnaireTestAnswer>(null as any);
    }

    postQuestionnaireTestAnswer(body: QuestionnaireTestAnswerCreation): Promise<QuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostQuestionnaireTestAnswer(_response);
        });
    }

    protected processPostQuestionnaireTestAnswer(response: Response): Promise<QuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTestAnswer;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTestAnswer>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getQuestionnaireTestAnswer(key: string, select?: string | undefined, expand?: string | undefined): Promise<QuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTestAnswer(_response);
        });
    }

    protected processGetQuestionnaireTestAnswer(response: Response): Promise<QuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTestAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTestAnswer>(null as any);
    }

    patchQuestionnaireTestAnswer(body: QuestionnaireTestAnswerMutation, key: string, auditAnnotation?: string | null | undefined): Promise<QuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchQuestionnaireTestAnswer(_response);
        });
    }

    protected processPatchQuestionnaireTestAnswer(response: Response): Promise<QuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTestAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTestAnswer>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getQuestionnaireTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfQuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTests(_response);
        });
    }

    protected processGetQuestionnaireTests(response: Response): Promise<QueryOfQuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfQuestionnaireTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfQuestionnaireTest>(null as any);
    }

    postQuestionnaireTest(body: QuestionnaireTestCreation): Promise<QuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostQuestionnaireTest(_response);
        });
    }

    protected processPostQuestionnaireTest(response: Response): Promise<QuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getQuestionnaireTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<QuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTest(_response);
        });
    }

    protected processGetQuestionnaireTest(response: Response): Promise<QuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTest>(null as any);
    }

    patchQuestionnaireTest(body: QuestionnaireTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<QuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchQuestionnaireTest(_response);
        });
    }

    protected processPatchQuestionnaireTest(response: Response): Promise<QuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getRaces(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoreRace> {
        let url_ = this.baseUrl + "/api/v3/races?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRaces(_response);
        });
    }

    protected processGetRaces(response: Response): Promise<QueryOfCoreRace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoreRace;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoreRace>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getRoles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfRole> {
        let url_ = this.baseUrl + "/api/v3/roles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<QueryOfRole> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfRole;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfRole>(null as any);
    }

    postRole(body: RoleCreation): Promise<Role> {
        let url_ = this.baseUrl + "/api/v3/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostRole(_response);
        });
    }

    protected processPostRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getRole(key: string, select?: string | undefined, expand?: string | undefined): Promise<Role> {
        let url_ = this.baseUrl + "/api/v3/roles/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(null as any);
    }

    patchRole(body: RoleMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Role> {
        let url_ = this.baseUrl + "/api/v3/roles/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchRole(_response);
        });
    }

    protected processPatchRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getServiceResources(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetServiceResources(_response);
        });
    }

    protected processGetServiceResources(response: Response): Promise<QueryOfServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfServiceResourceCreation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfServiceResourceCreation>(null as any);
    }

    postServiceResource(body: ServiceResourceCreation): Promise<ServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostServiceResource(_response);
        });
    }

    protected processPostServiceResource(response: Response): Promise<ServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceResourceCreation;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResourceCreation>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getServiceResource(key: string, select?: string | undefined, expand?: string | undefined): Promise<ServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetServiceResource(_response);
        });
    }

    protected processGetServiceResource(response: Response): Promise<ServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceResourceCreation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResourceCreation>(null as any);
    }

    patchServiceResource(body: ServiceResourceMutation, key: string, auditAnnotation?: string | null | undefined): Promise<ServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchServiceResource(_response);
        });
    }

    protected processPatchServiceResource(response: Response): Promise<ServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceResourceCreation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResourceCreation>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessionAttachments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSessionAttachment> {
        let url_ = this.baseUrl + "/api/v3/sessionattachments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionAttachments(_response);
        });
    }

    protected processGetSessionAttachments(response: Response): Promise<QueryOfSessionAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSessionAttachment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSessionAttachment>(null as any);
    }

    postSessionAttachments(body: SessionAttachmentCreation): Promise<SessionAttachment> {
        let url_ = this.baseUrl + "/api/v3/sessionattachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSessionAttachments(_response);
        });
    }

    protected processPostSessionAttachments(response: Response): Promise<SessionAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionAttachment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionAttachment>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFile2(key: string, select?: string | undefined, expand?: string | undefined): Promise<SessionAttachment> {
        let url_ = this.baseUrl + "/api/v3/sessionattachments/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile2(_response);
        });
    }

    protected processGetFile2(response: Response): Promise<SessionAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionAttachment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionAttachment>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessionNotes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSessionNote> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionNotes(_response);
        });
    }

    protected processGetSessionNotes(response: Response): Promise<QueryOfSessionNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSessionNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSessionNote>(null as any);
    }

    postSessionNote(body: SessionNoteCreation): Promise<SessionNote> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSessionNote(_response);
        });
    }

    protected processPostSessionNote(response: Response): Promise<SessionNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionNote;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionNote>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSessionNote(key: string, select?: string | undefined, expand?: string | undefined): Promise<SessionNote> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionNote(_response);
        });
    }

    protected processGetSessionNote(response: Response): Promise<SessionNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionNote>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSession> {
        let url_ = this.baseUrl + "/api/v3/sessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: Response): Promise<QueryOfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<Session> {
        let url_ = this.baseUrl + "/api/v3/sessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSession(_response);
        });
    }

    protected processGetSession(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Session;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessionTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSessionType> {
        let url_ = this.baseUrl + "/api/v3/sessiontypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionTypes(_response);
        });
    }

    protected processGetSessionTypes(response: Response): Promise<QueryOfSessionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSessionType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSessionType>(null as any);
    }

    patchSetting(body: PatchSetting): Promise<PatchSetting> {
        let url_ = this.baseUrl + "/api/v3/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSetting(_response);
        });
    }

    protected processPatchSetting(response: Response): Promise<PatchSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchSetting;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatchSetting>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSites(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSite> {
        let url_ = this.baseUrl + "/api/v3/sites?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSites(_response);
        });
    }

    protected processGetSites(response: Response): Promise<QueryOfSite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSite;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSite>(null as any);
    }

    postSites(body: SiteCreation): Promise<Site> {
        let url_ = this.baseUrl + "/api/v3/sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSites(_response);
        });
    }

    protected processPostSites(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSite(key: string, select?: string | undefined, expand?: string | undefined): Promise<Site> {
        let url_ = this.baseUrl + "/api/v3/sites/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSite(_response);
        });
    }

    protected processGetSite(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    patchSites(body: SiteMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Site> {
        let url_ = this.baseUrl + "/api/v3/sites/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSites(_response);
        });
    }

    protected processPatchSites(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getRestPeriods(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRestPeriods(_response);
        });
    }

    protected processGetRestPeriods(response: Response): Promise<QueryOfSixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSixMinuteWalkRestPeriod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSixMinuteWalkRestPeriod>(null as any);
    }

    postRestPeriod(body: SixMinuteWalkRestPeriodCreation): Promise<SixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostRestPeriod(_response);
        });
    }

    protected processPostRestPeriod(response: Response): Promise<SixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkRestPeriod;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkRestPeriod>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getRestPeriod(key: string, select?: string | undefined, expand?: string | undefined): Promise<SixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRestPeriod(_response);
        });
    }

    protected processGetRestPeriod(response: Response): Promise<SixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkRestPeriod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkRestPeriod>(null as any);
    }

    patchRestPeriod(body: SixMinuteWalkRestPeriodMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchRestPeriod(_response);
        });
    }

    protected processPatchRestPeriod(response: Response): Promise<SixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkRestPeriod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkRestPeriod>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSixMinuteWalkSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkSessions(_response);
        });
    }

    protected processGetSixMinuteWalkSessions(response: Response): Promise<QueryOfSixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSixMinuteWalkSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSixMinuteWalkSession>(null as any);
    }

    postSixMinuteWalkSession(body: SixMinuteWalkSessionCreation): Promise<SixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSixMinuteWalkSession(_response);
        });
    }

    protected processPostSixMinuteWalkSession(response: Response): Promise<SixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSixMinuteWalkSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkSession(_response);
        });
    }

    protected processGetSixMinuteWalkSession(response: Response): Promise<SixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkSession>(null as any);
    }

    patchSixMinuteWalkSession(body: SixMinuteWalkSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSixMinuteWalkSession(_response);
        });
    }

    protected processPatchSixMinuteWalkSession(response: Response): Promise<SixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSixMinuteWalkTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkTests(_response);
        });
    }

    protected processGetSixMinuteWalkTests(response: Response): Promise<QueryOfSixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSixMinuteWalkTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSixMinuteWalkTest>(null as any);
    }

    postSixMinuteWalkTest(body: SixMinuteWalkTestCreation): Promise<SixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSixMinuteWalkTest(_response);
        });
    }

    protected processPostSixMinuteWalkTest(response: Response): Promise<SixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSixMinuteWalkTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkTest(_response);
        });
    }

    protected processGetSixMinuteWalkTest(response: Response): Promise<SixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkTest>(null as any);
    }

    patchSixMinuteWalkTest(body: SixMinuteWalkTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSixMinuteWalkTest(_response);
        });
    }

    protected processPatchSixMinuteWalkTest(response: Response): Promise<SixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSets(_response);
        });
    }

    protected processGetSnipAnalysisSets(response: Response): Promise<QueryOfSnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipAnalysisSet>(null as any);
    }

    postSnipAnalysisSet(body: SnipAnalysisSetCreation): Promise<SnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipAnalysisSet(_response);
        });
    }

    protected processPostSnipAnalysisSet(response: Response): Promise<SnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSet(_response);
        });
    }

    protected processGetSnipAnalysisSet(response: Response): Promise<SnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSet>(null as any);
    }

    patchSnipAnalysisSet(body: SnipAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipAnalysisSet(_response);
        });
    }

    protected processPatchSnipAnalysisSet(response: Response): Promise<SnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSetTests(_response);
        });
    }

    protected processGetSnipAnalysisSetTests(response: Response): Promise<QueryOfSnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipAnalysisSetTest>(null as any);
    }

    postSnipAnalysisSetTest(body: SnipAnalysisSetTestCreation): Promise<SnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipAnalysisSetTest(_response);
        });
    }

    protected processPostSnipAnalysisSetTest(response: Response): Promise<SnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSetTest(_response);
        });
    }

    protected processGetSnipAnalysisSetTest(response: Response): Promise<SnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSetTest>(null as any);
    }

    patchSnipAnalysisSetTest(body: PressureAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipAnalysisSetTest(_response);
        });
    }

    protected processPatchSnipAnalysisSetTest(response: Response): Promise<SnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipSessions(_response);
        });
    }

    protected processGetSnipSessions(response: Response): Promise<QueryOfSnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipSession>(null as any);
    }

    postSnipSession(body: SnipSessionCreation): Promise<SnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipSession(_response);
        });
    }

    protected processPostSnipSession(response: Response): Promise<SnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipSession(_response);
        });
    }

    protected processGetSnipSession(response: Response): Promise<SnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipSession>(null as any);
    }

    patchSnipSession(body: PressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipSession(_response);
        });
    }

    protected processPatchSnipSession(response: Response): Promise<SnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipTests(_response);
        });
    }

    protected processGetSnipTests(response: Response): Promise<QueryOfSnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipTest>(null as any);
    }

    postSnipTest(body: SnipTestCreation): Promise<SnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipTest(_response);
        });
    }

    protected processPostSnipTest(response: Response): Promise<SnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipTest(_response);
        });
    }

    protected processGetSnipTest(response: Response): Promise<SnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipTest>(null as any);
    }

    patchSnipTest(body: PressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipTest(_response);
        });
    }

    protected processPatchSnipTest(response: Response): Promise<SnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSpirometryAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSets(_response);
        });
    }

    protected processGetSpirometryAnalysisSets(response: Response): Promise<QueryOfFvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcAnalysisSet>(null as any);
    }

    postSpirometryAnalysisSet(body: FvcAnalysisSetCreation): Promise<FvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSpirometryAnalysisSet(_response);
        });
    }

    protected processPostSpirometryAnalysisSet(response: Response): Promise<FvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSpirometryAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSet(_response);
        });
    }

    protected processGetSpirometryAnalysisSet(response: Response): Promise<FvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSet>(null as any);
    }

    patchSpirometryAnalysisSet(body: FvcAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSpirometryAnalysisSet(_response);
        });
    }

    protected processPatchSpirometryAnalysisSet(response: Response): Promise<FvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSpirometryAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSetTests(_response);
        });
    }

    protected processGetSpirometryAnalysisSetTests(response: Response): Promise<QueryOfFvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcAnalysisSetTest>(null as any);
    }

    postSpirometryAnalysisSetTest(body: FvcAnalysisSetTest): Promise<FvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSpirometryAnalysisSetTest(_response);
        });
    }

    protected processPostSpirometryAnalysisSetTest(response: Response): Promise<FvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSpirometryAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSetTest(_response);
        });
    }

    protected processGetSpirometryAnalysisSetTest(response: Response): Promise<FvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSetTest>(null as any);
    }

    patchSpirometryAnalysisSetTest(body: FvcAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSpirometryAnalysisSetTest(_response);
        });
    }

    protected processPatchSpirometryAnalysisSetTest(response: Response): Promise<FvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSpirotracUserGroups(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSpirotracUserGroup> {
        let url_ = this.baseUrl + "/api/v3/spirotracusergroups?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirotracUserGroups(_response);
        });
    }

    protected processGetSpirotracUserGroups(response: Response): Promise<QueryOfSpirotracUserGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSpirotracUserGroup;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSpirotracUserGroup>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudies(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudy> {
        let url_ = this.baseUrl + "/api/v3/studies?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudies(_response);
        });
    }

    protected processGetStudies(response: Response): Promise<QueryOfStudy> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudy;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudy>(null as any);
    }

    postStudy(body: StudyCreation): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudy(_response);
        });
    }

    protected processPostStudy(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudy(key: string, select?: string | undefined, expand?: string | undefined): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studies/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudy(_response);
        });
    }

    protected processGetStudy(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    patchStudy(body: StudyMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studies/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudy(_response);
        });
    }

    protected processPatchStudy(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyCoughEventTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyCoughEventTypes(_response);
        });
    }

    protected processGetStudyCoughEventTypes(response: Response): Promise<QueryOfStudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyCoughEventType>(null as any);
    }

    postStudyCoughEventType(body: StudyCoughEventType): Promise<StudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudyCoughEventType(_response);
        });
    }

    protected processPostStudyCoughEventType(response: Response): Promise<StudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCoughEventType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyCoughEventType(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyCoughEventType(_response);
        });
    }

    protected processGetStudyCoughEventType(response: Response): Promise<StudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCoughEventType>(null as any);
    }

    patchStudyCoughEventType(body: StudyCoughEventType, key: string, auditAnnotation?: string | null | undefined): Promise<StudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyCoughEventType(_response);
        });
    }

    protected processPatchStudyCoughEventType(response: Response): Promise<StudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCoughEventType>(null as any);
    }

    deleteStudyCoughEventType(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteStudyCoughEventType(_response);
        });
    }

    protected processDeleteStudyCoughEventType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyCountries(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyCountry> {
        let url_ = this.baseUrl + "/api/v3/studycountries?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyCountries(_response);
        });
    }

    protected processGetStudyCountries(response: Response): Promise<QueryOfStudyCountry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyCountry;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyCountry>(null as any);
    }

    patchStudyCountry(body: StudyCountry, key: string, auditAnnotation?: string | null | undefined): Promise<StudyCountry> {
        let url_ = this.baseUrl + "/api/v3/studycountries/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyCountry(_response);
        });
    }

    protected processPatchStudyCountry(response: Response): Promise<StudyCountry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCountry;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCountry>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyFixedCommentSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyFixedCommentSets(_response);
        });
    }

    protected processGetStudyFixedCommentSets(response: Response): Promise<QueryOfStudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyFixedCommentSet>(null as any);
    }

    postStudyFixedCommentSet(body: StudyFixedCommentSet): Promise<StudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudyFixedCommentSet(_response);
        });
    }

    protected processPostStudyFixedCommentSet(response: Response): Promise<StudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyFixedCommentSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyFixedCommentSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyFixedCommentSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyFixedCommentSet(_response);
        });
    }

    protected processGetStudyFixedCommentSet(response: Response): Promise<StudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyFixedCommentSet>(null as any);
    }

    patchStudyFixedCommentSet(body: StudyFixedCommentSet, key: string, auditAnnotation?: string | null | undefined): Promise<StudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyFixedCommentSet(_response);
        });
    }

    protected processPatchStudyFixedCommentSet(response: Response): Promise<StudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyFixedCommentSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyLanguages(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyLanguage> {
        let url_ = this.baseUrl + "/api/v3/studylanguages?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyLanguages(_response);
        });
    }

    protected processGetStudyLanguages(response: Response): Promise<QueryOfStudyLanguage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyLanguage;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyLanguage>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudySchedulePhases(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyPhase> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedulePhases(_response);
        });
    }

    protected processGetStudySchedulePhases(response: Response): Promise<QueryOfStudyPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyPhase>(null as any);
    }

    postStudySchedulePhase(body: StudyPhase): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudySchedulePhase(_response);
        });
    }

    protected processPostStudySchedulePhase(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudySchedulePhase(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyPhase> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedulePhase(_response);
        });
    }

    protected processGetStudySchedulePhase(response: Response): Promise<StudyPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyPhase>(null as any);
    }

    patchStudySchedulePhase(body: StudyPhase, key: string, auditAnnotation?: string | null | undefined): Promise<StudyPhase> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudySchedulePhase(_response);
        });
    }

    protected processPatchStudySchedulePhase(response: Response): Promise<StudyPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyPhase>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudySchedules(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudySchedule> {
        let url_ = this.baseUrl + "/api/v3/studyschedules?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedules(_response);
        });
    }

    protected processGetStudySchedules(response: Response): Promise<QueryOfStudySchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudySchedule;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudySchedule>(null as any);
    }

    postStudySchedule(body: StudyScheduleCreation): Promise<StudySchedule> {
        let url_ = this.baseUrl + "/api/v3/studyschedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudySchedule(_response);
        });
    }

    protected processPostStudySchedule(response: Response): Promise<StudySchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudySchedule;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudySchedule>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudySchedule(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudySchedule> {
        let url_ = this.baseUrl + "/api/v3/studyschedules/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedule(_response);
        });
    }

    protected processGetStudySchedule(response: Response): Promise<StudySchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudySchedule;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudySchedule>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyScheduleSessionActions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyScheduleSessionAction> {
        let url_ = this.baseUrl + "/api/v3/studyschedulesessionactions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleSessionActions(_response);
        });
    }

    protected processGetStudyScheduleSessionActions(response: Response): Promise<QueryOfStudyScheduleSessionAction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyScheduleSessionAction;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyScheduleSessionAction>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyScheduleSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyScheduleSession> {
        let url_ = this.baseUrl + "/api/v3/studyschedulesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleSessions(_response);
        });
    }

    protected processGetStudyScheduleSessions(response: Response): Promise<QueryOfStudyScheduleSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyScheduleSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyScheduleSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyScheduleSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyScheduleSession> {
        let url_ = this.baseUrl + "/api/v3/studyschedulesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleSession(_response);
        });
    }

    protected processGetStudyScheduleSession(response: Response): Promise<StudyScheduleSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyScheduleSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyScheduleSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyScheduleVisits(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyScheduleVisit> {
        let url_ = this.baseUrl + "/api/v3/studyschedulevisits?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleVisits(_response);
        });
    }

    protected processGetStudyScheduleVisits(response: Response): Promise<QueryOfStudyScheduleVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyScheduleVisit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyScheduleVisit>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyScheduleVisit(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyScheduleVisit> {
        let url_ = this.baseUrl + "/api/v3/studyschedulevisits/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleVisit(_response);
        });
    }

    protected processGetStudyScheduleVisit(response: Response): Promise<StudyScheduleVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyScheduleVisit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyScheduleVisit>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudySessionTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudySessionType> {
        let url_ = this.baseUrl + "/api/v3/studysessiontypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySessionTypes(_response);
        });
    }

    protected processGetStudySessionTypes(response: Response): Promise<QueryOfStudySessionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudySessionType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudySessionType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSubjectNotes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSubjectNote> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjectNotes(_response);
        });
    }

    protected processGetSubjectNotes(response: Response): Promise<QueryOfSubjectNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSubjectNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSubjectNote>(null as any);
    }

    postSubjectNote(body: SubjectNoteCreation): Promise<SubjectNote> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSubjectNote(_response);
        });
    }

    protected processPostSubjectNote(response: Response): Promise<SubjectNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubjectNote;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectNote>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSubjectNote(key: string, select?: string | undefined, expand?: string | undefined): Promise<SubjectNote> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjectNote(_response);
        });
    }

    protected processGetSubjectNote(response: Response): Promise<SubjectNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubjectNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectNote>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSubjects(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSubject> {
        let url_ = this.baseUrl + "/api/v3/subjects?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjects(_response);
        });
    }

    protected processGetSubjects(response: Response): Promise<QueryOfSubject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSubject;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSubject>(null as any);
    }

    postSubjects(body: SubjectCreation): Promise<Subject> {
        let url_ = this.baseUrl + "/api/v3/subjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSubjects(_response);
        });
    }

    protected processPostSubjects(response: Response): Promise<Subject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subject;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subject>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSubject(key: string, select?: string | undefined, expand?: string | undefined): Promise<Subject> {
        let url_ = this.baseUrl + "/api/v3/subjects/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubject(_response);
        });
    }

    protected processGetSubject(response: Response): Promise<Subject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subject;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subject>(null as any);
    }

    patchSubjects(body: SubjectMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Subject> {
        let url_ = this.baseUrl + "/api/v3/subjects/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSubjects(_response);
        });
    }

    protected processPatchSubjects(response: Response): Promise<Subject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subject;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subject>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSubjectTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSubjectType> {
        let url_ = this.baseUrl + "/api/v3/subjecttypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjectTypes(_response);
        });
    }

    protected processGetSubjectTypes(response: Response): Promise<QueryOfSubjectType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSubjectType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSubjectType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSurveyAnswers(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSurveyAnswer> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveyAnswers(_response);
        });
    }

    protected processGetSurveyAnswers(response: Response): Promise<QueryOfSurveyAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSurveyAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSurveyAnswer>(null as any);
    }

    postSurveyAnswer(body: SurveyAnswerCreation): Promise<SurveyAnswer> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSurveyAnswer(_response);
        });
    }

    protected processPostSurveyAnswer(response: Response): Promise<SurveyAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyAnswer;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyAnswer>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSurveyAnswer(key: string, select?: string | undefined, expand?: string | undefined): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveyAnswer(_response);
        });
    }

    protected processGetSurveyAnswer(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    patchSurveyAnswer(body: SurveyAnswerMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SurveyAnswer> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSurveyAnswer(_response);
        });
    }

    protected processPatchSurveyAnswer(response: Response): Promise<SurveyAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyAnswer>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSurveySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveySessions(_response);
        });
    }

    protected processGetSurveySessions(response: Response): Promise<QueryOfSurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSurveySession>(null as any);
    }

    postSurveySession(body: SurveySessionCreation): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSurveySession(_response);
        });
    }

    protected processPostSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSurveySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveySession(_response);
        });
    }

    protected processGetSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    patchSurveySession(body: SurveySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSurveySession(_response);
        });
    }

    protected processPatchSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    putSurveySession(body: SurveySessionMutation, key: string): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutSurveySession(_response);
        });
    }

    protected processPutSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSets(_response);
        });
    }

    protected processGetSvcAnalysisSets(response: Response): Promise<QueryOfSvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcAnalysisSet>(null as any);
    }

    postSvcAnalysisSet(body: SvcAnalysisSetCreation): Promise<SvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcAnalysisSet(_response);
        });
    }

    protected processPostSvcAnalysisSet(response: Response): Promise<SvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSet(_response);
        });
    }

    protected processGetSvcAnalysisSet(response: Response): Promise<SvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSet>(null as any);
    }

    patchSvcAnalysisSet(body: SvcAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcAnalysisSet(_response);
        });
    }

    protected processPatchSvcAnalysisSet(response: Response): Promise<SvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSetTests(_response);
        });
    }

    protected processGetSvcAnalysisSetTests(response: Response): Promise<QueryOfSvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcAnalysisSetTest>(null as any);
    }

    postSvcAnalysisSetTest(body: SvcAnalysisSetTest): Promise<SvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcAnalysisSetTest(_response);
        });
    }

    protected processPostSvcAnalysisSetTest(response: Response): Promise<SvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSetTest(_response);
        });
    }

    protected processGetSvcAnalysisSetTest(response: Response): Promise<SvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSetTest>(null as any);
    }

    patchSvcAnalysisSetTest(body: SvcAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcAnalysisSetTest(_response);
        });
    }

    protected processPatchSvcAnalysisSetTest(response: Response): Promise<SvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSetTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSetTypes(_response);
        });
    }

    protected processGetSvcAnalysisSetTypes(response: Response): Promise<QueryOfSvcAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcAnalysisSetType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcSessions(_response);
        });
    }

    protected processGetSvcSessions(response: Response): Promise<QueryOfSvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcSession>(null as any);
    }

    postSvcSession(body: SvcSessionCreation): Promise<SvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcSession(_response);
        });
    }

    protected processPostSvcSession(response: Response): Promise<SvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcSession(_response);
        });
    }

    protected processGetSvcSession(response: Response): Promise<SvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcSession>(null as any);
    }

    patchSvcSession(body: SvcSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcSession(_response);
        });
    }

    protected processPatchSvcSession(response: Response): Promise<SvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcTests(_response);
        });
    }

    protected processGetSvcTests(response: Response): Promise<QueryOfSvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcTest>(null as any);
    }

    postSvcTest(body: SvcTestCreation): Promise<SvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcTest(_response);
        });
    }

    protected processPostSvcTest(response: Response): Promise<SvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcTest(_response);
        });
    }

    protected processGetSvcTest(response: Response): Promise<SvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcTest>(null as any);
    }

    patchSvcTest(body: SvcTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcTest(_response);
        });
    }

    protected processPatchSvcTest(response: Response): Promise<SvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getTestNotes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfTestNote> {
        let url_ = this.baseUrl + "/api/v3/testnotes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTestNotes(_response);
        });
    }

    protected processGetTestNotes(response: Response): Promise<QueryOfTestNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfTestNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfTestNote>(null as any);
    }

    postTestNote(body: TestNoteCreation): Promise<TestNote> {
        let url_ = this.baseUrl + "/api/v3/testnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostTestNote(_response);
        });
    }

    protected processPostTestNote(response: Response): Promise<TestNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestNote;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestNote>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getTestNote(key: string, select?: string | undefined, expand?: string | undefined): Promise<TestNote> {
        let url_ = this.baseUrl + "/api/v3/testnotes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTestNote(_response);
        });
    }

    protected processGetTestNote(response: Response): Promise<TestNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestNote>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getTimeZones(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfTimeZone> {
        let url_ = this.baseUrl + "/api/v3/timezones?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimeZones(_response);
        });
    }

    protected processGetTimeZones(response: Response): Promise<QueryOfTimeZone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfTimeZone;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfTimeZone>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getUnitTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfUnitType> {
        let url_ = this.baseUrl + "/api/v3/unittypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitTypes(_response);
        });
    }

    protected processGetUnitTypes(response: Response): Promise<QueryOfUnitType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfUnitType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfUnitType>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getUnrestrictedCoughAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/unrestrictedcoughanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnrestrictedCoughAnalysisSets(_response);
        });
    }

    protected processGetUnrestrictedCoughAnalysisSets(response: Response): Promise<QueryOfCoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getUnrestrictedCoughAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/unrestrictedcoughanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnrestrictedCoughAnalysisSet(_response);
        });
    }

    protected processGetUnrestrictedCoughAnalysisSet(response: Response): Promise<CoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSet>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getUsers(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfUser> {
        let url_ = this.baseUrl + "/api/v3/users?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<QueryOfUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfUser;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfUser>(null as any);
    }

    postUser(body: UserCreation): Promise<User> {
        let url_ = this.baseUrl + "/api/v3/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostUser(_response);
        });
    }

    protected processPostUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getUser(key: string, select?: string | undefined, expand?: string | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/v3/users/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    patchUser(body: UserMutation, key: string, auditAnnotation?: string | null | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/v3/users/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchUser(_response);
        });
    }

    protected processPatchUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getVisitObligations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfVisitObligation> {
        let url_ = this.baseUrl + "/api/v3/visitobligations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisitObligations(_response);
        });
    }

    protected processGetVisitObligations(response: Response): Promise<QueryOfVisitObligation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfVisitObligation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfVisitObligation>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getVisits(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfVisit> {
        let url_ = this.baseUrl + "/api/v3/visits?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisits(_response);
        });
    }

    protected processGetVisits(response: Response): Promise<QueryOfVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfVisit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfVisit>(null as any);
    }

    postVisit(body: VisitCreation): Promise<Visit> {
        let url_ = this.baseUrl + "/api/v3/visits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostVisit(_response);
        });
    }

    protected processPostVisit(response: Response): Promise<Visit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Visit;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Visit>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getVisit(key: string, select?: string | undefined, expand?: string | undefined): Promise<Visit> {
        let url_ = this.baseUrl + "/api/v3/visits/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisit(_response);
        });
    }

    protected processGetVisit(response: Response): Promise<Visit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Visit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Visit>(null as any);
    }

    patchVisits(body: VisitMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Visit> {
        let url_ = this.baseUrl + "/api/v3/visits/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchVisits(_response);
        });
    }

    protected processPatchVisits(response: Response): Promise<Visit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Visit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Visit>(null as any);
    }
}

export interface QueryOfAccessRequest {
    value?: AccessRequest[] | undefined;
    "@odata.count"?: number;
}

export interface AccessRequest {
    id?: string;
    email?: string | undefined;
    fullName?: string | undefined;
    organization?: string | undefined;
    countryCode?: string | undefined;
    createdAt?: string;
    timeZoneId?: string | undefined;
    preferredLanguageCode?: string | undefined;
}

export interface ErrorDto {
    id?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
    generated?: string;
    meta?: any | undefined;
}

export interface AccessRequestCreation {
    id?: string;
}

/** Represents an IQueryable containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResult {
    /** The IQueryable containing zero or one entities. */
    queryable?: any[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfAccessRequest extends SingleResult {
    queryable?: AccessRequest[] | undefined;
}

export interface QueryOfAlertNotification {
    value?: AlertNotification[] | undefined;
    "@odata.count"?: number;
}

export interface AlertNotificationMutation {
    isRead?: boolean;
}

export interface AlertNotification extends AlertNotificationMutation {
    id?: string;
    subscription?: NotificationSubscription | undefined;
    alert?: Alert | undefined;
    occurred?: string;
}

export interface NotificationSubscriptionCreation {
    id?: string;
    pluginId?: string | undefined;
    pluginName?: string | undefined;
    notifyImmediately?: boolean;
    notifyAuthor?: boolean;
    notifySite?: boolean;
    active?: boolean;
    usersToNotifyIds?: string[] | undefined;
    rolesToNotifyIds?: string[] | undefined;
    studyId?: string;
}

export interface NotificationSubscription extends NotificationSubscriptionCreation {
    usersToNotify?: User[] | undefined;
    rolesToNotify?: Role[] | undefined;
}

export interface UserMutation {
    email?: string | undefined;
    password?: string | undefined;
    roleIds?: string[] | undefined;
    siteIds?: string[] | undefined;
    eDiaryPin?: string | undefined;
    spirotracUserGroupId?: string | undefined;
    isServiceAccount?: boolean;
    isRegisteredForMobileApp?: boolean;
    timeZoneId?: string | undefined;
    isDisabled?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    countryId?: string | undefined;
    preferredLanguageCode?: string | undefined;
}

export interface User extends UserMutation {
    id?: string;
    hasRequest?: boolean;
    roles?: Role[] | undefined;
}

export interface RoleMutation {
    studyId?: string | undefined;
    name?: string | undefined;
    permissionsIds?: string[] | undefined;
    childRolesIds?: string[] | undefined;
}

export interface Role extends RoleMutation {
    id?: string;
    study?: Study | undefined;
    users?: User[] | undefined;
    permissions?: Permission[] | undefined;
}

export interface StudyMutation {
    name?: string | undefined;
    protocol?: string | undefined;
    description?: string | undefined;
    welcomeMessage?: string | undefined;
    logo?: string | undefined;
    logoMediaType?: string | undefined;
    targetSubjects?: number | undefined;
    targetSessions?: number | undefined;
    vitalographContactEmail?: string | undefined;
    sessionTypeIds?: string[] | undefined;
    countriesIds?: string[] | undefined;
    deviceTypeIds?: string[] | undefined;
    languageIds?: string[] | undefined;
    diaryConfiguration?: string | undefined;
}

export interface StudyCreation extends StudyMutation {
    id?: string;
}

export interface Study extends StudyCreation {
    created?: string;
    modified?: string;
    sites?: Site[] | undefined;
}

export interface SiteMutation {
    id?: string;
    studyId?: string;
    number?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contact?: string | undefined;
    fax?: string | undefined;
    country?: string | undefined;
    timeZone?: string | undefined;
}

export interface Site extends SiteMutation {
    created?: string;
    modified?: string;
    study?: Study | undefined;
    country?: string | undefined;
    subjects?: Subject[] | undefined;
}

export interface SubjectMutation {
    siteId?: string;
    populationGroupId?: string | undefined;
    status?: string | undefined;
    number?: string | undefined;
    alternativeNumber?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    language?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    ulna?: number | undefined;
    medicationType?: string | undefined;
    smokerType?: string | undefined;
    randomizationNumber?: string | undefined;
    randomized?: string | undefined;
    isRandomized?: boolean;
    pin?: string | undefined;
    bedTime?: string | undefined;
    baselinePef?: number | undefined;
    baselineFev1?: number | undefined;
    alarms?: SubjectAlarm[] | undefined;
    diaryComplianceDateTime?: string | undefined;
    studyPart?: string | undefined;
    terminationDate?: string | undefined;
    baseline1?: number | undefined;
    baseline2?: number | undefined;
    baseline3?: number | undefined;
}

export interface Subject extends SubjectMutation {
    id?: string;
    created?: string;
    modified?: string;
    site?: Site | undefined;
    languageName?: string | undefined;
    genderName?: string | undefined;
    smokerTypeName?: string | undefined;
    populationGroupName?: string | undefined;
    visits?: Visit[] | undefined;
    createdWithSpirotracV?: boolean;
    typeKey?: string | undefined;
    typeName?: string | undefined;
}

export interface VisitMutation {
    name?: string | undefined;
    occurred?: string;
}

export interface VisitCreation extends VisitMutation {
    id?: string;
    subjectId?: string;
}

export interface Visit extends VisitCreation {
    created?: string;
    modified?: string;
    subject?: Subject | undefined;
    visitScheduleItemId?: string;
    sessions?: Session[] | undefined;
}

export interface Session {
    id?: string;
    visitId?: string;
    sessionType?: string | undefined;
    sessionTypeName?: string | undefined;
    deviceType?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    occurred?: string | undefined;
    created?: string;
    modified?: string | undefined;
    lastReceived?: string | undefined;
    suppressed?: boolean;
    visit?: Visit | undefined;
    technician?: string | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: AnalysisSet[] | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean | undefined;
    sessionScheduleItemId?: string;
}

export interface SessionNoteMutation {
    sessionId?: string;
    userEmailAddress?: string | undefined;
    comment?: string | undefined;
    recorded?: string;
}

export interface SessionNote extends SessionNoteMutation {
    id?: string;
}

export interface AnalysisSet {
    id?: string;
    status?: string | undefined;
    type?: string | undefined;
}

export interface SubjectAlarm {
    time?: string;
}

export interface Permission {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDisabled?: boolean;
    category?: PermissionCategory | undefined;
    roles?: Role[] | undefined;
}

export interface PermissionCategory {
    id?: number;
    description?: string | undefined;
    displayOrder?: number;
    permissions?: Permission[] | undefined;
}

export interface AlertMutation {
    alertTemplateId?: string | undefined;
    headline?: string | undefined;
    content?: string | undefined;
    active?: boolean | undefined;
    triggeredBySessionId?: string | undefined;
    occurred?: string;
    isRead?: boolean;
    originatingIdentifier?: string | undefined;
    siteId?: string | undefined;
}

export interface Alert extends AlertMutation {
    id?: string;
    triggeredBySession?: Session | undefined;
    subject?: Subject | undefined;
}

export interface AlertNotificationCreation {
    id?: string;
    occurred?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfAlertNotification extends SingleResult {
    queryable?: AlertNotification[] | undefined;
}

export interface QueryOfAlert {
    value?: Alert[] | undefined;
    "@odata.count"?: number;
}

export interface AlertCreation {
    id?: string;
    alertTemplateId?: string | undefined;
    headline?: string | undefined;
    content?: string | undefined;
    active?: boolean | undefined;
    triggeredBySessionId?: string | undefined;
    occurred?: string;
    originatingIdentifier?: string | undefined;
    siteId?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfAlert extends SingleResult {
    queryable?: Alert[] | undefined;
}

export interface QueryOfAnalysisSetType {
    value?: AnalysisSetType[] | undefined;
    "@odata.count"?: number;
}

export interface AnalysisSetType {
    id?: number;
    name?: string | undefined;
    externalCode?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfAnalysisSetType extends SingleResult {
    queryable?: AnalysisSetType[] | undefined;
}

export interface AnnotatedEcgWrapper {
    text?: string | undefined;
}

export interface AnnotatedEcgRequest {
    testId?: string;
}

export interface AuditTrailEvent {
    id?: string;
    auditAction?: string | undefined;
    summary?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfAuditTrailEvent extends SingleResult {
    queryable?: AuditTrailEvent[] | undefined;
}

export interface QueryOfBloodGlucoseSampleMethod {
    value?: BloodGlucoseSampleMethod[] | undefined;
    "@odata.count"?: number;
}

export interface BloodGlucoseSampleMethod {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfBloodGlucoseSampleMethod extends SingleResult {
    queryable?: BloodGlucoseSampleMethod[] | undefined;
}

export interface QueryOfBloodGlucoseSession {
    value?: BloodGlucoseSession[] | undefined;
    "@odata.count"?: number;
}

export interface BloodGlucoseSessionMutation {
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bmi?: number | undefined;
    status?: string | undefined;
    configured?: boolean;
    configurationTechnician?: string | undefined;
    configurationOccurred?: string | undefined;
}

export interface BloodGlucoseSession extends BloodGlucoseSessionMutation {
    id?: string;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: BloodGlucoseTest[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
}

export interface BloodGlucoseTestMutation {
    occurred?: string;
    index?: number;
    ketone?: number | undefined;
    glucoseSI?: number | undefined;
    glucoseUS?: number | undefined;
    sampleMethod?: string | undefined;
    sampleMethodName?: string | undefined;
}

export interface BloodGlucoseTest extends BloodGlucoseTestMutation {
    id?: string;
    sessionId?: string;
    session?: BloodGlucoseSession | undefined;
    created?: string;
    modified?: string;
}

export interface BloodGlucoseSessionCreation {
    id?: string;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: BloodGlucoseTestCreation[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bmi?: number | undefined;
    status?: string | undefined;
    configured?: boolean;
    configurationTechnician?: string | undefined;
    configurationOccurred?: string | undefined;
}

export interface BloodGlucoseTestCreation {
    id?: string;
    sessionId?: string;
    session?: BloodGlucoseSession | undefined;
    created?: string;
    modified?: string;
    occurred?: string;
    index?: number;
    ketone?: number | undefined;
    glucoseSI?: number | undefined;
    glucoseUS?: number | undefined;
    sampleMethod?: string | undefined;
    sampleMethodName?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfBloodGlucoseSession extends SingleResult {
    queryable?: BloodGlucoseSession[] | undefined;
}

export interface QueryOfBloodGlucoseTest {
    value?: BloodGlucoseTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfBloodGlucoseTest extends SingleResult {
    queryable?: BloodGlucoseTest[] | undefined;
}

export interface QueryOfBloodPressureSession {
    value?: BloodPressureSession[] | undefined;
    "@odata.count"?: number;
}

export interface BloodPressureSessionMutation {
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bmi?: number | undefined;
}

export interface BloodPressureSession extends BloodPressureSessionMutation {
    id?: string;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: BloodPressureTest[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
}

export interface BloodPressureTestMutation {
    occurred?: string;
    index?: number;
    systolic?: number | undefined;
    diastolic?: number | undefined;
    meanArterialPressure?: number | undefined;
    pulseRate?: number | undefined;
    arm?: string | undefined;
    cuffSize?: string | undefined;
}

export interface BloodPressureTest extends BloodPressureTestMutation {
    id?: string;
    sessionId?: string;
    session?: BloodPressureSession | undefined;
    created?: string;
    modified?: string;
}

export interface BloodPressureSessionCreation {
    id?: string;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: BloodPressureTestCreation[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bmi?: number | undefined;
}

export interface BloodPressureTestCreation {
    id?: string;
    sessionId?: string;
    session?: BloodPressureSession | undefined;
    created?: string;
    modified?: string;
    occurred?: string;
    index?: number;
    systolic?: number | undefined;
    diastolic?: number | undefined;
    meanArterialPressure?: number | undefined;
    pulseRate?: number | undefined;
    arm?: string | undefined;
    cuffSize?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfBloodPressureSession extends SingleResult {
    queryable?: BloodPressureSession[] | undefined;
}

export interface QueryOfBloodPressureTest {
    value?: BloodPressureTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfBloodPressureTest extends SingleResult {
    queryable?: BloodPressureTest[] | undefined;
}

export interface QueryOfBorgScale {
    value?: BorgScale[] | undefined;
    "@odata.count"?: number;
}

export interface BorgScaleMutation {
    description?: string | undefined;
}

export interface BorgScale extends BorgScaleMutation {
    id?: string;
    studyId?: string;
    grade?: number;
}

export interface BorgScaleCreation {
    id?: string;
    studyId?: string;
    grade?: number;
    description?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfBorgScale extends SingleResult {
    queryable?: BorgScale[] | undefined;
}

export interface QueryOfCalibration {
    value?: Calibration[] | undefined;
    "@odata.count"?: number;
}

export interface CalibrationMutation {
    id?: string;
    siteId?: string | undefined;
    deviceType?: string | undefined;
    user?: string | undefined;
    checked?: string;
    serialNumber?: string | undefined;
    syringeNumber?: string | undefined;
    referenceVol?: number;
    measuredExp?: number | undefined;
    measuredInsp?: number | undefined;
    temperature?: number | undefined;
    pressure?: number | undefined;
    humidity?: number | undefined;
    altitude?: number | undefined;
    result?: string | undefined;
    updated?: boolean;
    comments?: string | undefined;
    dynamicProperties?: { [key: string]: any; } | undefined;
}

export interface CalibrationCreation extends CalibrationMutation {
}

export interface Calibration extends CalibrationCreation {
    created?: string;
    modified?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCalibration extends SingleResult {
    queryable?: Calibration[] | undefined;
}

export interface QueryOfChallengeSession {
    value?: ChallengeSession[] | undefined;
    "@odata.count"?: number;
}

export interface ChallengeSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    softwareReference?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    challengeTypeId?: string | undefined;
    preChallengeFev1?: number | undefined;
    baselineFev1?: number | undefined;
    deliveryMethod?: string | undefined;
    pd?: number | undefined;
}

export interface ChallengeSession extends ChallengeSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionTypeId?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    received?: string | undefined;
}

export interface ChallengeSessionCreation extends ChallengeSessionMutation {
    id?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfChallengeSession extends SingleResult {
    queryable?: ChallengeSession[] | undefined;
}

export interface QueryOfConfigurableDataItem {
    value?: ConfigurableDataItem[] | undefined;
    "@odata.count"?: number;
}

export interface ConfigurableDataItem {
    id?: string | undefined;
    name?: string | undefined;
    defaultFormatId?: string | undefined;
    configurableDataItemId?: string | undefined;
    configurableEntityId?: string | undefined;
    defaultDisplayText?: string | undefined;
    defaultMinimumLength?: number | undefined;
    defaultMaximumLength?: number | undefined;
    defaultMinimumValue?: number | undefined;
    defaultMaximumValue?: number | undefined;
    defaultUnitTypeId?: string | undefined;
    defaultImportanceId?: string | undefined;
    customFormat?: string | undefined;
    isFormatAttributeAvailable?: boolean;
    isMinAndMaxLengthAttributesAvailable?: boolean;
    isMinAndMaxValueAttributesAvailable?: boolean;
    isImportanceAttributeAvailable?: boolean;
    isDisplayTextAttributeAvailable?: boolean;
    isUnitTypeAttributeAvailable?: boolean;
    isPrefixWithSiteNumberAttributeAvailable?: boolean;
    defaultPrefixWithSiteNumber?: boolean;
    fieldLength?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfConfigurableDataItem extends SingleResult {
    queryable?: ConfigurableDataItem[] | undefined;
}

export interface QueryOfCoughAnalysisSetComment {
    value?: CoughAnalysisSetComment[] | undefined;
    "@odata.count"?: number;
}

export interface CoughAnalysisSetCommentCreation {
    analysisSetId?: string;
    comment?: string | undefined;
    commentStartTime?: number | undefined;
    commentEndTime?: number | undefined;
    parentCommentId?: string | undefined;
    replies?: CoughAnalysisSetComment[] | undefined;
}

export interface CoughAnalysisSetComment extends CoughAnalysisSetCommentCreation {
    userEmail?: string | undefined;
    created?: string | undefined;
    id?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughAnalysisSetComment extends SingleResult {
    queryable?: CoughAnalysisSetComment[] | undefined;
}

export interface QueryOfCoughAnalysisSetEvent {
    value?: CoughAnalysisSetEvent[] | undefined;
    "@odata.count"?: number;
}

export interface CoughAnalysisSetEventCreation {
    id?: string;
    analysisSetId?: string;
    eventTypeId?: string;
    rawStart?: number | undefined;
    rawEnd?: number | undefined;
    processedStart?: number | undefined;
    processedEnd?: number | undefined;
    sensorProcessedStart?: number | undefined;
    sensorProcessedEnd?: number | undefined;
}

export interface CoughAnalysisSetEvent extends CoughAnalysisSetEventCreation {
    analysisSet?: CoughAnalysisSet | undefined;
}

export interface CoughAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    primary?: boolean;
    qaDeadline?: string | undefined;
    analysisDeadline?: string | undefined;
}

export interface CoughAnalysisSet extends CoughAnalysisSetMutation {
    session?: Session | undefined;
    typeName?: string | undefined;
    statusName?: string | undefined;
    isLinkedAnalysisSet?: boolean;
    linksSourcedFromThis?: AnalysisSetLink[] | undefined;
    linksTargetingThis?: AnalysisSetLink[] | undefined;
    reviewRequired?: boolean;
    reviewComplete?: boolean;
    reviewStatus?: string | undefined;
    hasReOpenComments?: boolean;
    reOpenedDuringReview?: boolean;
    isSourceOfAnother?: boolean;
    analyst?: string | undefined;
    lastAnalyst?: string | undefined;
    analystLastChangedDateTime?: string | undefined;
    firstAnalyst?: string | undefined;
    firstAnalystAssignedDateTime?: string | undefined;
    visualInspectionStatusLastChanged?: string | undefined;
    qaAnalyst?: string | undefined;
    qaAnalystStageDateTime?: string | undefined;
    visualReview?: boolean;
    visualReviewAnalystSelectionId?: number | undefined;
    started?: string | undefined;
    firstComplete?: string | undefined;
    created?: string;
    modified?: string;
    sessionWaveform?: string | undefined;
}

export interface AnalysisSetLink {
    linkType?: string | undefined;
    linkTypeName?: string | undefined;
    name?: string | undefined;
    targetId?: string;
    targetStatus?: string | undefined;
    targetStatusName?: string | undefined;
    targetCreated?: string;
    targetCoughType?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughAnalysisSetEvent extends SingleResult {
    queryable?: CoughAnalysisSetEvent[] | undefined;
}

export interface QueryOfCoughAnalysisSet {
    value?: CoughAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughAnalysisSet extends SingleResult {
    queryable?: CoughAnalysisSet[] | undefined;
}

export interface QueryOfCoughEventType {
    value?: CoughEventType[] | undefined;
    "@odata.count"?: number;
}

export interface CoughEventType {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isPeriod?: boolean;
    defaultColor?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughEventType extends SingleResult {
    queryable?: CoughEventType[] | undefined;
}

export interface QueryOfCoughSession {
    value?: CoughSession[] | undefined;
    "@odata.count"?: number;
}

export interface CoughSessionMutation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    deviceType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    smokerType?: string | undefined;
    technician?: string | undefined;
    preSessionId?: string | undefined;
    serialNumber?: string | undefined;
    mediaSerialNumber?: string | undefined;
    softwareVersion?: string | undefined;
    softwareReference?: string | undefined;
    hardwareVersion?: string | undefined;
    recordingStart?: string | undefined;
    status?: string | undefined;
    suppressed?: boolean;
    configured?: boolean;
    postalTrackingNumber?: string | undefined;
    postalReceived?: string | undefined;
    primaryAnalysisSetIds?: string[] | undefined;
    uploadStartTime?: string | undefined;
    uploadEndTime?: string | undefined;
    uploadRecordingRetry?: number | undefined;
}

export interface CoughSessionCreation extends CoughSessionMutation {
}

export interface CoughSession extends CoughSessionCreation {
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    created?: string;
    modified?: string;
    lastReceived?: string | undefined;
    lastAnalysed?: string | undefined;
    uploadRecordingRetry?: number | undefined;
    statusName?: string | undefined;
    waveform?: string | undefined;
    rawDuration?: number | undefined;
    processedDuration?: number | undefined;
    sensorProcessedDuration?: number | undefined;
    availableForQualityCheckDateTime?: string | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: CoughAnalysisSet[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughSession extends SingleResult {
    queryable?: CoughSession[] | undefined;
}

export interface QueryOfCoughSessionStatus {
    value?: CoughSessionStatus[] | undefined;
    "@odata.count"?: number;
}

export interface CoughSessionStatus {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughSessionStatus extends SingleResult {
    queryable?: CoughSessionStatus[] | undefined;
}

export interface QueryOfCoughWaveformType {
    value?: CoughWaveformType[] | undefined;
    "@odata.count"?: number;
}

export interface CoughWaveformType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoughWaveformType extends SingleResult {
    queryable?: CoughWaveformType[] | undefined;
}

export interface QueryOfCountry {
    value?: Country[] | undefined;
    "@odata.count"?: number;
}

export interface Country {
    id?: string | undefined;
    name?: string | undefined;
    tollFreeNumber?: string | undefined;
    localPostalAddress?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCountry extends SingleResult {
    queryable?: Country[] | undefined;
}

export interface QueryOfCustomCalculation {
    value?: CustomCalculation[] | undefined;
    "@odata.count"?: number;
}

export interface CustomCalculationMutation {
    active?: boolean;
}

export interface CustomCalculationCreation extends CustomCalculationMutation {
    id?: string;
    pluginId?: string | undefined;
    pluginName?: string | undefined;
}

export interface CustomCalculation extends CustomCalculationCreation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCustomCalculation extends SingleResult {
    queryable?: CustomCalculation[] | undefined;
}

export interface QueryOfDataItemConfiguration {
    value?: DataItemConfiguration[] | undefined;
    "@odata.count"?: number;
}

export interface DataItemConfigurationMutation {
    minimumLength?: number | undefined;
    maximumLength?: number | undefined;
    minimumValue?: number | undefined;
    maximumValue?: number | undefined;
    formatId?: string | undefined;
    customFormat?: string | undefined;
    unitTypeId?: string | undefined;
    importanceId?: string | undefined;
    displayText?: string | undefined;
    prefixWithSiteNumber?: boolean;
    prefixDelimiter?: string | undefined;
}

export interface DataItemConfiguration extends DataItemConfigurationMutation {
    id?: string;
    studyId?: string;
    configurableDataItemId?: string | undefined;
    created?: string;
    modified?: string;
}

export interface DataItemConfigurationCreation extends DataItemConfigurationMutation {
    id?: string;
    studyId?: string;
    configurableDataItemId?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDataItemConfiguration extends SingleResult {
    queryable?: DataItemConfiguration[] | undefined;
}

export interface QueryOfDcfCorrectionType {
    value?: DcfCorrectionType[] | undefined;
    "@odata.count"?: number;
}

export interface DcfCorrectionType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDcfCorrectionType extends SingleResult {
    queryable?: DcfCorrectionType[] | undefined;
}

export interface QueryOfDcfRequest {
    value?: DcfRequest[] | undefined;
    "@odata.count"?: number;
}

export interface DcfRequestMutation {
    id?: string;
    entityId?: number;
    label?: string | undefined;
    status?: string | undefined;
    studyId?: string;
    siteId?: string | undefined;
    subjectId?: string | undefined;
    visitId?: string | undefined;
    sessionId?: string | undefined;
    created?: string;
    modified?: string;
    createdByUser?: string | undefined;
    siteApproved?: boolean;
    siteApprovedByUser?: string | undefined;
    siteApprovedAnnotation?: string | undefined;
    verificationReviewed?: boolean;
    verificationReviewedByUser?: string | undefined;
    verificationReviewedAnnotation?: string | undefined;
    actionedApproved?: boolean;
    actionedByUser?: string | undefined;
    actionedApprovedAnnotation?: string | undefined;
    additionalComments?: string | undefined;
    originalEntry?: string | undefined;
    newEntry?: string | undefined;
    corrections?: DcfCorrection[] | undefined;
}

export interface DcfRequest extends DcfRequestMutation {
    study?: Study | undefined;
    site?: Site | undefined;
    subject?: Subject | undefined;
    visit?: Visit | undefined;
    session?: Session | undefined;
    siteApprovedDateTime?: string | undefined;
    verificationReviewedDateTime?: string | undefined;
    actionedApprovedDateTime?: string | undefined;
    correctionTypeId?: string | undefined;
}

export interface DcfCorrection {
    id?: string;
    entity?: string | undefined;
    field?: string | undefined;
    requestId?: string;
    originalValue?: string | undefined;
    correctedValue?: string | undefined;
}

export interface DcfRequestCreation {
    id?: string;
    label?: string | undefined;
    studyId?: string;
    siteId?: string | undefined;
    subjectId?: string | undefined;
    sessionId?: string | undefined;
    visitId?: string | undefined;
    created?: string;
    createdByUser?: string | undefined;
    additionalComments?: string | undefined;
    originalEntry?: string | undefined;
    newEntry?: string | undefined;
    corrections?: DcfCorrection[] | undefined;
    correctionTypeId?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDcfRequest extends SingleResult {
    queryable?: DcfRequest[] | undefined;
}

export interface QueryOfDcfRequestStatus {
    value?: DcfRequestStatus[] | undefined;
    "@odata.count"?: number;
}

export interface DcfRequestStatus {
    id?: string | undefined;
    name?: string | undefined;
    order?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDcfRequestStatus extends SingleResult {
    queryable?: DcfRequestStatus[] | undefined;
}

export interface QueryOfDefinedReport {
    value?: DefinedReport[] | undefined;
    "@odata.count"?: number;
}

export interface DefinedReportMutation {
    path?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isWidget?: boolean;
    rolesIds?: string[] | undefined;
    parameters?: DefinedReportParameter[] | undefined;
}

export interface DefinedReport extends DefinedReportMutation {
    id?: string;
    created?: string;
    modified?: string;
    studyIds?: string[] | undefined;
}

export interface DefinedReportParameter {
    parameterTypeId?: string | undefined;
    name?: string | undefined;
}

export interface DefinedReportCreation extends DefinedReportMutation {
    id?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDefinedReport extends SingleResult {
    queryable?: DefinedReport[] | undefined;
}

export interface QueryOfDeviceAuditTrail {
    value?: DeviceAuditTrail[] | undefined;
    "@odata.count"?: number;
}

export interface DeviceAuditTrailCreation {
    id?: string;
    subjectId?: string | undefined;
    siteId?: string | undefined;
    deviceType?: string | undefined;
    serialNumber?: string | undefined;
    occurred?: string;
    code?: string | undefined;
    summary?: string | undefined;
    user?: string | undefined;
    annotation?: string | undefined;
    sequenceNumber?: string | undefined;
}

export interface DeviceAuditTrail extends DeviceAuditTrailCreation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDeviceAuditTrail extends SingleResult {
    queryable?: DeviceAuditTrail[] | undefined;
}

export interface DeviceConfiguration {
    resource?: DeviceConfigurationItem[] | undefined;
}

export interface DeviceConfigurationItem {
    content?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    version?: string | undefined;
    softwareFileChecksum?: string | undefined;
    softwareRevisionNumber?: number;
    softwareFileName?: string | undefined;
    text?: string | undefined;
}

export interface ConfigurationRequest {
    deviceType?: string | undefined;
    serialNumber?: string | undefined;
    subjectId?: string | undefined;
    timeZone?: string | undefined;
    studyId?: string | undefined;
    version?: string | undefined;
}

export interface QueryOfDevice {
    value?: Device[] | undefined;
    "@odata.count"?: number;
}

export interface DeviceMutation {
    studyId?: string;
    deviceType?: string | undefined;
    allocatedSiteId?: string | undefined;
    allocatedSubjectId?: string | undefined;
    spirotracPackageVersion?: string | undefined;
}

export interface DeviceCreation extends DeviceMutation {
    serialNumber?: string | undefined;
}

export interface Device extends DeviceCreation {
    id?: string;
    allocatedSite?: Site | undefined;
    allocatedSubject?: Subject | undefined;
    created?: string;
    modified?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDevice extends SingleResult {
    queryable?: Device[] | undefined;
}

export interface QueryOfDeviceType {
    value?: DeviceType[] | undefined;
    "@odata.count"?: number;
}

export interface DeviceType {
    id?: string | undefined;
    name?: string | undefined;
    serialNumberPrefix?: string | undefined;
    isPrefixOnDevice?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDeviceType extends SingleResult {
    queryable?: DeviceType[] | undefined;
}

export interface QueryOfDiaryCompliance {
    value?: DiaryCompliance[] | undefined;
    "@odata.count"?: number;
}

export interface DiaryComplianceMutation {
    id?: string;
    expected?: number;
    recorded?: number;
    duration?: number | undefined;
    occurred?: string;
    confirmed?: boolean;
    eDiarySessionComplianceIdentifier?: number;
    complianceName?: string | undefined;
}

export interface DiaryComplianceCreation extends DiaryComplianceMutation {
    sessionId?: string;
    complianceType?: number;
}

export interface DiaryCompliance extends DiaryComplianceCreation {
    session?: Session | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiaryCompliance extends SingleResult {
    queryable?: DiaryCompliance[] | undefined;
}

export interface QueryOfDiaryConfigurationFile {
    value?: DiaryConfigurationFile[] | undefined;
    "@odata.count"?: number;
}

export interface DiaryConfigurationFileCreation {
    name?: string | undefined;
    fileSizeInBytes?: number | undefined;
    contentType?: string | undefined;
    fileContent?: string | undefined;
    configurationId?: string;
}

export interface DiaryConfigurationFile extends DiaryConfigurationFileCreation {
    id?: string;
    createdDateTime?: string;
    lastModifiedDateTime?: string | undefined;
    eDiaryConfiguration?: DiaryConfiguration | undefined;
}

export interface DiaryConfigurationCreation {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
}

export interface DiaryConfiguration extends DiaryConfigurationCreation {
    studies?: Study[] | undefined;
    files?: DiaryConfigurationFile[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiaryConfigurationFile extends SingleResult {
    queryable?: DiaryConfigurationFile[] | undefined;
}

export interface QueryOfDiaryConfiguration {
    value?: DiaryConfiguration[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiaryConfiguration extends SingleResult {
    queryable?: DiaryConfiguration[] | undefined;
}

export interface QueryOfDiaryPackageDeployment {
    value?: DiaryPackageDeployment[] | undefined;
    "@odata.count"?: number;
}

export interface DiaryPackageDeploymentCreation {
    serialNumber?: string | undefined;
    sessionScheduleId?: string;
    subjectId?: string;
    visitId?: string;
}

export interface DiaryPackageDeployment extends DiaryPackageDeploymentCreation {
    id?: string;
    occurred?: string | undefined;
    visit?: Visit | undefined;
    sessionSchedule?: StudyScheduleSession | undefined;
}

export interface StudyScheduleSessionCreation {
    id?: string;
    studyScheduleVisitId?: string;
    preStudyScheduleSessionId?: string | undefined;
    startOfTestWindow?: string | undefined;
    endOfTestWindow?: string | undefined;
    resetDiaryOnUpload?: boolean | undefined;
    sessionTypeId?: string | undefined;
    deviceTypeId?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    rules?: string | undefined;
    ordinal?: number;
    disabled?: boolean;
    mandatory?: boolean;
    cohort?: string | undefined;
    rolling?: boolean;
    configurationSessionReference?: number | undefined;
    expectedMinimumQuestionnaires?: number | undefined;
    expectedMinimumTests?: number | undefined;
    includedInDailySummaryCompliance?: boolean | undefined;
    tags?: string | undefined;
    requireDoseTime?: boolean;
    group?: string | undefined;
    afterRandomisation?: boolean;
    visualReview?: boolean;
}

export interface StudyScheduleSession extends StudyScheduleSessionCreation {
    requiredSessions?: StudyScheduleSession[] | undefined;
    studyScheduleVisit?: StudyScheduleVisit | undefined;
    actions?: StudyScheduleSessionAction[] | undefined;
}

export interface StudyScheduleVisit {
    id?: string;
    studyScheduleId?: string;
    phaseId?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    ordinal?: number;
    disabled?: boolean;
    mandatory?: boolean;
    obligation?: string | undefined;
    spanDays?: boolean;
    commentRequired?: boolean;
    confirmationRequired?: boolean;
    cohort?: string | undefined;
    studySchedule?: StudySchedule | undefined;
    studyScheduleSessions?: StudyScheduleSession[] | undefined;
    requiredVisits?: StudyScheduleVisit[] | undefined;
    blockedByVisits?: StudyScheduleVisit[] | undefined;
}

export interface StudySchedule {
    id?: string;
    studyId?: string;
    created?: string;
    modified?: string;
    studyScheduleVisits?: StudyScheduleVisit[] | undefined;
}

export interface StudyScheduleSessionAction {
    id?: string;
    studyScheduleSessionId?: string;
    studyScheduleSession?: StudyScheduleSession | undefined;
    actionType?: number;
    actionValue?: string | undefined;
    displayOrder?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiaryPackageDeployment extends SingleResult {
    queryable?: DiaryPackageDeployment[] | undefined;
}

export interface QueryOfDiaryResourceString {
    value?: DiaryResourceString[] | undefined;
    "@odata.count"?: number;
}

export interface DiaryResourceString {
    id?: string;
    fileId?: string;
    file?: DiaryConfigurationFile | undefined;
    typeId?: string | undefined;
    parentResourceId?: string | undefined;
    resourceIndex?: string | undefined;
    value?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiaryResourceString extends SingleResult {
    queryable?: DiaryResourceString[] | undefined;
}

export interface QueryOfDiarySession {
    value?: DiarySession[] | undefined;
    "@odata.count"?: number;
}

export interface DiarySessionMutation {
    serialNumber?: string | undefined;
    applicationVersion?: string | undefined;
    occurred?: string | undefined;
    batteryLevel?: number;
    accuracyChecked?: string | undefined;
    pefRepeatable?: boolean | undefined;
    pefRepeatability?: number | undefined;
}

export interface DiarySession extends DiarySessionMutation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    notes?: SessionNote[] | undefined;
    tests?: DiaryTest[] | undefined;
    questionnaires?: QuestionnaireTest[] | undefined;
}

export interface DiaryTestMutation {
    index?: number;
    accepted?: boolean;
    qualityIndicators?: number;
    fvc?: number | undefined;
    pef?: number | undefined;
    fev1?: number | undefined;
    bev?: number | undefined;
    fet?: number | undefined;
    tExt?: number | undefined;
    tPef?: number | undefined;
    occurred?: string;
}

export interface DiaryTestCreation extends DiaryTestMutation {
    id?: string;
    sessionId?: string;
}

export interface DiaryTest extends DiaryTestCreation {
    session?: DiarySession | undefined;
}

export interface QuestionnaireTestMutation {
    score?: number | undefined;
    symptomScore?: number | undefined;
    activityLimitationScore?: number | undefined;
    emotionalFunctionScore?: number | undefined;
    environmentalScore?: number | undefined;
}

export interface QuestionnaireTest extends QuestionnaireTestMutation {
    id?: string;
    sessionId?: string;
    session?: Session | undefined;
    questionnaireId?: string;
    name?: string | undefined;
    occurred?: string;
    answers?: QuestionnaireTestAnswer[] | undefined;
}

export interface QuestionnaireTestAnswerMutation {
    answerWeight?: number;
    answer?: string | undefined;
}

export interface QuestionnaireTestAnswerCreation extends QuestionnaireTestAnswerMutation {
    id?: string;
    questionnaireTestId?: string;
    questionIndex?: string | undefined;
    questionText?: string | undefined;
    answerIndex?: string | undefined;
    answerText?: string | undefined;
}

export interface QuestionnaireTestAnswer extends QuestionnaireTestAnswerCreation {
    questionnaireTest?: QuestionnaireTest | undefined;
}

export interface DiarySessionCreation extends DiarySessionMutation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    tests?: DiaryTestCreation[] | undefined;
    questionnaires?: QuestionnaireTestCreation[] | undefined;
}

export interface QuestionnaireTestCreation extends QuestionnaireTestMutation {
    id?: string;
    sessionId?: string;
    questionnaireId?: string;
    name?: string | undefined;
    occurred?: string;
    answers?: QuestionnaireTestAnswerCreation[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiarySession extends SingleResult {
    queryable?: DiarySession[] | undefined;
}

export interface QueryOfDiaryTest {
    value?: DiaryTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDiaryTest extends SingleResult {
    queryable?: DiaryTest[] | undefined;
}

export interface QueryOfFileViewModel {
    value?: FileViewModel[] | undefined;
    "@odata.count"?: number;
}

export interface FileViewModel {
    icon?: string | undefined;
    name?: string | undefined;
    lastWriteTimeUtc?: string | undefined;
    lastWriteTime?: string;
    directoryName?: string | undefined;
    size?: string | undefined;
    length?: number;
    fullPath?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFileViewModel extends SingleResult {
    queryable?: FileViewModel[] | undefined;
}

export interface QueryOfDlcoAnalysisSet {
    value?: DlcoAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface DlcoAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestDlco?: number | undefined;
    bestDlcoCorr?: number | undefined;
    bestVa?: number | undefined;
    bestKco?: number | undefined;
}

export interface DlcoAnalysisSet extends DlcoAnalysisSetMutation {
    started?: string;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    user?: string | undefined;
    canEdit?: boolean;
    tests?: DlcoAnalysisSetTest[] | undefined;
}

export interface DlcoAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface DlcoAnalysisSetTest extends DlcoAnalysisSetTestMutation {
}

export interface AnalysisSetTestFixedComment {
    analysisSetTestId?: string;
    fixedCommentId?: string;
    followOnComment?: string | undefined;
}

export interface AnalysisSetFixedComment {
    analysisSetId?: string;
    fixedCommentId?: string;
    followOnComment?: string | undefined;
}

export interface DlcoAnalysisSetCreation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestDlco?: number | undefined;
    bestDlcoCorr?: number | undefined;
    bestVa?: number | undefined;
    bestKco?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDlcoAnalysisSet extends SingleResult {
    queryable?: DlcoAnalysisSet[] | undefined;
}

export interface QueryOfDlcoAnalysisSetTest {
    value?: DlcoAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDlcoAnalysisSetTest extends SingleResult {
    queryable?: DlcoAnalysisSetTest[] | undefined;
}

export interface QueryOfCalculationMethod {
    value?: CalculationMethod[] | undefined;
    "@odata.count"?: number;
}

export interface CalculationMethod {
    id?: number;
    description?: string | undefined;
}

export interface QueryOfDlcoSession {
    value?: DlcoSession[] | undefined;
    "@odata.count"?: number;
}

export interface DlcoSessionMutation {
    visitId?: string;
    subjectId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
    hb?: number | undefined;
    predictedDlco?: number | undefined;
    predictedKco?: number | undefined;
    predictedVa?: number | undefined;
    predictedFiv1?: number | undefined;
    predictedBht?: number | undefined;
    predictedDlcoCorr?: number | undefined;
}

export interface DlcoSession extends DlcoSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    lastReceived?: string | undefined;
    testsCount?: number;
    tests?: DlcoTest[] | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: DlcoAnalysisSet[] | undefined;
}

export interface DlcoTestMutation {
    index?: number;
    occurred?: string;
    fvcSessionId?: string;
    testTypeId?: string | undefined;
    dlco?: number | undefined;
    kco?: number | undefined;
    va?: number | undefined;
    iv?: number | undefined;
    bht?: number | undefined;
    dlcoCorr?: number | undefined;
}

export interface DlcoTest extends DlcoTestMutation {
    id?: string;
    sessionId?: string;
}

export interface DlcoSessionCreation {
    id?: string;
    visitId?: string;
    subjectId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    hb?: number | undefined;
    predictedDlco?: number | undefined;
    predictedKco?: number | undefined;
    predictedVa?: number | undefined;
    predictedFiv1?: number | undefined;
    predictedBht?: number | undefined;
    predictedDlcoCorr?: number | undefined;
    tests?: DlcoTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface DlcoTestCreation extends DlcoTestMutation {
    id?: string;
    sessionId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDlcoSession extends SingleResult {
    queryable?: DlcoSession[] | undefined;
}

export interface QueryOfDlcoTest {
    value?: DlcoTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfDlcoTest extends SingleResult {
    queryable?: DlcoTest[] | undefined;
}

export interface QueryOfEcgAnalysisSet {
    value?: EcgAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface EcgAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    started?: string | undefined;
}

export interface EcgAnalysisSet extends EcgAnalysisSetMutation {
    created?: string;
    modified?: string;
    session?: EcgSession | undefined;
    tests?: EcgAnalysisSetTest[] | undefined;
    batchId?: string | undefined;
}

export interface EcgSessionMutation {
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    hrAvg?: number | undefined;
    qtcFriAvg?: number | undefined;
    qtcFraAvg?: number | undefined;
    qtcBazAvg?: number | undefined;
    qtcHodAvg?: number | undefined;
    rrAvg?: number | undefined;
    prAvg?: number | undefined;
    pqAvg?: number | undefined;
    qrsAvg?: number | undefined;
    qtAvg?: number | undefined;
    pAvg?: number | undefined;
    stAvg?: number | undefined;
}

export interface EcgSession extends EcgSessionMutation {
    id?: string;
    deviceType?: string | undefined;
    sessionType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: EcgTest[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface EcgTestMutation {
    index?: number;
    duration?: number;
    hr?: number | undefined;
    p?: number | undefined;
    qrs?: number | undefined;
    pr?: number | undefined;
    pq?: number | undefined;
    st?: number | undefined;
    qt?: number | undefined;
    rr?: number | undefined;
    qtcFri?: number | undefined;
    qtcFra?: number | undefined;
    qtcBaz?: number | undefined;
    qtcHod?: number | undefined;
    sampleRate?: number;
    scale?: number;
    leadI?: string | undefined;
    leadII?: string | undefined;
    leadIII?: string | undefined;
    leadAvr?: string | undefined;
    leadAvl?: string | undefined;
    leadAvf?: string | undefined;
    leadV1?: string | undefined;
    leadV2?: string | undefined;
    leadV3?: string | undefined;
    leadV4?: string | undefined;
    leadV5?: string | undefined;
    leadV6?: string | undefined;
    pAxis?: number | undefined;
    qrsAxis?: number | undefined;
    tAxis?: number | undefined;
    representativeLeadI?: string | undefined;
    representativeLeadII?: string | undefined;
    representativeLeadIII?: string | undefined;
    representativeLeadAvr?: string | undefined;
    representativeLeadAvl?: string | undefined;
    representativeLeadAvf?: string | undefined;
    representativeLeadV1?: string | undefined;
    representativeLeadV2?: string | undefined;
    representativeLeadV3?: string | undefined;
    representativeLeadV4?: string | undefined;
    representativeLeadV5?: string | undefined;
    representativeLeadV6?: string | undefined;
    analysisStatement?: string | undefined;
    diagnosticStatement?: string | undefined;
    summaryStatement?: string | undefined;
    occurred?: string;
    currentFilters?: string | undefined;
}

export interface EcgTest extends EcgTestMutation {
    id?: string;
    sessionId?: string;
    session?: EcgSession | undefined;
    created?: string;
    modified?: string;
}

export interface EcgAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean | undefined;
    annotations?: EcgAnalysisSetTestAnnotation[] | undefined;
    ampsAnnotationsTextBase64?: string | undefined;
    rr?: number | undefined;
    hr?: number | undefined;
    qTcBaz?: number | undefined;
    qTcFri?: number | undefined;
    qTcFra?: number | undefined;
    qTcHod?: number | undefined;
    analystId?: string | undefined;
    analysisCompleted?: string | undefined;
    intepretations?: AnalysisSetTestFixedComment[] | undefined;
    alerts?: AnalysisSetTestFixedComment[] | undefined;
}

export interface EcgAnalysisSetTest extends EcgAnalysisSetTestMutation {
    test?: EcgTest | undefined;
    analysisSet?: EcgAnalysisSet | undefined;
    analyst?: string | undefined;
}

export interface EcgAnalysisSetTestAnnotation {
    annotation?: string | undefined;
    leadIndex?: number;
    beatIndex?: number;
    value?: number | undefined;
}

export interface EcgAnalysisSetCreation extends EcgAnalysisSetMutation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfEcgAnalysisSet extends SingleResult {
    queryable?: EcgAnalysisSet[] | undefined;
}

export interface QueryOfEcgAnalysisSetTest {
    value?: EcgAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfEcgAnalysisSetTest extends SingleResult {
    queryable?: EcgAnalysisSetTest[] | undefined;
}

export interface QueryOfEcgAnalysisSetType {
    value?: EcgAnalysisSetType[] | undefined;
    "@odata.count"?: number;
}

export interface EcgAnalysisSetType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfEcgAnalysisSetType extends SingleResult {
    queryable?: EcgAnalysisSetType[] | undefined;
}

export interface QueryOfEcgSession {
    value?: EcgSession[] | undefined;
    "@odata.count"?: number;
}

export interface EcgSessionCreation {
    id?: string;
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    tests?: EcgTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
    hrAvg?: number | undefined;
    qtcFriAvg?: number | undefined;
    qtcFraAvg?: number | undefined;
    qtcBazAvg?: number | undefined;
    qtcHodAvg?: number | undefined;
    rrAvg?: number | undefined;
    prAvg?: number | undefined;
    pqAvg?: number | undefined;
    qrsAvg?: number | undefined;
    qtAvg?: number | undefined;
    pAvg?: number | undefined;
    stAvg?: number | undefined;
}

export interface EcgTestCreation {
    id?: string;
    sessionId?: string;
    index?: number;
    duration?: number;
    hr?: number | undefined;
    p?: number | undefined;
    qrs?: number | undefined;
    pr?: number | undefined;
    pq?: number | undefined;
    st?: number | undefined;
    qt?: number | undefined;
    rr?: number | undefined;
    qtcFri?: number | undefined;
    qtcFra?: number | undefined;
    qtcBaz?: number | undefined;
    qtcHod?: number | undefined;
    sampleRate?: number;
    scale?: number;
    leadI?: string | undefined;
    leadII?: string | undefined;
    leadIII?: string | undefined;
    leadAvr?: string | undefined;
    leadAvl?: string | undefined;
    leadAvf?: string | undefined;
    leadV1?: string | undefined;
    leadV2?: string | undefined;
    leadV3?: string | undefined;
    leadV4?: string | undefined;
    leadV5?: string | undefined;
    leadV6?: string | undefined;
    representativeLeadI?: string | undefined;
    representativeLeadII?: string | undefined;
    representativeLeadIII?: string | undefined;
    representativeLeadAvr?: string | undefined;
    representativeLeadAvl?: string | undefined;
    representativeLeadAvf?: string | undefined;
    representativeLeadV1?: string | undefined;
    representativeLeadV2?: string | undefined;
    representativeLeadV3?: string | undefined;
    representativeLeadV4?: string | undefined;
    representativeLeadV5?: string | undefined;
    representativeLeadV6?: string | undefined;
    pAxis?: number | undefined;
    qrsAxis?: number | undefined;
    tAxis?: number | undefined;
    analysisStatement?: string | undefined;
    diagnosticStatement?: string | undefined;
    summaryStatement?: string | undefined;
    occurred?: string;
    currentFilters?: string | undefined;
}

export interface DynamicObject {
}

/** Base class for the Delta resource */
export interface Delta extends DynamicObject {
    /** DeltaKind for the objects part of the DeltaResourceSet Payload. */
    Kind?: DeltaItemKind;
}

/** A class the tracks changes (i.e. the Delta) for a particular . */
export interface DeltaOfEcgSession extends Delta {
    /** DeltaKind for the objects part of the DeltaResourceSet Payload. */
    Kind?: DeltaItemKind;
    /** Gets the actual type of the structural object for which the changes are tracked. */
    StructuredType?: string | undefined;
    /** Gets the expected type of the entity for which the changes are tracked. */
    ExpectedClrType?: string | undefined;
    /** The list of property names that can be updated. */
    UpdatableProperties?: string[] | undefined;
    /** If the StructuralType is a Complex type. */
    IsComplexType?: boolean;
}

/** The Kind of the object within the DeltaPayload used to distinguish between Resource/DeletedResource/DeltaDeletedLink/AddedLink. */
export enum DeltaItemKind {
    Resource = 0,
    DeletedResource = 1,
    DeltaDeletedLink = 2,
    DeltaLink = 3,
    Unknown = 4,
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfEcgSession extends SingleResult {
    queryable?: EcgSession[] | undefined;
}

export interface QueryOfEcgTest {
    value?: EcgTest[] | undefined;
    "@odata.count"?: number;
}

/** A class the tracks changes (i.e. the Delta) for a particular . */
export interface DeltaOfEcgTest extends Delta {
    /** DeltaKind for the objects part of the DeltaResourceSet Payload. */
    Kind?: DeltaItemKind;
    /** Gets the actual type of the structural object for which the changes are tracked. */
    StructuredType?: string | undefined;
    /** Gets the expected type of the entity for which the changes are tracked. */
    ExpectedClrType?: string | undefined;
    /** The list of property names that can be updated. */
    UpdatableProperties?: string[] | undefined;
    /** If the StructuralType is a Complex type. */
    IsComplexType?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfEcgTest extends SingleResult {
    queryable?: EcgTest[] | undefined;
}

export interface QueryOfFenoQC {
    value?: FenoQC[] | undefined;
    "@odata.count"?: number;
}

export interface FenoQCMutation {
    occurred?: string;
    goodTest?: boolean | undefined;
    childMode?: boolean | undefined;
    feno?: number | undefined;
    serialNumber?: string | undefined;
    sensorSerialNumber?: string | undefined;
    appBuild?: string | undefined;
    appVersion?: string | undefined;
    botBuild?: string | undefined;
    botVersion?: string | undefined;
    counter?: number | undefined;
    errorCodes?: string | undefined;
    remainingMeasurements?: string | undefined;
    technician?: string | undefined;
    alertNumber?: number | undefined;
    movingMeanDay1?: number | undefined;
    movingMeanDay2?: number | undefined;
    movingMeanDay3?: number | undefined;
    status?: string | undefined;
}

export interface FenoQC extends FenoQCMutation {
    id?: string;
    created?: string;
    modified?: string;
}

export interface FenoQCCreation {
    id?: string;
    occurred?: string;
    goodTest?: boolean | undefined;
    childMode?: boolean | undefined;
    feno?: number | undefined;
    serialNumber?: string | undefined;
    sensorSerialNumber?: string | undefined;
    appBuild?: string | undefined;
    appVersion?: string | undefined;
    botBuild?: string | undefined;
    botVersion?: string | undefined;
    counter?: number | undefined;
    errorCodes?: string | undefined;
    remainingMeasurements?: string | undefined;
    technician?: string | undefined;
    alertNumber?: number | undefined;
    movingMeanDay1?: number | undefined;
    movingMeanDay2?: number | undefined;
    movingMeanDay3?: number | undefined;
    status?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFenoQC extends SingleResult {
    queryable?: FenoQC[] | undefined;
}

export interface QueryOfFenoSession {
    value?: FenoSession[] | undefined;
    "@odata.count"?: number;
}

export interface FenoSessionMutation {
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    goodSession?: boolean | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bestFirstTestId?: string | undefined;
    bestSecondTestId?: string | undefined;
    variance?: number | undefined;
    mean?: number | undefined;
    qcAcceptStatus?: number | undefined;
    qcRepeatStatus?: number | undefined;
    best?: number | undefined;
}

export interface FenoSession extends FenoSessionMutation {
    id?: string;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: FenoTest[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface FenoTestMutation {
    index?: number;
    feno?: number | undefined;
    goodTest?: boolean | undefined;
    childMode?: boolean | undefined;
    serialNumber?: string | undefined;
    sensorSerialNumber?: string | undefined;
    appBuild?: string | undefined;
    appVersion?: string | undefined;
    botBuild?: string | undefined;
    botVersion?: string | undefined;
    counter?: number | undefined;
    alertNumber?: number | undefined;
    errorCodes?: string | undefined;
    dailyQCPassed?: number | undefined;
    deviceExpiryDate?: string | undefined;
    deviceRemainingTests?: number | undefined;
    sensorExpiryDate?: string | undefined;
    sensorRemainingTests?: number | undefined;
    handleScrubberExpiryDate?: string | undefined;
    handleScrubberRemainingTests?: number | undefined;
    occurred?: string;
}

export interface FenoTest extends FenoTestMutation {
    id?: string;
    sessionId?: string;
    session?: FenoSession | undefined;
    created?: string;
    modified?: string;
}

export interface FenoSessionCreation {
    id?: string;
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    goodSession?: boolean | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    tests?: FenoTestCreation[] | undefined;
    notes?: SessionNoteCreation[] | undefined;
    bestFirstTestId?: string | undefined;
    bestSecondTestId?: string | undefined;
    variance?: number | undefined;
    mean?: number | undefined;
    qcAcceptStatus?: number | undefined;
    qcRepeatStatus?: number | undefined;
    best?: number | undefined;
}

export interface FenoTestCreation {
    id?: string;
    sessionId?: string;
    index?: number;
    feno?: number | undefined;
    goodTest?: boolean | undefined;
    childMode?: boolean | undefined;
    serialNumber?: string | undefined;
    sensorSerialNumber?: string | undefined;
    appBuild?: string | undefined;
    appVersion?: string | undefined;
    botBuild?: string | undefined;
    botVersion?: string | undefined;
    counter?: number | undefined;
    alertNumber?: number | undefined;
    errorCodes?: string | undefined;
    dailyQCPassed?: number | undefined;
    deviceExpiryDate?: string | undefined;
    deviceRemainingTests?: number | undefined;
    sensorExpiryDate?: string | undefined;
    sensorRemainingTests?: number | undefined;
    handleScrubberExpiryDate?: string | undefined;
    handleScrubberRemainingTests?: number | undefined;
    occurred?: string;
}

export interface SessionNoteCreation {
    id?: string;
    sessionId?: string;
    userEmailAddress?: string | undefined;
    comment?: string | undefined;
    recorded?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFenoSession extends SingleResult {
    queryable?: FenoSession[] | undefined;
}

export interface QueryOfFenoTest {
    value?: FenoTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFenoTest extends SingleResult {
    queryable?: FenoTest[] | undefined;
}

export interface QueryOfFileAttachment {
    value?: FileAttachment[] | undefined;
    "@odata.count"?: number;
}

export interface FileAttachment {
    id?: string;
    relatedEntityId?: number;
    fileId?: number;
    file?: File | undefined;
}

export interface FileCreation {
    fileName?: string | undefined;
    fileSizeInBytes?: number | undefined;
    contentType?: string | undefined;
    fileContent?: string | undefined;
    studyIds?: string[] | undefined;
}

export interface File extends FileCreation {
    id?: string;
    downloadLink?: string | undefined;
    fullFilePath?: string | undefined;
    lastModified?: string | undefined;
    studies?: StudyFile[] | undefined;
    fileEntityAttachments?: FileAttachment[] | undefined;
}

export interface StudyFile {
    studyId?: string;
    fileId?: string;
    study?: Study | undefined;
    file?: File | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFileAttachment extends SingleResult {
    queryable?: FileAttachment[] | undefined;
}

export interface QueryOfFile {
    value?: File[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFile extends SingleResult {
    queryable?: File[] | undefined;
}

export interface FileUpload {
    id?: string;
    startPosition?: number;
    filePart?: string | undefined;
    totalSize?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFileUpload extends SingleResult {
    queryable?: FileUpload[] | undefined;
}

export interface QueryOfFixedComment {
    value?: FixedComment[] | undefined;
    "@odata.count"?: number;
}

export interface FixedCommentCreation {
    id?: string;
    setId?: string;
    comment?: string | undefined;
    description?: string | undefined;
    followOnCommentAvailable?: boolean;
    followOnCommentRequired?: boolean;
    followOnCommentAnnotation?: string | undefined;
    disabled?: boolean;
    displayOrder?: number;
}

export interface FixedComment extends FixedCommentCreation {
    mask?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFixedComment extends SingleResult {
    queryable?: FixedComment[] | undefined;
}

export interface QueryOfFixedCommentSetEntityType {
    value?: FixedCommentSetEntityType[] | undefined;
    "@odata.count"?: number;
}

export interface FixedCommentSetEntityType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFixedCommentSetEntityType extends SingleResult {
    queryable?: FixedCommentSetEntityType[] | undefined;
}

export interface QueryOfFixedCommentSet {
    value?: FixedCommentSet[] | undefined;
    "@odata.count"?: number;
}

export interface FixedCommentSet {
    id?: string;
    studySetId?: string;
    studySet?: StudyFixedCommentSet | undefined;
    entityType?: string | undefined;
    defaultCommentId?: string | undefined;
    defaultComment?: FixedComment | undefined;
    comments?: FixedComment[] | undefined;
}

export interface StudyFixedCommentSet {
    id?: string;
    studyId?: string;
    sessionType?: string | undefined;
    commentSetType?: string | undefined;
    fixedCommentSets?: FixedCommentSet[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFixedCommentSet extends SingleResult {
    queryable?: FixedCommentSet[] | undefined;
}

export interface QueryOfFixedCommentSetType {
    value?: FixedCommentSetType[] | undefined;
    "@odata.count"?: number;
}

export interface FixedCommentSetType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFixedCommentSetType extends SingleResult {
    queryable?: FixedCommentSetType[] | undefined;
}

export interface QueryOfFvcSession {
    value?: FvcSession[] | undefined;
    "@odata.count"?: number;
}

export interface FvcSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    lastCalibrationId?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    doseAmount?: number | undefined;
    doseTime?: string | undefined;
    preSessionId?: string | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
    predictedFev1?: number | undefined;
    predictedFvc?: number | undefined;
    predictedFev1Fvc?: number | undefined;
    predictedPefMin?: number | undefined;
    predictedPefSec?: number | undefined;
    predictedFef2575?: number | undefined;
    predictedFev6?: number | undefined;
    predictedFev6Fvc?: number | undefined;
    predictedFef75?: number | undefined;
    predictedFef2575Fvc?: number | undefined;
    predictedSvc?: number | undefined;
    predictedFev05?: number | undefined;
    predictedFev05Fvc?: number | undefined;
    predictedFev075?: number | undefined;
    predictedFev075Fvc?: number | undefined;
    predictedFev1Pef?: number | undefined;
    predictedFev3?: number | undefined;
    predictedFev3Fvc?: number | undefined;
    predictedFef0212?: number | undefined;
    predictedFef7585?: number | undefined;
    predictedFef25?: number | undefined;
    predictedFef50?: number | undefined;
    predictedFivc?: number | undefined;
    predictedFivcFvc?: number | undefined;
    predictedPifMin?: number | undefined;
    predictedPifSec?: number | undefined;
    predictedFif25?: number | undefined;
    predictedFif50?: number | undefined;
    predictedFif75?: number | undefined;
    predictedFifFef50?: number | undefined;
    predictedFmft?: number | undefined;
    predictedIc?: number | undefined;
    predictedMvvind?: number | undefined;
    predictedFrc?: number | undefined;
    predictedRv?: number | undefined;
    predictedTlc?: number | undefined;
    predictedErv?: number | undefined;
    predictedFev1R?: number | undefined;
    predictedFet?: number | undefined;
    predictedIrv?: number | undefined;
    predictedTv?: number | undefined;
    predictedFiv1?: number | undefined;
    predictedEOTV?: number | undefined;
    predictedEv?: number | undefined;
    predictedEvFvc?: number | undefined;
    predictedFef50Fif50?: number | undefined;
    predictedFefMax?: number | undefined;
    predictedFev1Fev6?: number | undefined;
    predictedFev1Fivc?: number | undefined;
    predictedFev1Ht2?: number | undefined;
    predictedFev1Ivc?: number | undefined;
    predictedFev1Q?: number | undefined;
    predictedFev1Vc?: number | undefined;
    predictedFev3Vc?: number | undefined;
    predictedFiv1Fivc?: number | undefined;
    predictedFiv1Fvc?: number | undefined;
    predictedIvc?: number | undefined;
    predictedRawind?: number | undefined;
    predictedRisetime?: number | undefined;
    predictedText?: number | undefined;
    predictedThes?: number | undefined;
    predictedTpef?: number | undefined;
    predictedIfr?: number | undefined;
    siteFev1AbsoluteRepeatability?: number | undefined;
    siteFvcAbsoluteRepeatability?: number | undefined;
    siteFvcPercentageRepeatability?: number | undefined;
    siteFev1PercentageRepeatability?: number | undefined;
    status?: string | undefined;
    llnFvc?: number | undefined;
    llnFev1?: number | undefined;
    llnFev1Fvc?: number | undefined;
    llnPef?: number | undefined;
    llnFef2575?: number | undefined;
    fev1Drop?: number | undefined;
}

export interface FvcSession extends FvcSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    lastReceived?: string | undefined;
    tests?: FvcTest[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
    analysisSets?: FvcAnalysisSet[] | undefined;
}

export interface FvcTestMutation {
    index?: number;
    startOfTestQuality?: string | undefined;
    flowPlateauQuality?: string | undefined;
    coughFreeQuality?: string | undefined;
    eofeQuality?: string | undefined;
    fivcFvcQuality?: string | undefined;
    fev1Quality?: string | undefined;
    fvcQuality?: string | undefined;
    occurred?: string;
    sampleRate?: number;
    volumeData?: string | undefined;
    volumeDataLength?: number;
    flowData?: string | undefined;
    timeData?: string | undefined;
    duration?: number;
    testDurationQuality?: string | undefined;
    fvc?: number | undefined;
    fev1?: number | undefined;
    fev3?: number | undefined;
    fev6?: number | undefined;
    fev05?: number | undefined;
    fev075?: number | undefined;
    pefSec?: number | undefined;
    pefMin?: number | undefined;
    pifSec?: number | undefined;
    pifMin?: number | undefined;
    bev?: number | undefined;
    fef2575?: number | undefined;
    tPef?: number | undefined;
    fet?: number | undefined;
    fivc?: number | undefined;
    fev1Fev6?: number | undefined;
    fev1Fvc?: number | undefined;
    fev05Fvc?: number | undefined;
    tv?: number | undefined;
    irv?: number | undefined;
    erv?: number | undefined;
    ic?: number | undefined;
    fev075Fvc?: number | undefined;
    fev3Fvc?: number | undefined;
    fev6Fvc?: number | undefined;
    fef0212?: number | undefined;
    fef2575Fvc?: number | undefined;
    fef7585?: number | undefined;
    fivcFvc?: number | undefined;
    fef75?: number | undefined;
    fef25?: number | undefined;
    fef50?: number | undefined;
    fif25?: number | undefined;
    fif50?: number | undefined;
    fif75?: number | undefined;
    fev1Pef?: number | undefined;
    fif50Fef50?: number | undefined;
    fiv1?: number | undefined;
    fev1Fivc?: number | undefined;
    fiv1Fivc?: number | undefined;
    fiv1Fvc?: number | undefined;
    fef50Fif50?: number | undefined;
    mvvInd?: number | undefined;
    eotv?: number | undefined;
    fmft?: number | undefined;
    fev1Ivc?: number | undefined;
    ivc?: number | undefined;
    tExt?: number | undefined;
    tZero?: number | undefined;
    tHes?: number | undefined;
    fefMax?: number | undefined;
    evFvc?: number | undefined;
    vc?: number | undefined;
    fev1Vc?: number | undefined;
    fev1R?: number | undefined;
    tRise?: number | undefined;
    fev1Q?: number | undefined;
    ifr?: number | undefined;
    fev1Ht2?: number | undefined;
    fev3Vc?: number | undefined;
    frc?: number | undefined;
    rawind?: number | undefined;
    rv?: number | undefined;
    tlc?: number | undefined;
}

export interface FvcTest extends FvcTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface FvcAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    bestFev1?: number | undefined;
    bestFvc?: number | undefined;
    bestPefMin?: number | undefined;
    bestFef2575?: number | undefined;
    bestFev1Fvc?: number | undefined;
    bestFef25?: number | undefined;
    bestFef50?: number | undefined;
    bestFef75?: number | undefined;
    bestFev6?: number | undefined;
    fev1Grade?: string | undefined;
    fvcGrade?: string | undefined;
    bestFev1Q?: number | undefined;
    fev1Bdr?: number | undefined;
    fvcBdr?: number | undefined;
    fev1ReversibilityAbsoluteChange?: number | undefined;
    fev1ReversibilityPercentageChange?: number | undefined;
    percentBaselineFev1?: number | undefined;
    percentBaselineDropFev1?: number | undefined;
    user?: string | undefined;
    bestEOTV?: number | undefined;
    bestErv?: number | undefined;
    bestEv?: number | undefined;
    bestEvFvc?: number | undefined;
    bestFef0212?: number | undefined;
    bestFef2575Fvc?: number | undefined;
    bestFef50Fif50?: number | undefined;
    bestFef7585?: number | undefined;
    bestFefMax?: number | undefined;
    bestFet?: number | undefined;
    bestFev05?: number | undefined;
    bestFev05Fvc?: number | undefined;
    bestFev075?: number | undefined;
    bestFev075Fvc?: number | undefined;
    bestFev1Fev6?: number | undefined;
    bestFev1Fivc?: number | undefined;
    bestFev1Ht2?: number | undefined;
    bestFev1Ivc?: number | undefined;
    bestFev1Pef?: number | undefined;
    bestFev1R?: number | undefined;
    bestFev1Vc?: number | undefined;
    bestFev3?: number | undefined;
    bestFev3Fvc?: number | undefined;
    bestFev3Vc?: number | undefined;
    bestFif25?: number | undefined;
    bestFif50?: number | undefined;
    bestFif50Fef50?: number | undefined;
    bestFif75?: number | undefined;
    bestFiv1?: number | undefined;
    bestFiv1Fivc?: number | undefined;
    bestFiv1Fvc?: number | undefined;
    bestFivc?: number | undefined;
    bestFivcFvc?: number | undefined;
    bestFmft?: number | undefined;
    bestFrc?: number | undefined;
    bestIc?: number | undefined;
    bestIrv?: number | undefined;
    bestIvc?: number | undefined;
    bestMvvind?: number | undefined;
    bestPefSec?: number | undefined;
    bestPifMin?: number | undefined;
    bestPifSec?: number | undefined;
    bestRawind?: number | undefined;
    bestRisetime?: number | undefined;
    bestRv?: number | undefined;
    bestText?: number | undefined;
    bestThes?: number | undefined;
    bestTlc?: number | undefined;
    bestTpef?: number | undefined;
    bestTv?: number | undefined;
    bestFev6Fvc?: number | undefined;
    bestIfr?: number | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
}

export interface FvcAnalysisSet extends FvcAnalysisSetMutation {
    fev1AbsoluteRepeatability?: number | undefined;
    fvcAbsoluteRepeatability?: number | undefined;
    started?: string;
    created?: string;
    modified?: string;
    firstCompleted?: string | undefined;
    session?: Session | undefined;
    tests?: FvcAnalysisSetTest[] | undefined;
    analystUserId?: string;
    canEdit?: boolean;
}

export interface FvcAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
    repeatabilityFvcAbsolute?: number | undefined;
    repeatabilityFvcPercentage?: number | undefined;
    repeatabilityFev1Absolute?: number | undefined;
    repeatabilityFev1Percentage?: number | undefined;
    repeatabilityPefAbsolute?: number | undefined;
    repeatabilityPefPercentage?: number | undefined;
}

export interface FvcAnalysisSetTest extends FvcAnalysisSetTestMutation {
    test?: FvcTest | undefined;
}

export interface FvcSessionCreation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    lastCalibrationId?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    doseAmount?: number | undefined;
    doseTime?: string | undefined;
    preSessionId?: string | undefined;
    predictedFev1?: number | undefined;
    predictedFvc?: number | undefined;
    predictedFev1Fvc?: number | undefined;
    predictedPefMin?: number | undefined;
    predictedPefSec?: number | undefined;
    predictedFef2575?: number | undefined;
    predictedFev6?: number | undefined;
    predictedFev6Fvc?: number | undefined;
    predictedFef75?: number | undefined;
    predictedFef2575Fvc?: number | undefined;
    predictedSvc?: number | undefined;
    predictedFev05?: number | undefined;
    predictedFev05Fvc?: number | undefined;
    predictedFev075?: number | undefined;
    predictedFev075Fvc?: number | undefined;
    predictedFev1Pef?: number | undefined;
    predictedFev3?: number | undefined;
    predictedFev3Fvc?: number | undefined;
    predictedFef0212?: number | undefined;
    predictedFef7585?: number | undefined;
    predictedFef25?: number | undefined;
    predictedFef50?: number | undefined;
    predictedFivc?: number | undefined;
    predictedFivcFvc?: number | undefined;
    predictedPifMin?: number | undefined;
    predictedPifSec?: number | undefined;
    predictedFif25?: number | undefined;
    predictedFif50?: number | undefined;
    predictedFif75?: number | undefined;
    predictedFifFef50?: number | undefined;
    predictedFmft?: number | undefined;
    predictedIc?: number | undefined;
    predictedMvvind?: number | undefined;
    predictedFrc?: number | undefined;
    predictedRv?: number | undefined;
    predictedTlc?: number | undefined;
    predictedErv?: number | undefined;
    predictedFev1R?: number | undefined;
    predictedFet?: number | undefined;
    predictedIrv?: number | undefined;
    predictedTv?: number | undefined;
    predictedFiv1?: number | undefined;
    siteFev1AbsoluteRepeatability?: number | undefined;
    siteFvcAbsoluteRepeatability?: number | undefined;
    siteFvcPercentageRepeatability?: number | undefined;
    siteFev1PercentageRepeatability?: number | undefined;
    status?: string | undefined;
    llnFvc?: number | undefined;
    llnFev1?: number | undefined;
    llnFev1Fvc?: number | undefined;
    llnPef?: number | undefined;
    llnFef2575?: number | undefined;
    fev1Drop?: number | undefined;
    tests?: FvcTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
    predictedEOTV?: number | undefined;
    predictedEv?: number | undefined;
    predictedEvFvc?: number | undefined;
    predictedFef50Fif50?: number | undefined;
    predictedFefMax?: number | undefined;
    predictedFev1Fev6?: number | undefined;
    predictedFev1Fivc?: number | undefined;
    predictedFev1Ht2?: number | undefined;
    predictedFev1Ivc?: number | undefined;
    predictedFev1Q?: number | undefined;
    predictedFev1Vc?: number | undefined;
    predictedFev3Vc?: number | undefined;
    predictedFiv1Fivc?: number | undefined;
    predictedFiv1Fvc?: number | undefined;
    predictedIvc?: number | undefined;
    predictedRawind?: number | undefined;
    predictedRisetime?: number | undefined;
    predictedText?: number | undefined;
    predictedThes?: number | undefined;
    predictedTpef?: number | undefined;
    predictedIfr?: number | undefined;
}

export interface FvcTestCreation {
    id?: string;
    sessionId?: string;
    index?: number;
    startOfTestQuality?: string | undefined;
    flowPlateauQuality?: string | undefined;
    coughFreeQuality?: string | undefined;
    eofeQuality?: string | undefined;
    fivcFvcQuality?: string | undefined;
    fev1Quality?: string | undefined;
    fvcQuality?: string | undefined;
    occurred?: string;
    sampleRate?: number;
    volumeData?: string | undefined;
    volumeDataLength?: number;
    flowData?: string | undefined;
    timeData?: string | undefined;
    duration?: number;
    fvc?: number | undefined;
    fev1?: number | undefined;
    fev3?: number | undefined;
    fev6?: number | undefined;
    fev05?: number | undefined;
    fev075?: number | undefined;
    pefSec?: number | undefined;
    pefMin?: number | undefined;
    pifSec?: number | undefined;
    pifMin?: number | undefined;
    bev?: number | undefined;
    fef2575?: number | undefined;
    tPef?: number | undefined;
    fet?: number | undefined;
    fivc?: number | undefined;
    fev1Fev6?: number | undefined;
    fev1Fvc?: number | undefined;
    fev05Fvc?: number | undefined;
    tv?: number | undefined;
    irv?: number | undefined;
    erv?: number | undefined;
    ic?: number | undefined;
    fev075Fvc?: number | undefined;
    fev3Fvc?: number | undefined;
    fev6Fvc?: number | undefined;
    fef0212?: number | undefined;
    fef2575Fvc?: number | undefined;
    fef7585?: number | undefined;
    fivcFvc?: number | undefined;
    fef75?: number | undefined;
    fef25?: number | undefined;
    fef50?: number | undefined;
    fif25?: number | undefined;
    fif50?: number | undefined;
    fif75?: number | undefined;
    fev1Pef?: number | undefined;
    fif50Fef50?: number | undefined;
    fiv1?: number | undefined;
    fev1Fivc?: number | undefined;
    fiv1Fivc?: number | undefined;
    fiv1Fvc?: number | undefined;
    fef50Fif50?: number | undefined;
    mvvInd?: number | undefined;
    eotv?: number | undefined;
    fmft?: number | undefined;
    fev1Ivc?: number | undefined;
    ivc?: number | undefined;
    tExt?: number | undefined;
    testDurationQuality?: string | undefined;
    tZero?: number | undefined;
    tHes?: number | undefined;
    fefMax?: number | undefined;
    evFvc?: number | undefined;
    vc?: number | undefined;
    fev1Vc?: number | undefined;
    fev1R?: number | undefined;
    tRise?: number | undefined;
    fev1Q?: number | undefined;
    ifr?: number | undefined;
    fev1Ht2?: number | undefined;
    fev3Vc?: number | undefined;
    frc?: number | undefined;
    rawind?: number | undefined;
    rv?: number | undefined;
    tlc?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFvcSession extends SingleResult {
    queryable?: FvcSession[] | undefined;
}

export interface QueryOfFvcTest {
    value?: FvcTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFvcTest extends SingleResult {
    queryable?: FvcTest[] | undefined;
}

export interface QueryOfLanguage {
    value?: Language[] | undefined;
    "@odata.count"?: number;
}

export interface Language {
    id?: string | undefined;
    name?: string | undefined;
    localeName?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfLanguage extends SingleResult {
    queryable?: Language[] | undefined;
}

export interface QueryOfLungVolumeAnalysisSet {
    value?: LungVolumeAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface LungVolumeAnalysisSetMutation {
    started?: string | undefined;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    analyst?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestFrc?: number | undefined;
    bestTlc?: number | undefined;
    bestRv?: number | undefined;
    bestIc?: number | undefined;
    bestVc?: number | undefined;
    bestErv?: number | undefined;
    bestRvTlc?: number | undefined;
}

export interface LungVolumeAnalysisSet extends LungVolumeAnalysisSetMutation {
    id?: string;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    analystId?: string | undefined;
    analystEmail?: string | undefined;
    canEdit?: boolean;
    tests?: LungVolumeAnalysisSetTest[] | undefined;
}

export interface LungVolumeAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface LungVolumeAnalysisSetTest extends LungVolumeAnalysisSetTestMutation {
}

export interface LungVolumeAnalysisSetCreation extends LungVolumeAnalysisSetMutation {
    id?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfLungVolumeAnalysisSet extends SingleResult {
    queryable?: LungVolumeAnalysisSet[] | undefined;
}

export interface QueryOfLungVolumeAnalysisSetTest {
    value?: LungVolumeAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfLungVolumeAnalysisSetTest extends SingleResult {
    queryable?: LungVolumeAnalysisSetTest[] | undefined;
}

export interface QueryOfLungVolumeSession {
    value?: LungVolumeSession[] | undefined;
    "@odata.count"?: number;
}

export interface LungVolumeSessionMutation {
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    predictedFrc?: number | undefined;
    predictedTlc?: number | undefined;
    predictedRv?: number | undefined;
    predictedIc?: number | undefined;
    predictedVc?: number | undefined;
    predictedErv?: number | undefined;
    predictedRvTlc?: number | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
}

export interface LungVolumeSession extends LungVolumeSessionMutation {
    id?: string;
    analysisSetId?: string;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: LungVolumeTest[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
    status?: string | undefined;
    overreader?: string | undefined;
    received?: string;
    analysisSets?: LungVolumeAnalysisSet[] | undefined;
}

export interface LungVolumeTestMutation {
    testNumber?: number;
    pantingFrequency?: number | undefined;
    occurred?: string;
    frc?: number | undefined;
    tlc?: number | undefined;
    rv?: number | undefined;
    ic?: number | undefined;
    vc?: number | undefined;
    erv?: number | undefined;
    rvTlc?: number | undefined;
}

export interface LungVolumeTest extends LungVolumeTestMutation {
    id?: string;
    sessionId?: string;
    session?: LungVolumeSession | undefined;
    created?: string;
    modified?: string;
}

export interface LungVolumeSessionCreation extends LungVolumeSessionMutation {
    id?: string;
    tests?: LungVolumeTestCreation[] | undefined;
    notes?: SessionNoteCreation[] | undefined;
}

export interface LungVolumeTestCreation extends LungVolumeTestMutation {
    id?: string;
    sessionId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfLungVolumeSession extends SingleResult {
    queryable?: LungVolumeSession[] | undefined;
}

export interface QueryOfLungVolumeTest {
    value?: LungVolumeTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfLungVolumeTest extends SingleResult {
    queryable?: LungVolumeTest[] | undefined;
}

export interface QueryOfMappedServerDirectory {
    value?: MappedServerDirectory[] | undefined;
    "@odata.count"?: number;
}

export interface MappedServerDirectory {
    id?: string;
    serverDirectory?: string | undefined;
    name?: string | undefined;
    userRoles?: string[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMappedServerDirectory extends SingleResult {
    queryable?: MappedServerDirectory[] | undefined;
}

export interface QueryOfMedicationRecord {
    value?: MedicationRecord[] | undefined;
    "@odata.count"?: number;
}

export interface MedicationRecordMutation {
    dateTime?: string;
    medication?: string | undefined;
    dose?: number;
    unitType?: string | undefined;
}

export interface MedicationRecord extends MedicationRecordMutation {
    id?: string;
    testId?: string;
}

export interface MedicationRecordCreation extends MedicationRecord {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMedicationRecord extends SingleResult {
    queryable?: MedicationRecord[] | undefined;
}

export interface QueryOfMepAnalysisSet {
    value?: MepAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface PressureAnalysisSetMutation {
    status?: string | undefined;
    started?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
}

export interface MepAnalysisSetMutation extends PressureAnalysisSetMutation {
    bestMep?: number | undefined;
    bestPep?: number | undefined;
}

export interface MepAnalysisSet extends MepAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    analyst?: string | undefined;
    analystId?: string | undefined;
    canEdit?: boolean;
    tests?: MepAnalysisSetTest[] | undefined;
}

export interface PressureAnalysisSetTestMutation {
    accepted?: boolean;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface MepAnalysisSetTestMutation extends PressureAnalysisSetTestMutation {
    mipMepRepeatability?: number | undefined;
    mipMepRepeatabilityPercent?: number | undefined;
}

export interface MepAnalysisSetTest extends MepAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    test?: MepTest | undefined;
    analysisSetId?: string;
}

export interface PressureTestMutation {
    index?: number;
    occurred?: string;
    shortDurationQuality?: string | undefined;
    sampleRate?: number;
    pressureData?: string | undefined;
    timeData?: string | undefined;
}

export interface MepTestMutation extends PressureTestMutation {
    mep?: number | undefined;
    pep?: number | undefined;
}

export interface MepTest extends MepTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface MepAnalysisSetCreation extends MepAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    analyst?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMepAnalysisSet extends SingleResult {
    queryable?: MepAnalysisSet[] | undefined;
}

export interface QueryOfMepAnalysisSetTest {
    value?: MepAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

export interface MepAnalysisSetTestCreation extends MepAnalysisSetTest {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMepAnalysisSetTest extends SingleResult {
    queryable?: MepAnalysisSetTest[] | undefined;
}

export interface QueryOfMepSession {
    value?: MepSession[] | undefined;
    "@odata.count"?: number;
}

export interface PressureSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    softwareReference?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
}

export interface MepSessionMutation extends PressureSessionMutation {
    predictedMep?: number | undefined;
}

export interface MepSession extends MepSessionMutation {
    id?: string;
    analysisSetId?: string;
    visit?: Visit | undefined;
    sessionTypeId?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    received?: string | undefined;
    tests?: MepTest[] | undefined;
    testsCount?: number;
    status?: string | undefined;
    overreader?: string | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: PressureAnalysisSet[] | undefined;
}

export interface PressureAnalysisSet extends PressureAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    analyst?: string | undefined;
    analystId?: string | undefined;
    canEdit?: boolean;
    tests?: PressureAnalysisSetTest[] | undefined;
}

export interface PressureAnalysisSetTest extends PressureAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    test?: PressureTest | undefined;
    analysisSetId?: string;
}

export interface PressureTest extends PressureTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface MepSessionCreation extends MepSessionMutation {
    id?: string;
    tests?: MepTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface MepTestCreation extends MepTestMutation {
    id?: string;
    sessionId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMepSession extends SingleResult {
    queryable?: MepSession[] | undefined;
}

export interface QueryOfMepTest {
    value?: MepTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMepTest extends SingleResult {
    queryable?: MepTest[] | undefined;
}

export interface QueryOfMipAnalysisSet {
    value?: MipAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface MipAnalysisSetMutation extends PressureAnalysisSetMutation {
    bestMip?: number | undefined;
    bestPip?: number | undefined;
}

export interface MipAnalysisSet extends MipAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    analyst?: string | undefined;
    analystId?: string | undefined;
    canEdit?: boolean;
    tests?: MipAnalysisSetTest[] | undefined;
}

export interface MipAnalysisSetTestMutation extends PressureAnalysisSetTestMutation {
    mipMepRepeatability?: number | undefined;
    mipMepRepeatabilityPercent?: number | undefined;
}

export interface MipAnalysisSetTest extends MipAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    test?: MipTest | undefined;
    analysisSetId?: string;
}

export interface MipTestMutation extends PressureTestMutation {
    mip?: number | undefined;
    pip?: number | undefined;
}

export interface MipTest extends MipTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface MipAnalysisSetCreation extends MipAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    analyst?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMipAnalysisSet extends SingleResult {
    queryable?: MipAnalysisSet[] | undefined;
}

export interface QueryOfMipAnalysisSetTest {
    value?: MipAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

export interface MipAnalysisSetTestCreation extends MipAnalysisSetTest {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMipAnalysisSetTest extends SingleResult {
    queryable?: MipAnalysisSetTest[] | undefined;
}

export interface QueryOfMipSession {
    value?: MipSession[] | undefined;
    "@odata.count"?: number;
}

export interface MipSessionMutation extends PressureSessionMutation {
    predictedMip?: number | undefined;
}

export interface MipSession extends MipSessionMutation {
    id?: string;
    analysisSetId?: string;
    visit?: Visit | undefined;
    sessionTypeId?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    received?: string | undefined;
    tests?: MipTest[] | undefined;
    testsCount?: number;
    status?: string | undefined;
    overreader?: string | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: PressureAnalysisSet[] | undefined;
}

export interface MipSessionCreation extends MipSessionMutation {
    id?: string;
    tests?: MipTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface MipTestCreation extends MipTestMutation {
    id?: string;
    sessionId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMipSession extends SingleResult {
    queryable?: MipSession[] | undefined;
}

export interface QueryOfMipTest {
    value?: MipTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMipTest extends SingleResult {
    queryable?: MipTest[] | undefined;
}

export interface QueryOfMiscField {
    value?: MiscField[] | undefined;
    "@odata.count"?: number;
}

export interface MiscFieldMuation {
    value?: string | undefined;
}

export interface MiscField extends MiscFieldMuation {
    id?: string;
    entityTypeName?: string | undefined;
    recordId?: string;
    fieldName?: string | undefined;
}

export interface MiscFieldCreation {
    id?: string;
    entityTypeName?: string | undefined;
    recordId?: string;
    fieldName?: string | undefined;
    value?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfMiscField extends SingleResult {
    queryable?: MiscField[] | undefined;
}

export interface QueryOfNotificationSubscription {
    value?: NotificationSubscription[] | undefined;
    "@odata.count"?: number;
}

export interface NotificationSubscriptionMutation extends NotificationSubscriptionCreation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfNotificationSubscription extends SingleResult {
    queryable?: NotificationSubscription[] | undefined;
}

export interface QueryOfOscillometryAnalysisSet {
    value?: OscillometryAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface OscillometryAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestR5?: number | undefined;
    bestR20?: number | undefined;
    bestR5R20?: number | undefined;
    bestAx?: number | undefined;
    bestR7?: number | undefined;
    bestR7R20?: number | undefined;
    bestFres?: number | undefined;
    bestX5?: number | undefined;
    bestVt?: number | undefined;
    averageR5?: number | undefined;
    averageR20?: number | undefined;
    averageR5R20?: number | undefined;
    averageR7?: number | undefined;
    averageR7R20?: number | undefined;
    averageX5?: number | undefined;
    averageAx?: number | undefined;
    averageVt?: number | undefined;
    averageFres?: number | undefined;
    zR5?: number | undefined;
    zR20?: number | undefined;
    zR5R20?: number | undefined;
    zAx?: number | undefined;
    zR7?: number | undefined;
    zR7R20?: number | undefined;
    zX5?: number | undefined;
    cvAx?: number | undefined;
    cvVt?: number | undefined;
    cvR5?: number | undefined;
    percentPredictedR5?: number | undefined;
    percentPredictedR20?: number | undefined;
    percentPredictedR5R20?: number | undefined;
    percentPredictedAx?: number | undefined;
    percentPredictedR7?: number | undefined;
    percentPredictedR7R20?: number | undefined;
    percentPredictedX5?: number | undefined;
    percentPredictedFres?: number | undefined;
}

export interface OscillometryAnalysisSet extends OscillometryAnalysisSetMutation {
    started?: string;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    analyst?: string | undefined;
    canEdit?: boolean;
    tests?: OscillometryAnalysisSetTest[] | undefined;
}

export interface OscillometryAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface OscillometryAnalysisSetTest extends OscillometryAnalysisSetTestMutation {
}

export interface OscillometryAnalysisSetCreation {
    id?: string;
    started?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestR5?: number | undefined;
    bestR20?: number | undefined;
    bestR5R20?: number | undefined;
    bestAx?: number | undefined;
    bestR7?: number | undefined;
    bestR7R20?: number | undefined;
    bestFres?: number | undefined;
    bestX5?: number | undefined;
    bestVt?: number | undefined;
    averageR5?: number | undefined;
    averageR20?: number | undefined;
    averageR5R20?: number | undefined;
    averageR7?: number | undefined;
    averageR7R20?: number | undefined;
    averageX5?: number | undefined;
    averageAx?: number | undefined;
    averageVt?: number | undefined;
    averageFres?: number | undefined;
    zR5?: number | undefined;
    zR20?: number | undefined;
    zR5R20?: number | undefined;
    zAx?: number | undefined;
    zR7?: number | undefined;
    zR7R20?: number | undefined;
    zX5?: number | undefined;
    cvAx?: number | undefined;
    cvVt?: number | undefined;
    cvR5?: number | undefined;
    percentPredictedR5?: number | undefined;
    percentPredictedR20?: number | undefined;
    percentPredictedR5R20?: number | undefined;
    percentPredictedAx?: number | undefined;
    percentPredictedR7?: number | undefined;
    percentPredictedR7R20?: number | undefined;
    percentPredictedX5?: number | undefined;
    percentPredictedFres?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfOscillometryAnalysisSet extends SingleResult {
    queryable?: OscillometryAnalysisSet[] | undefined;
}

export interface QueryOfOscillometryAnalysisSetTest {
    value?: OscillometryAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

export interface OscillometryAnalysisSetTestCreation extends OscillometryAnalysisSetTest {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfOscillometryAnalysisSetTest extends SingleResult {
    queryable?: OscillometryAnalysisSetTest[] | undefined;
}

export interface QueryOfOscillometrySession {
    value?: OscillometrySession[] | undefined;
    "@odata.count"?: number;
}

export interface OscillometrySessionMutation {
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bmi?: number | undefined;
    predictedR5?: number | undefined;
    predictedR20?: number | undefined;
    predictedR5R20?: number | undefined;
    predictedAx?: number | undefined;
    predictedR7?: number | undefined;
    predictedR7R20?: number | undefined;
    predictedX5?: number | undefined;
    predictedFres?: number | undefined;
    cvAx?: number | undefined;
    cvR5?: number | undefined;
    cvR7?: number | undefined;
}

export interface OscillometrySession extends OscillometrySessionMutation {
    id?: string;
    analysisSetId?: string;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    visit?: Visit | undefined;
    tests?: OscillometryTest[] | undefined;
    testsCount?: number;
    notes?: SessionNote[] | undefined;
    status?: string | undefined;
    overreader?: string | undefined;
}

export interface OscillometryTestMutation {
    testNumber?: number;
    shortDurationQuality?: string | undefined;
    occurred?: string;
    r5?: number | undefined;
    r20?: number | undefined;
    r5R20?: number | undefined;
    ax?: number | undefined;
    r7?: number | undefined;
    r7R20?: number | undefined;
    x5?: number | undefined;
    fres?: number | undefined;
    vt?: number | undefined;
}

export interface OscillometryTest extends OscillometryTestMutation {
    id?: string;
    sessionId?: string;
    session?: OscillometrySession | undefined;
    created?: string;
    modified?: string;
}

export interface OscillometrySessionCreation {
    id?: string;
    visitId?: string;
    preSessionId?: string | undefined;
    populationGroupId?: string | undefined;
    name?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    hardwareVersion?: string | undefined;
    softwareVersion?: string | undefined;
    technician?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    ulna?: number | undefined;
    smokerType?: string | undefined;
    postureType?: string | undefined;
    medicationType?: string | undefined;
    occurred?: string;
    bmi?: number | undefined;
    tests?: OscillometryTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
    predictedR5?: number | undefined;
    predictedR20?: number | undefined;
    predictedR5R20?: number | undefined;
    predictedAx?: number | undefined;
    predictedR7?: number | undefined;
    predictedR7R20?: number | undefined;
    predictedX5?: number | undefined;
    predictedFres?: number | undefined;
    cvAx?: number | undefined;
    cvR5?: number | undefined;
    cvR7?: number | undefined;
}

export interface OscillometryTestCreation {
    id?: string;
    sessionId?: string;
    testNumber?: number;
    shortDurationQuality?: string | undefined;
    occurred?: string;
    r5?: number | undefined;
    r20?: number | undefined;
    r5R20?: number | undefined;
    ax?: number | undefined;
    r7?: number | undefined;
    r7R20?: number | undefined;
    x5?: number | undefined;
    fres?: number | undefined;
    vt?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfOscillometrySession extends SingleResult {
    queryable?: OscillometrySession[] | undefined;
}

export interface QueryOfOscillometryTest {
    value?: OscillometryTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfOscillometryTest extends SingleResult {
    queryable?: OscillometryTest[] | undefined;
}

export interface QueryOfOverreadChallengeStatus {
    value?: OverreadChallengeStatus[] | undefined;
    "@odata.count"?: number;
}

export interface OverreadChallengeStatus {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfOverreadChallengeStatus extends SingleResult {
    queryable?: OverreadChallengeStatus[] | undefined;
}

export interface QueryOfOverreadStatus {
    value?: OverreadStatus[] | undefined;
    "@odata.count"?: number;
}

export interface OverreadStatus {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfOverreadStatus extends SingleResult {
    queryable?: OverreadStatus[] | undefined;
}

export interface QueryOfParameter {
    value?: Parameter[] | undefined;
    "@odata.count"?: number;
}

export interface Parameter {
    id?: string | undefined;
    decimalPlaces?: number;
    unitName?: string | undefined;
    legacyId?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfParameter extends SingleResult {
    queryable?: Parameter[] | undefined;
}

export interface QueryOfPcfAnalysisSet {
    value?: PcfAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface PcfAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    bestPcf?: number | undefined;
    bestPcfMin?: number | undefined;
    pcfAbsoluteRepeatability?: number | undefined;
    pcfPercentageRepeatability?: number | undefined;
}

export interface PcfAnalysisSet extends PcfAnalysisSetMutation {
    started?: string;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    tests?: PcfAnalysisSetTest[] | undefined;
}

export interface PcfAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean | undefined;
}

export interface PcfAnalysisSetTest extends PcfAnalysisSetTestMutation {
}

export interface PcfAnalysisSetCreation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    bestPcf?: number | undefined;
    bestPcfMin?: number | undefined;
    pcfAbsoluteRepeatability?: number | undefined;
    pcfPercentageRepeatability?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPcfAnalysisSet extends SingleResult {
    queryable?: PcfAnalysisSet[] | undefined;
}

export interface QueryOfPcfAnalysisSetTest {
    value?: PcfAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

export interface PcfAnalysisSetTestCreation extends PcfAnalysisSetTest {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPcfAnalysisSetTest extends SingleResult {
    queryable?: PcfAnalysisSetTest[] | undefined;
}

export interface QueryOfPcfSession {
    value?: PcfSession[] | undefined;
    "@odata.count"?: number;
}

export interface PcfSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    lastCalibrationId?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    predictedPcf?: number | undefined;
}

export interface PcfSession extends PcfSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    tests?: PcfTest[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface PcfTestMutation {
    index?: number;
    occurred?: string;
    flowDataLength?: number;
    flowData?: string | undefined;
    sampleRate?: number;
    duration?: number;
    pcf?: number | undefined;
    pcfMin?: number | undefined;
}

export interface PcfTest extends PcfTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface PcfSessionCreation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    lastCalibrationId?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    predictedPcf?: number | undefined;
    tests?: PcfTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface PcfTestCreation {
    id?: string;
    sessionId?: string;
    index?: number;
    occurred?: string;
    sampleRate?: number;
    flowDataLength?: number;
    flowData?: string | undefined;
    duration?: number;
    pcf?: number | undefined;
    pcfMin?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPcfSession extends SingleResult {
    queryable?: PcfSession[] | undefined;
}

export interface QueryOfPcfTest {
    value?: PcfTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPcfTest extends SingleResult {
    queryable?: PcfTest[] | undefined;
}

export interface QueryOfPefAnalysisSet {
    value?: PefAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface PefAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    bestPefSec?: number | undefined;
    bestPefMin?: number | undefined;
    pefAbsoluteRepeatability?: number | undefined;
    pefPercentageRepeatability?: number | undefined;
    analyst?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    batchId?: string | undefined;
}

export interface PefAnalysisSet extends PefAnalysisSetMutation {
    started?: string | undefined;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    tests?: PefAnalysisSetTest[] | undefined;
    analystUserName?: string | undefined;
    firstCompleted?: string | undefined;
    canEdit?: boolean;
}

export interface PefAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean | undefined;
    repeatabilityPefAbsolute?: number | undefined;
    repeatabilityPefPercentage?: number | undefined;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface PefAnalysisSetTest extends PefAnalysisSetTestMutation {
    test?: PefTest | undefined;
}

export interface PefTestMutation {
    index?: number;
    occurred?: string;
    flowDataLength?: number;
    flowData?: string | undefined;
    sampleRate?: number;
    volumeData?: string | undefined;
    volumeDataLength?: number;
    duration?: number;
    startOfTestQuality?: string | undefined;
    coughFreeQuality?: string | undefined;
    pefMin?: number | undefined;
    pefSec?: number | undefined;
    tPef?: number | undefined;
    tidalPef?: number | undefined;
    tRise?: number | undefined;
}

export interface PefTest extends PefTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface PefAnalysisSetCreation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    bestPefMin?: number | undefined;
    bestPefSec?: number | undefined;
    pefAbsoluteRepeatability?: number | undefined;
    pefPercentageRepeatability?: number | undefined;
    analyst?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    batchId?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPefAnalysisSet extends SingleResult {
    queryable?: PefAnalysisSet[] | undefined;
}

export interface QueryOfPefAnalysisSetTest {
    value?: PefAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

export interface PefAnalysisSetTestCreation extends PefAnalysisSetTest {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPefAnalysisSetTest extends SingleResult {
    queryable?: PefAnalysisSetTest[] | undefined;
}

export interface QueryOfPefSession {
    value?: PefSession[] | undefined;
    "@odata.count"?: number;
}

export interface PefSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    predictedPefMin?: number | undefined;
    predictedPefSec?: number | undefined;
    lastCalibrationId?: string | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
}

export interface PefSession extends PefSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    tests?: PefTest[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface PefSessionCreation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    predictedPefMin?: number | undefined;
    predictedPefSec?: number | undefined;
    lastCalibrationId?: string | undefined;
    tests?: PefTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface PefTestCreation {
    id?: string;
    sessionId?: string;
    index?: number;
    occurred?: string;
    sampleRate?: number;
    flowDataLength?: number;
    flowData?: string | undefined;
    duration?: number;
    startOfTestQuality?: string | undefined;
    coughFreeQuality?: string | undefined;
    volumeData?: string | undefined;
    volumeDataLength?: number;
    pefMin?: number | undefined;
    pefSec?: number | undefined;
    tPef?: number | undefined;
    tidalPef?: number | undefined;
    tRise?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPefSession extends SingleResult {
    queryable?: PefSession[] | undefined;
}

export interface QueryOfPefTest {
    value?: PefTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPefTest extends SingleResult {
    queryable?: PefTest[] | undefined;
}

export interface QueryOfPermissionCategory {
    value?: PermissionCategory[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPermissionCategory extends SingleResult {
    queryable?: PermissionCategory[] | undefined;
}

export interface QueryOfPermission {
    value?: Permission[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPermission extends SingleResult {
    queryable?: Permission[] | undefined;
}

export interface QueryOfPhase {
    value?: Phase[] | undefined;
    "@odata.count"?: number;
}

export interface Phase {
    id?: string | undefined;
    name?: string | undefined;
    displayOrder?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPhase extends SingleResult {
    queryable?: Phase[] | undefined;
}

export interface QueryOfPopulationGroup {
    value?: PopulationGroup[] | undefined;
    "@odata.count"?: number;
}

export interface PopulationGroup {
    id?: string;
    name?: string | undefined;
    race?: string | undefined;
    raceName?: string | undefined;
    predictedSetId?: string | undefined;
    predictedSetKey?: string | undefined;
    correctionFactor?: number;
    studyId?: string;
    isDisabled?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPopulationGroup extends SingleResult {
    queryable?: PopulationGroup[] | undefined;
}

export interface QueryOfPredictedSet {
    value?: PredictedSet[] | undefined;
    "@odata.count"?: number;
}

export interface PredictedSet {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPredictedSet extends SingleResult {
    queryable?: PredictedSet[] | undefined;
}

export interface QueryOfPulseOximetryAnalysisSet {
    value?: PulseOximetryAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface PulseOximetryAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
}

export interface PulseOximetryAnalysisSet extends PulseOximetryAnalysisSetMutation {
    started?: string;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    tests?: PulseOximetryAnalysisSetTest[] | undefined;
}

export interface PulseOximetryAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean;
}

export interface PulseOximetryAnalysisSetTest extends PulseOximetryAnalysisSetTestMutation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPulseOximetryAnalysisSet extends SingleResult {
    queryable?: PulseOximetryAnalysisSet[] | undefined;
}

export interface QueryOfPulseOximetryAnalysisSetTest {
    value?: PulseOximetryAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPulseOximetryAnalysisSetTest extends SingleResult {
    queryable?: PulseOximetryAnalysisSetTest[] | undefined;
}

export interface QueryOfPulseOximetrySession {
    value?: PulseOximetrySession[] | undefined;
    "@odata.count"?: number;
}

export interface PulseOximetrySessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    serialNumber?: string | undefined;
    gender?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
}

export interface PulseOximetrySession extends PulseOximetrySessionMutation {
    id?: string;
    visit?: Visit | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    hardwareVersion?: string | undefined;
    tests?: PulseOximetryTest[] | undefined;
    subjectComments?: string | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: PulseOximetryAnalysisSet[] | undefined;
}

export interface PulseOximetryTestMutation {
    id?: string;
    index?: number;
    sessionId?: string;
    created?: string;
    modified?: string;
    endOfTestReached?: boolean;
    occurred?: string;
    duration?: number | undefined;
    spO2Min?: number | undefined;
    spO2Max?: number | undefined;
    spO2Mean?: number | undefined;
    spO2Median?: number | undefined;
    bpMin?: number | undefined;
    bpMax?: number | undefined;
    bpMean?: number | undefined;
    bpMedian?: number | undefined;
    spo2Percent?: number | undefined;
    percentComplete?: number | undefined;
    hr?: number | undefined;
    postureType?: string | undefined;
}

export interface PulseOximetryTest extends PulseOximetryTestMutation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPulseOximetrySession extends SingleResult {
    queryable?: PulseOximetrySession[] | undefined;
}

export interface QueryOfPulseOximetryTest {
    value?: PulseOximetryTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfPulseOximetryTest extends SingleResult {
    queryable?: PulseOximetryTest[] | undefined;
}

export interface QueryOfQuestionnaireTestAnswer {
    value?: QuestionnaireTestAnswer[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfQuestionnaireTestAnswer extends SingleResult {
    queryable?: QuestionnaireTestAnswer[] | undefined;
}

export interface QueryOfQuestionnaireTest {
    value?: QuestionnaireTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfQuestionnaireTest extends SingleResult {
    queryable?: QuestionnaireTest[] | undefined;
}

export interface QueryOfCoreRace {
    value?: CoreRace[] | undefined;
    "@odata.count"?: number;
}

export interface CoreRace {
    id?: number;
    name?: string | undefined;
    coreRaceKey?: string | undefined;
    externalCode?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfCoreRace extends SingleResult {
    queryable?: CoreRace[] | undefined;
}

export interface QueryOfRole {
    value?: Role[] | undefined;
    "@odata.count"?: number;
}

export interface RoleCreation extends RoleMutation {
    id?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfRole extends SingleResult {
    queryable?: Role[] | undefined;
}

export interface QueryOfServiceResourceCreation {
    value?: ServiceResourceCreation[] | undefined;
    "@odata.count"?: number;
}

export interface ServiceResourceMutation {
    name?: string | undefined;
    description?: string | undefined;
    deviceType?: string | undefined;
    softwareFileName?: string | undefined;
    softwareVersion?: string | undefined;
    softwareType?: string | undefined;
    subType?: string | undefined;
    revisionNumber?: number;
    createdDateTime?: string;
    lastModifiedDateTime?: string;
}

export interface ServiceResourceCreation extends ServiceResourceMutation {
    id?: string;
    studyId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfServiceResourceCreation extends SingleResult {
    queryable?: ServiceResourceCreation[] | undefined;
}

export interface QueryOfSessionAttachment {
    value?: SessionAttachment[] | undefined;
    "@odata.count"?: number;
}

export interface SessionAttachment {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    size?: number;
    content?: string | undefined;
    sessionId?: string;
    session?: SessionFile | undefined;
    createdDate?: string;
    modifiedDate?: string;
}

export interface SessionFile {
    sessionId?: string;
    fileId?: string;
    session?: Session | undefined;
    file?: File | undefined;
}

export interface SessionAttachmentMutation {
    name?: string | undefined;
    contentType?: string | undefined;
    content?: string | undefined;
}

export interface SessionAttachmentCreation extends SessionAttachmentMutation {
    id?: string;
    sessionId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSessionAttachment extends SingleResult {
    queryable?: SessionAttachment[] | undefined;
}

export interface QueryOfSessionNote {
    value?: SessionNote[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSessionNote extends SingleResult {
    queryable?: SessionNote[] | undefined;
}

export interface QueryOfSession {
    value?: Session[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSession extends SingleResult {
    queryable?: Session[] | undefined;
}

export interface QueryOfSessionType {
    value?: SessionType[] | undefined;
    "@odata.count"?: number;
}

export interface SessionType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSessionType extends SingleResult {
    queryable?: SessionType[] | undefined;
}

export interface PatchSetting {
    key?: string | undefined;
    value?: string | undefined;
    studyId?: string;
}

export interface QueryOfSite {
    value?: Site[] | undefined;
    "@odata.count"?: number;
}

export interface SiteCreation {
    id?: string;
    studyId?: string;
    number?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contact?: string | undefined;
    fax?: string | undefined;
    country?: string | undefined;
    timeZone?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSite extends SingleResult {
    queryable?: Site[] | undefined;
}

export interface QueryOfSixMinuteWalkRestPeriod {
    value?: SixMinuteWalkRestPeriod[] | undefined;
    "@odata.count"?: number;
}

export interface SixMinuteWalkRestPeriodMutation {
    dateTime?: string;
    comments?: string | undefined;
    durationInSeconds?: number | undefined;
}

export interface SixMinuteWalkRestPeriod extends SixMinuteWalkRestPeriodMutation {
    id?: string;
    testId?: string;
}

export interface SixMinuteWalkRestPeriodCreation extends SixMinuteWalkRestPeriod {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSixMinuteWalkRestPeriod extends SingleResult {
    queryable?: SixMinuteWalkRestPeriod[] | undefined;
}

export interface QueryOfSixMinuteWalkSession {
    value?: SixMinuteWalkSession[] | undefined;
    "@odata.count"?: number;
}

export interface SixMinuteWalkSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
}

export interface SixMinuteWalkSession extends SixMinuteWalkSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    tests?: SixMinuteWalkTest[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface SixMinuteWalkTestMutation {
    index?: number;
    testTypeId?: string | undefined;
    startTestDateTime?: string;
    endTestDateTime?: string;
    distanceWalked?: number;
    predictedDistance?: number | undefined;
    lapLength?: number;
    numberOfLaps?: number;
    bodeIndex?: number | undefined;
    dyspnoeaMmrcId?: string | undefined;
    nadirSpO2?: number;
    fvc?: number | undefined;
    relatedFvcSessionDateTime?: string | undefined;
    fev1?: number | undefined;
    fev1PercentPredicted?: number | undefined;
    systolic?: number | undefined;
    diastolic?: number | undefined;
    baselineObservation?: SixMinuteWalkObservation | undefined;
    finalObservation?: SixMinuteWalkObservation | undefined;
    distanceMde?: boolean | undefined;
    spirometryMde?: boolean | undefined;
    sensorTypeId?: string | undefined;
}

export interface SixMinuteWalkTest extends SixMinuteWalkTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
    restPeriods?: SixMinuteWalkRestPeriod[] | undefined;
    medicationRecords?: MedicationRecord[] | undefined;
}

export interface SixMinuteWalkObservation {
    observationDateTime?: string;
    dyspnoea?: number;
    fatigue?: number;
    hr?: number;
    spO2Percentage?: number;
    bloodPressureSystolic?: number | undefined;
    bloodPressureDiastolic?: number | undefined;
    bloodPressureMde?: boolean | undefined;
    spO2Mde?: boolean | undefined;
}

export interface SixMinuteWalkSessionCreation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    postureType?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    preSessionId?: string | undefined;
    tests?: SixMinuteWalkTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface SixMinuteWalkTestCreation extends SixMinuteWalkTestMutation {
    id?: string;
    sessionId?: string;
    restPeriods?: SixMinuteWalkRestPeriod[] | undefined;
    medicationRecords?: MedicationRecord[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSixMinuteWalkSession extends SingleResult {
    queryable?: SixMinuteWalkSession[] | undefined;
}

export interface QueryOfSixMinuteWalkTest {
    value?: SixMinuteWalkTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSixMinuteWalkTest extends SingleResult {
    queryable?: SixMinuteWalkTest[] | undefined;
}

export interface QueryOfSnipAnalysisSet {
    value?: SnipAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface SnipAnalysisSetMutation extends PressureAnalysisSetMutation {
    bestSnip?: number | undefined;
}

export interface SnipAnalysisSet extends SnipAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    analyst?: string | undefined;
    analystId?: string | undefined;
    canEdit?: boolean;
    tests?: SnipAnalysisSetTest[] | undefined;
}

export interface SnipAnalysisSetTestMutation extends PressureAnalysisSetTestMutation {
    snipRepeatability?: number | undefined;
    snipRepeatabilityPercent?: number | undefined;
}

export interface SnipAnalysisSetTest extends SnipAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    test?: SnipTest | undefined;
    analysisSetId?: string;
}

export interface SnipTestMutation extends PressureTestMutation {
    snip?: number | undefined;
}

export interface SnipTest extends SnipTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface SnipAnalysisSetCreation extends SnipAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    analyst?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSnipAnalysisSet extends SingleResult {
    queryable?: SnipAnalysisSet[] | undefined;
}

export interface QueryOfSnipAnalysisSetTest {
    value?: SnipAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

export interface SnipAnalysisSetTestCreation extends SnipAnalysisSetTest {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSnipAnalysisSetTest extends SingleResult {
    queryable?: SnipAnalysisSetTest[] | undefined;
}

export interface QueryOfSnipSession {
    value?: SnipSession[] | undefined;
    "@odata.count"?: number;
}

export interface SnipSessionMutation extends PressureSessionMutation {
    predictedSnip?: number | undefined;
}

export interface SnipSession extends SnipSessionMutation {
    id?: string;
    analysisSetId?: string;
    visit?: Visit | undefined;
    sessionTypeId?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    modified?: string;
    received?: string | undefined;
    tests?: SnipTest[] | undefined;
    testsCount?: number;
    status?: string | undefined;
    overreader?: string | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: PressureAnalysisSet[] | undefined;
}

export interface SnipSessionCreation extends SnipSessionMutation {
    id?: string;
    tests?: SnipTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface SnipTestCreation extends SnipTestMutation {
    id?: string;
    sessionId?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSnipSession extends SingleResult {
    queryable?: SnipSession[] | undefined;
}

export interface QueryOfSnipTest {
    value?: SnipTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSnipTest extends SingleResult {
    queryable?: SnipTest[] | undefined;
}

export interface QueryOfFvcAnalysisSet {
    value?: FvcAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface FvcAnalysisSetCreation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    bestFev1?: number | undefined;
    bestFvc?: number | undefined;
    bestPefMin?: number | undefined;
    bestFef2575?: number | undefined;
    bestFev1Fvc?: number | undefined;
    bestFev6?: number | undefined;
    fev1Grade?: string | undefined;
    bestFef25?: number | undefined;
    bestFef50?: number | undefined;
    bestFef75?: number | undefined;
    fvcGrade?: string | undefined;
    bestFev1Q?: number | undefined;
    fev1Bdr?: number | undefined;
    fvcBdr?: number | undefined;
    fev1ReversibilityAbsoluteChange?: number | undefined;
    fev1ReversibilityPercentageChange?: number | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    percentBaselineFev1?: number | undefined;
    percentBaselineDropFev1?: number | undefined;
    bestEOTV?: number | undefined;
    bestErv?: number | undefined;
    bestEv?: number | undefined;
    bestEvFvc?: number | undefined;
    bestFef0212?: number | undefined;
    bestFef2575Fvc?: number | undefined;
    bestFef50Fif50?: number | undefined;
    bestFef7585?: number | undefined;
    bestFefMax?: number | undefined;
    bestFet?: number | undefined;
    bestFev05?: number | undefined;
    bestFev05Fvc?: number | undefined;
    bestFev075?: number | undefined;
    bestFev075Fvc?: number | undefined;
    bestFev1Fev6?: number | undefined;
    bestFev1Fivc?: number | undefined;
    bestFev1Ht2?: number | undefined;
    bestFev1Ivc?: number | undefined;
    bestFev1Pef?: number | undefined;
    bestFev1R?: number | undefined;
    bestFev1Vc?: number | undefined;
    bestFev3?: number | undefined;
    bestFev3Fvc?: number | undefined;
    bestFev3Vc?: number | undefined;
    bestFif25?: number | undefined;
    bestFif50?: number | undefined;
    bestFif50Fef50?: number | undefined;
    bestFif75?: number | undefined;
    bestFiv1?: number | undefined;
    bestFiv1Fivc?: number | undefined;
    bestFiv1Fvc?: number | undefined;
    bestFivc?: number | undefined;
    bestFivcFvc?: number | undefined;
    bestFmft?: number | undefined;
    bestFrc?: number | undefined;
    bestIc?: number | undefined;
    bestIrv?: number | undefined;
    bestIvc?: number | undefined;
    bestMvvind?: number | undefined;
    bestPefSec?: number | undefined;
    bestPifMin?: number | undefined;
    bestPifSec?: number | undefined;
    bestRawind?: number | undefined;
    bestRisetime?: number | undefined;
    bestRv?: number | undefined;
    bestText?: number | undefined;
    bestThes?: number | undefined;
    bestTlc?: number | undefined;
    bestTpef?: number | undefined;
    bestTv?: number | undefined;
    bestFev6Fvc?: number | undefined;
    bestIfr?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFvcAnalysisSet extends SingleResult {
    queryable?: FvcAnalysisSet[] | undefined;
}

export interface QueryOfFvcAnalysisSetTest {
    value?: FvcAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfFvcAnalysisSetTest extends SingleResult {
    queryable?: FvcAnalysisSetTest[] | undefined;
}

export interface QueryOfSpirotracUserGroup {
    value?: SpirotracUserGroup[] | undefined;
    "@odata.count"?: number;
}

export interface SpirotracUserGroup {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSpirotracUserGroup extends SingleResult {
    queryable?: SpirotracUserGroup[] | undefined;
}

export interface QueryOfStudy {
    value?: Study[] | undefined;
    "@odata.count"?: number;
}

/** A class the tracks changes (i.e. the Delta) for a particular . */
export interface DeltaOfStudy extends Delta {
    /** DeltaKind for the objects part of the DeltaResourceSet Payload. */
    Kind?: DeltaItemKind;
    /** Gets the actual type of the structural object for which the changes are tracked. */
    StructuredType?: string | undefined;
    /** Gets the expected type of the entity for which the changes are tracked. */
    ExpectedClrType?: string | undefined;
    /** The list of property names that can be updated. */
    UpdatableProperties?: string[] | undefined;
    /** If the StructuralType is a Complex type. */
    IsComplexType?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudy extends SingleResult {
    queryable?: Study[] | undefined;
}

export interface QueryOfStudyCoughEventType {
    value?: StudyCoughEventType[] | undefined;
    "@odata.count"?: number;
}

export interface StudyCoughEventType {
    id?: string;
    studyId?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number;
    period?: boolean;
    colour?: string | undefined;
    hidden?: boolean;
    counted?: boolean;
    deviceButton?: number | undefined;
    refEventTypeId?: string | undefined;
}

/** A class the tracks changes (i.e. the Delta) for a particular . */
export interface DeltaOfStudyCoughEventType extends Delta {
    /** DeltaKind for the objects part of the DeltaResourceSet Payload. */
    Kind?: DeltaItemKind;
    /** Gets the actual type of the structural object for which the changes are tracked. */
    StructuredType?: string | undefined;
    /** Gets the expected type of the entity for which the changes are tracked. */
    ExpectedClrType?: string | undefined;
    /** The list of property names that can be updated. */
    UpdatableProperties?: string[] | undefined;
    /** If the StructuralType is a Complex type. */
    IsComplexType?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyCoughEventType extends SingleResult {
    queryable?: StudyCoughEventType[] | undefined;
}

export interface QueryOfStudyCountry {
    value?: StudyCountry[] | undefined;
    "@odata.count"?: number;
}

export interface StudyCountry {
    id?: string;
    countryCode?: string | undefined;
    name?: string | undefined;
    tollFreeNumber?: string | undefined;
    localPostalAddress?: string | undefined;
    studyId?: string;
}

/** A class the tracks changes (i.e. the Delta) for a particular . */
export interface DeltaOfStudyCountry extends Delta {
    /** DeltaKind for the objects part of the DeltaResourceSet Payload. */
    Kind?: DeltaItemKind;
    /** Gets the actual type of the structural object for which the changes are tracked. */
    StructuredType?: string | undefined;
    /** Gets the expected type of the entity for which the changes are tracked. */
    ExpectedClrType?: string | undefined;
    /** The list of property names that can be updated. */
    UpdatableProperties?: string[] | undefined;
    /** If the StructuralType is a Complex type. */
    IsComplexType?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyCountry extends SingleResult {
    queryable?: StudyCountry[] | undefined;
}

export interface QueryOfStudyFixedCommentSet {
    value?: StudyFixedCommentSet[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyFixedCommentSet extends SingleResult {
    queryable?: StudyFixedCommentSet[] | undefined;
}

export interface QueryOfStudyLanguage {
    value?: StudyLanguage[] | undefined;
    "@odata.count"?: number;
}

export interface StudyLanguage {
    studyId?: string;
    id?: string | undefined;
    name?: string | undefined;
    localeName?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyLanguage extends SingleResult {
    queryable?: StudyLanguage[] | undefined;
}

export interface QueryOfStudyPhase {
    value?: StudyPhase[] | undefined;
    "@odata.count"?: number;
}

export interface StudyPhase {
    id?: string;
    phaseId?: string | undefined;
    name?: string | undefined;
    studyId?: string;
    displayOrder?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyPhase extends SingleResult {
    queryable?: StudyPhase[] | undefined;
}

export interface QueryOfStudySchedule {
    value?: StudySchedule[] | undefined;
    "@odata.count"?: number;
}

export interface StudyScheduleCreation {
    id?: string;
    studyId?: string;
    studyScheduleVisits?: StudyScheduleVisitCreation[] | undefined;
}

export interface StudyScheduleVisitCreation {
    id?: string;
    studyScheduleId?: string;
    phaseId?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    ordinal?: number;
    disabled?: boolean;
    mandatory?: boolean;
    obligation?: string | undefined;
    spanDays?: boolean;
    commentRequired?: boolean;
    confirmationRequired?: boolean;
    cohort?: string | undefined;
    studyScheduleSessions?: StudyScheduleSessionCreation[] | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudySchedule extends SingleResult {
    queryable?: StudySchedule[] | undefined;
}

export interface QueryOfStudyScheduleSessionAction {
    value?: StudyScheduleSessionAction[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyScheduleSessionAction extends SingleResult {
    queryable?: StudyScheduleSessionAction[] | undefined;
}

export interface QueryOfStudyScheduleSession {
    value?: StudyScheduleSession[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyScheduleSession extends SingleResult {
    queryable?: StudyScheduleSession[] | undefined;
}

export interface QueryOfStudyScheduleVisit {
    value?: StudyScheduleVisit[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudyScheduleVisit extends SingleResult {
    queryable?: StudyScheduleVisit[] | undefined;
}

export interface QueryOfStudySessionType {
    value?: StudySessionType[] | undefined;
    "@odata.count"?: number;
}

export interface StudySessionType {
    id?: string | undefined;
    name?: string | undefined;
    studyId?: string;
    sessionTypeId?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfStudySessionType extends SingleResult {
    queryable?: StudySessionType[] | undefined;
}

export interface QueryOfSubjectNote {
    value?: SubjectNote[] | undefined;
    "@odata.count"?: number;
}

export interface SubjectNoteMutation {
    subjectId?: string;
    userEmailAddress?: string | undefined;
    comment?: string | undefined;
    recorded?: string;
}

export interface SubjectNote extends SubjectNoteMutation {
    id?: string;
}

export interface SubjectNoteCreation {
    id?: string;
    subjectId?: string;
    userEmailAddress?: string | undefined;
    comment?: string | undefined;
    recorded?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSubjectNote extends SingleResult {
    queryable?: SubjectNote[] | undefined;
}

export interface QueryOfSubject {
    value?: Subject[] | undefined;
    "@odata.count"?: number;
}

export interface SubjectCreation {
    id?: string;
    siteId?: string;
    populationGroupId?: string | undefined;
    status?: string | undefined;
    number?: string | undefined;
    alternativeNumber?: string | undefined;
    race?: string | undefined;
    language?: string | undefined;
    gender?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    ulna?: number | undefined;
    medicationType?: string | undefined;
    smokerType?: string | undefined;
    randomizationNumber?: string | undefined;
    randomized?: string | undefined;
    pin?: string | undefined;
    createdWithSpirotracV?: boolean;
    bedTime?: string | undefined;
    alarms?: SubjectAlarm[] | undefined;
    studyPart?: string | undefined;
    baselinePef?: number | undefined;
    baselineFev1?: number | undefined;
    baseline1?: number | undefined;
    baseline2?: number | undefined;
    baseline3?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSubject extends SingleResult {
    queryable?: Subject[] | undefined;
}

export interface QueryOfSubjectType {
    value?: SubjectType[] | undefined;
    "@odata.count"?: number;
}

export interface SubjectType {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSubjectType extends SingleResult {
    queryable?: SubjectType[] | undefined;
}

export interface QueryOfSurveyAnswer {
    value?: SurveyAnswer[] | undefined;
    "@odata.count"?: number;
}

export interface SurveyAnswerCreation {
    id?: string;
    sessionId?: string;
    questionId?: string;
    questionNumber?: string | undefined;
    questionText?: string | undefined;
    index?: number;
    valueType?: string | undefined;
    value?: any | undefined;
    answerWeight?: number | undefined;
    valueText?: string | undefined;
    exitedEarly?: boolean | undefined;
    leftBlank?: boolean | undefined;
}

export interface SurveyAnswer extends SurveyAnswerCreation {
    session?: SurveySession | undefined;
}

export interface SurveySessionMutation {
    id?: string;
    visitId?: string | undefined;
    seriesId?: string | undefined;
    label?: string | undefined;
    subjectId?: string;
    completedBySubject?: boolean;
    completedByUserId?: string | undefined;
    deviceTypeId?: string | undefined;
    serialNumber?: string | undefined;
    softwareVersion?: string | undefined;
    surveyId?: string | undefined;
    status?: string | undefined;
    startDateTime?: string;
    endDateTime?: string | undefined;
    answers?: SurveyAnswer[] | undefined;
    notes?: SessionNote[] | undefined;
    scores?: SurveyScore[] | undefined;
}

export interface SurveySessionCreation extends SurveySessionMutation {
}

export interface SurveySession extends SurveySessionCreation {
    visit?: Visit | undefined;
}

export interface SurveyScore {
    name?: string | undefined;
    value?: string | undefined;
}

export interface SurveyAnswerMutation extends SurveyAnswerCreation {
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSurveyAnswer extends SingleResult {
    queryable?: SurveyAnswer[] | undefined;
}

export interface QueryOfSurveySession {
    value?: SurveySession[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSurveySession extends SingleResult {
    queryable?: SurveySession[] | undefined;
}

export interface QueryOfSvcAnalysisSet {
    value?: SvcAnalysisSet[] | undefined;
    "@odata.count"?: number;
}

export interface SvcAnalysisSetMutation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    analystUserName?: string | undefined;
    status?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestVc?: number | undefined;
    bestIvc?: number | undefined;
    bestEvc?: number | undefined;
    bestTv?: number | undefined;
    bestIc?: number | undefined;
    bestErv?: number | undefined;
    bestTlc?: number | undefined;
    bestRv?: number | undefined;
    bestFrc?: number | undefined;
}

export interface SvcAnalysisSet extends SvcAnalysisSetMutation {
    started?: string | undefined;
    created?: string;
    modified?: string;
    session?: Session | undefined;
    tests?: SvcAnalysisSetTest[] | undefined;
    analystUserId?: string;
    canEdit?: boolean;
}

export interface SvcAnalysisSetTestMutation {
    id?: string;
    testId?: string;
    analysisSetId?: string;
    accepted?: boolean;
    repeatabilityVcAbsolute?: number | undefined;
    repeatabilityVcPercentage?: number | undefined;
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface SvcAnalysisSetTest extends SvcAnalysisSetTestMutation {
}

export interface SvcAnalysisSetCreation {
    id?: string;
    sessionId?: string;
    type?: string | undefined;
    status?: string | undefined;
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    bestVc?: number | undefined;
    bestIvc?: number | undefined;
    bestEvc?: number | undefined;
    bestTv?: number | undefined;
    bestIc?: number | undefined;
    bestErv?: number | undefined;
    bestTlc?: number | undefined;
    bestRv?: number | undefined;
    bestFrc?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSvcAnalysisSet extends SingleResult {
    queryable?: SvcAnalysisSet[] | undefined;
}

export interface QueryOfSvcAnalysisSetTest {
    value?: SvcAnalysisSetTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSvcAnalysisSetTest extends SingleResult {
    queryable?: SvcAnalysisSetTest[] | undefined;
}

export interface QueryOfSvcAnalysisSetType {
    value?: SvcAnalysisSetType[] | undefined;
    "@odata.count"?: number;
}

export interface SvcAnalysisSetType {
    id?: number;
    name?: string | undefined;
    externalCode?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSvcAnalysisSetType extends SingleResult {
    queryable?: SvcAnalysisSetType[] | undefined;
}

export interface QueryOfSvcSession {
    value?: SvcSession[] | undefined;
    "@odata.count"?: number;
}

export interface SvcSessionMutation {
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    lastCalibrationId?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    doseAmount?: number | undefined;
    doseTime?: string | undefined;
    preSessionId?: string | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
    predictedVc?: number | undefined;
    predictedIvc?: number | undefined;
    predictedEvc?: number | undefined;
    predictedTv?: number | undefined;
    predictedIc?: number | undefined;
    predictedErv?: number | undefined;
    predictedTlc?: number | undefined;
    predictedRv?: number | undefined;
    predictedFrc?: number | undefined;
}

export interface SvcSession extends SvcSessionMutation {
    id?: string;
    visit?: Visit | undefined;
    sessionType?: string | undefined;
    deviceType?: string | undefined;
    created?: string;
    lastReceivedTime?: string | undefined;
    modified?: string;
    analystUserName?: string | undefined;
    analystUserId?: string;
    testsCount?: number;
    tests?: SvcTest[] | undefined;
    notes?: SessionNote[] | undefined;
    analysisSets?: SvcAnalysisSet[] | undefined;
    status?: string | undefined;
}

export interface SvcTestMutation {
    id?: string;
    index?: number;
    occurred?: string;
    qualityIndicators?: number;
    sampleRate?: number;
    volumeDataLength?: number;
    flowPlateauQuality?: string | undefined;
    volumeData?: string | undefined;
    flowData?: string | undefined;
    duration?: number;
    vc?: number | undefined;
    ivc?: number | undefined;
    evc?: number | undefined;
    tv?: number | undefined;
    ic?: number | undefined;
    erv?: number | undefined;
    tlc?: number | undefined;
    rv?: number | undefined;
    frc?: number | undefined;
}

export interface SvcTest extends SvcTestMutation {
    id?: string;
    sessionId?: string;
    created?: string;
    modified?: string;
}

export interface SvcSessionCreation {
    id?: string;
    visitId?: string;
    name?: string | undefined;
    occurred?: string;
    technician?: string | undefined;
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    medicationType?: string | undefined;
    lastCalibrationId?: string | undefined;
    gender?: string | undefined;
    age?: number | undefined;
    dateOfBirth?: string | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    bmi?: number | undefined;
    smokerType?: string | undefined;
    populationGroupId?: string | undefined;
    race?: string | undefined;
    ulna?: number | undefined;
    doseAmount?: number | undefined;
    doseTime?: string | undefined;
    preSessionId?: string | undefined;
    overreadChallengeStatus?: string | undefined;
    challengeIsClosed?: boolean;
    predictedVc?: number | undefined;
    predictedIvc?: number | undefined;
    predictedEvc?: number | undefined;
    predictedTv?: number | undefined;
    predictedIc?: number | undefined;
    predictedErv?: number | undefined;
    predictedTlc?: number | undefined;
    predictedRv?: number | undefined;
    predictedFrc?: number | undefined;
    tests?: SvcTestCreation[] | undefined;
    notes?: SessionNote[] | undefined;
}

export interface SvcTestCreation {
    id?: string;
    sessionId?: string;
    index?: number;
    occurred?: string;
    duration?: number;
    qualityIndicators?: number;
    sampleRate?: number;
    volumeDataLength?: number;
    flowPlateauQuality?: string | undefined;
    volumeData?: string | undefined;
    flowData?: string | undefined;
    vc?: number | undefined;
    ivc?: number | undefined;
    evc?: number | undefined;
    tv?: number | undefined;
    ic?: number | undefined;
    erv?: number | undefined;
    tlc?: number | undefined;
    rv?: number | undefined;
    frc?: number | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSvcSession extends SingleResult {
    queryable?: SvcSession[] | undefined;
}

export interface QueryOfSvcTest {
    value?: SvcTest[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfSvcTest extends SingleResult {
    queryable?: SvcTest[] | undefined;
}

export interface QueryOfTestNote {
    value?: TestNote[] | undefined;
    "@odata.count"?: number;
}

export interface TestNoteMutation {
    testId?: string;
    userEmailAddress?: string | undefined;
    comment?: string | undefined;
    recorded?: string;
}

export interface TestNote extends TestNoteMutation {
    id?: string;
}

export interface TestNoteCreation {
    id?: string;
    testId?: string;
    userEmailAddress?: string | undefined;
    comment?: string | undefined;
    recorded?: string;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfTestNote extends SingleResult {
    queryable?: TestNote[] | undefined;
}

export interface QueryOfTimeZone {
    value?: TimeZone[] | undefined;
    "@odata.count"?: number;
}

export interface TimeZone {
    id?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    legacyId?: number;
    offsetInMinutes?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfTimeZone extends SingleResult {
    queryable?: TimeZone[] | undefined;
}

export interface QueryOfUnitType {
    value?: UnitType[] | undefined;
    "@odata.count"?: number;
}

export interface UnitType {
    id?: string | undefined;
    name?: string | undefined;
    dataItemTypeId?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfUnitType extends SingleResult {
    queryable?: UnitType[] | undefined;
}

export interface QueryOfUser {
    value?: User[] | undefined;
    "@odata.count"?: number;
}

export interface UserCreation extends UserMutation {
    id?: string;
    hasRequest?: boolean;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfUser extends SingleResult {
    queryable?: User[] | undefined;
}

export interface QueryOfVisitObligation {
    value?: VisitObligation[] | undefined;
    "@odata.count"?: number;
}

export interface VisitObligation {
    id?: string | undefined;
    name?: string | undefined;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfVisitObligation extends SingleResult {
    queryable?: VisitObligation[] | undefined;
}

export interface QueryOfVisit {
    value?: Visit[] | undefined;
    "@odata.count"?: number;
}

/** Represents an IQueryable`1 containing zero or one entities. Use together with an [EnableQuery]. */
export interface SingleResultOfVisit extends SingleResult {
    queryable?: Visit[] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}